import gql from "graphql-tag"
import * as Urql from "urql"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: string
	String: string
	Boolean: boolean
	Int: number
	Float: number
	DateTime: any
	JSON: any
}

export type Address = {
	__typename?: "Address"
	city: Scalars["String"]
	country: Scalars["String"]
	postalCode: Scalars["String"]
	state: Scalars["String"]
	street: Scalars["String"]
}

export type AddressInput = {
	city: Scalars["String"]
	country: Scalars["String"]
	postalCode: Scalars["String"]
	state: Scalars["String"]
	street: Scalars["String"]
}

export type Area = {
	__typename?: "Area"
	_id: Scalars["String"]
	coordinatesOnUnitLayout?: Maybe<Array<Scalars["Float"]>>
	createdAt: Scalars["DateTime"]
	elements: Array<Elements>
	label: Label
	type: AreaTypes
	updatedAt: Scalars["DateTime"]
}

export type AreaDimensions = {
	__typename?: "AreaDimensions"
	_id: Scalars["String"]
	additionalArea?: Maybe<Dimension>
	area: Dimension
	areaId: Scalars["String"]
	builderRemarks?: Maybe<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	height: Dimension
	internalRemarks?: Maybe<Scalars["String"]>
	isBuilderApproved?: Maybe<Scalars["Boolean"]>
	isInternalApproved?: Maybe<Scalars["Boolean"]>
	isReInspected?: Maybe<Scalars["Boolean"]>
	length: Dimension
	rects: Array<RectDimensions>
	updatedAt: Scalars["DateTime"]
	width: Dimension
}

export type AreaDimensionsInput = {
	additionalArea?: InputMaybe<DimensionInput>
	area: DimensionInput
	height: DimensionInput
	rects: Array<RectDimensionsInput>
}

export type AreaInput = {
	label: LabelInput
	type: AreaTypes
}

export enum AreaTypes {
	Balcony = "Balcony",
	Basement = "Basement",
	Bedroom = "Bedroom",
	CommonBasement = "CommonBasement",
	CommonElevator = "CommonElevator",
	CommonLobbies = "CommonLobbies",
	CommonParking = "CommonParking",
	CommonStaircase = "CommonStaircase",
	CommonTerrace = "CommonTerrace",
	Dining = "Dining",
	Kitchen = "Kitchen",
	Living = "Living",
	Terrace = "Terrace",
	Toilet = "Toilet",
}

export type AreaWiseRectificationProgressItem = {
	__typename?: "AreaWiseRectificationProgressItem"
	areaId: Scalars["String"]
	done: Scalars["Float"]
	expected: Scalars["Float"]
	progressPercent: Scalars["Float"]
}

export type AssignmentLifecycle = {
	__typename?: "AssignmentLifecycle"
	_id: Scalars["ID"]
	createdAt: Scalars["DateTime"]
}

export type Block = {
	__typename?: "Block"
	_id: Scalars["String"]
	builder: Builder
	builderId: Scalars["String"]
	cluster: Cluster
	clusterId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	elementWiseContractors?: Maybe<Array<ElementWiseContractors>>
	isDeleted?: Maybe<Scalars["Boolean"]>
	label: Label
	project: Project
	projectId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type BlockInput = {
	label: LabelInput
}

export type BlockLayout = {
	__typename?: "BlockLayout"
	_id: Scalars["ID"]
	blockId: Scalars["ID"]
	builderId: Scalars["ID"]
	clusterId: Scalars["ID"]
	columns: Scalars["Int"]
	createdAt: Scalars["DateTime"]
	matrixUnitIds?: Maybe<Scalars["JSON"]>
	projectId: Scalars["ID"]
	rows: Scalars["Int"]
	updatedAt: Scalars["DateTime"]
}

export type BlockLayoutWithFieldErrorsResponse = {
	__typename?: "BlockLayoutWithFieldErrorsResponse"
	blockLayout?: Maybe<BlockLayout>
	errors?: Maybe<Array<FieldError>>
}

export type BlockWithFieldErrorsResponse = {
	__typename?: "BlockWithFieldErrorsResponse"
	block?: Maybe<Block>
	errors?: Maybe<Array<FieldError>>
}

export type BrandCheck = {
	__typename?: "BrandCheck"
	_id: Scalars["String"]
	areaId?: Maybe<Scalars["String"]>
	brandItem: BrandItem
	brandItemId: Scalars["String"]
	builderRemarks?: Maybe<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	internalRemarks?: Maybe<Scalars["String"]>
	isBuilderApproved?: Maybe<Scalars["Boolean"]>
	isInternalApproved?: Maybe<Scalars["Boolean"]>
	isOk?: Maybe<Scalars["Boolean"]>
	isReInspected?: Maybe<Scalars["Boolean"]>
	remarks?: Maybe<Scalars["String"]>
	updatedAt: Scalars["DateTime"]
}

export type BrandCheckInput = {
	isOk: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type BrandItem = {
	__typename?: "BrandItem"
	_id: Scalars["String"]
	areaId?: Maybe<Scalars["String"]>
	blockId: Scalars["String"]
	builderId: Scalars["String"]
	clusterId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	isDeleted?: Maybe<Scalars["Boolean"]>
	label: Label
	projectId: Scalars["String"]
	unitId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type BrandItemInput = {
	label: LabelInput
}

export type Builder = {
	__typename?: "Builder"
	_id: Scalars["String"]
	createdAt: Scalars["DateTime"]
	isDeleted?: Maybe<Scalars["Boolean"]>
	label: Label
	linkedContractorIds?: Maybe<Array<Scalars["String"]>>
	picture?: Maybe<Picture>
	updatedAt: Scalars["DateTime"]
}

export type BuilderInput = {
	label: LabelInput
}

export type BuilderWithFieldErrorsResponse = {
	__typename?: "BuilderWithFieldErrorsResponse"
	builder?: Maybe<Builder>
	errors?: Maybe<Array<FieldError>>
}

export type Cluster = {
	__typename?: "Cluster"
	_id: Scalars["String"]
	builder: Builder
	builderId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	elementWiseContractors?: Maybe<Array<ElementWiseContractors>>
	isDeleted?: Maybe<Scalars["Boolean"]>
	label: Label
	project: Project
	projectId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type ClusterInput = {
	label: LabelInput
}

export type ClusterWithFieldErrorsResponse = {
	__typename?: "ClusterWithFieldErrorsResponse"
	cluster?: Maybe<Cluster>
	errors?: Maybe<Array<FieldError>>
}

export type Coordinates = {
	__typename?: "Coordinates"
	x: Scalars["Float"]
	y: Scalars["Float"]
}

export type CoordinatesInput = {
	x: Scalars["Float"]
	y: Scalars["Float"]
}

export type Dimension = {
	__typename?: "Dimension"
	builderRemarks?: Maybe<Scalars["String"]>
	internalRemarks?: Maybe<Scalars["String"]>
	isBuilderApproved?: Maybe<Scalars["Boolean"]>
	isInternalApproved?: Maybe<Scalars["Boolean"]>
	isReInspected?: Maybe<Scalars["Boolean"]>
	unit: DimensionUnits
	value: Scalars["Float"]
}

export type DimensionInput = {
	unit: DimensionUnits
	value: Scalars["Float"]
}

export enum DimensionUnits {
	Feet = "Feet",
	SqFeet = "SqFeet",
}

export type ElementAndSeverityWiseIssues = {
	__typename?: "ElementAndSeverityWiseIssues"
	_id: Scalars["String"]
	cosmeticIssueIds: Array<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	element: Scalars["String"]
	majorIssueIds: Array<Scalars["String"]>
	minorIssueIds: Array<Scalars["String"]>
	updatedAt: Scalars["DateTime"]
}

export type ElementAndSeverityWiseIssuesStats = {
	__typename?: "ElementAndSeverityWiseIssuesStats"
	_id: Scalars["String"]
	builderId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	elements: Array<ElementAndSeverityWiseIssues>
	unitId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type ElementWiseContractorInput = {
	contractorId: Scalars["String"]
	element: Elements
}

export type ElementWiseContractors = {
	__typename?: "ElementWiseContractors"
	contractorId: Scalars["String"]
	element: Elements
}

export type ElementWiseInspectionProgressItem = {
	__typename?: "ElementWiseInspectionProgressItem"
	done: Scalars["Float"]
	element: Elements
	expected: Scalars["Float"]
	progressPercent: Scalars["Float"]
}

export type ElementWiseRectification = {
	__typename?: "ElementWiseRectification"
	contractor: User
	contractorId: Scalars["String"]
	element: Elements
	issues: Array<RectificationIssue>
	progress: ElementWiseRectificationProgress
	status: RectificationStatus
	statusLifecycle: Array<StatusLifecycle>
}

export type ElementWiseRectificationProgress = {
	__typename?: "ElementWiseRectificationProgress"
	areaWiseProgress: Array<AreaWiseRectificationProgressItem>
	done: Scalars["Float"]
	expected: Scalars["Float"]
	progressPercent: Scalars["Float"]
}

export enum Elements {
	Accessories = "Accessories",
	Appliances = "Appliances",
	Architrave = "Architrave",
	Brands = "Brands",
	Cabinets = "Cabinets",
	Ceiling = "Ceiling",
	Dimensions = "Dimensions",
	Doors = "Doors",
	Drainage = "Drainage",
	Electrical = "Electrical",
	Firefighting = "Firefighting",
	Flooring = "Flooring",
	Glass = "Glass",
	HVAC = "HVAC",
	Issues = "Issues",
	LiftCar = "LiftCar",
	Lighting = "Lighting",
	Markings = "Markings",
	Materials = "Materials",
	Painting = "Painting",
	Plumbing = "Plumbing",
	Railing = "Railing",
	Sanitary = "Sanitary",
	Sink = "Sink",
	Unknown = "Unknown",
	Wall = "Wall",
	Water = "Water",
	WaterProofing = "WaterProofing",
	Windows = "Windows",
	WorkInProgressItems = "WorkInProgressItems",
}

export type Email = {
	__typename?: "Email"
	address: Scalars["String"]
	createdAt: Scalars["DateTime"]
	isVerified: Scalars["Boolean"]
	updatedAt: Scalars["DateTime"]
	verifiedAt?: Maybe<Scalars["DateTime"]>
}

export type EmailInput = {
	address: Scalars["String"]
}

export type FieldError = {
	__typename?: "FieldError"
	error: Scalars["String"]
	field: Scalars["String"]
}

export type FinishUploadInput = {
	key: Scalars["String"]
}

export type GroupedUnits = {
	__typename?: "GroupedUnits"
	_id: Scalars["String"]
	block: Block
	blockId: Scalars["String"]
	cluster: Cluster
	clusterId: Scalars["String"]
	unitCategory: UnitCategory
	unitCategoryId: Scalars["String"]
	unitIds: Array<Scalars["String"]>
	units: Array<Unit>
}

export type GroupedUnitsInput = {
	blockId: Scalars["String"]
	clusterId: Scalars["String"]
	prefix?: InputMaybe<Scalars["String"]>
	sequenceBeginning?: InputMaybe<Scalars["Int"]>
	suffix?: InputMaybe<Scalars["String"]>
	unitCategoryId: Scalars["String"]
	unitsCount: Scalars["Int"]
}

export type Inspection = {
	__typename?: "Inspection"
	_id: Scalars["String"]
	block: Block
	blockId: Scalars["String"]
	brandChecks: Array<BrandCheck>
	builder: Builder
	builderId: Scalars["String"]
	builderReviewer: User
	builderReviewerId: Scalars["String"]
	builderReviewerLifeCycle: Array<AssignmentLifecycle>
	cluster: Cluster
	clusterId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	dimensions: Array<AreaDimensions>
	inspector: User
	inspectorId: Scalars["String"]
	inspectorLifeCycle: Array<AssignmentLifecycle>
	internalReviewer: User
	internalReviewerId: Scalars["String"]
	internalReviewerLifeCycle: Array<AssignmentLifecycle>
	isDeleted?: Maybe<Scalars["Boolean"]>
	issues?: Maybe<Array<Issue>>
	materialChecks: Array<MaterialCheck>
	postSnaggingInspectionId?: Maybe<Scalars["String"]>
	postSnaggingInspectionRequest?: Maybe<PostSnaggingInspectionRequest>
	postSnaggingInspectionStatus?: Maybe<InspectionStatus>
	preSnaggingInspectionId?: Maybe<Scalars["String"]>
	progress: InspectionProgress
	project: Project
	projectId: Scalars["String"]
	rectificationId?: Maybe<Scalars["String"]>
	rectificationStatus?: Maybe<RectificationStatus>
	reviewedBrandChecks?: Maybe<Array<ReviewedBrandCheck>>
	reviewedDimensions?: Maybe<Array<ReviewedAreaDimensions>>
	reviewedIssues?: Maybe<Array<ReviewedIssue>>
	reviewedMaterialChecks?: Maybe<Array<ReviewedMaterialCheck>>
	reviewedUnitArea?: Maybe<ReviewedDimension>
	reviewedWaterQuality?: Maybe<ReviewedWaterQuality>
	reviewedWorkInProgressItems?: Maybe<Array<ReviewedWorkInProgressItem>>
	status: InspectionStatus
	statusLifecycle: Array<StatusLifecycle>
	type: InspectionTypes
	unit: Unit
	unitArea: Dimension
	unitId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
	waterQuality: WaterQuality
	workInProgressItems?: Maybe<Array<WorkInProgressItem>>
}

export type InspectionProgress = {
	__typename?: "InspectionProgress"
	items: Array<InspectionProgressItem>
	progressPercent: Scalars["Float"]
}

export type InspectionProgressItem = {
	__typename?: "InspectionProgressItem"
	areaId?: Maybe<Scalars["String"]>
	elementWiseItems: Array<ElementWiseInspectionProgressItem>
	progressPercent: Scalars["Float"]
}

export enum InspectionStatus {
	Completed = "Completed",
	Ongoing = "Ongoing",
	Pending = "Pending",
	ReInspectionOngoing = "ReInspectionOngoing",
	ReInspectionPending = "ReInspectionPending",
	Rejected = "Rejected",
	UnderInternalReview = "UnderInternalReview",
	UnderReview = "UnderReview",
}

export enum InspectionTypes {
	PostSnagging = "PostSnagging",
	PreSnagging = "PreSnagging",
}

export type Issue = {
	__typename?: "Issue"
	_id: Scalars["String"]
	additionalPicture?: Maybe<Picture>
	areaId: Scalars["String"]
	builderRemarks?: Maybe<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	element: Elements
	internalRemarks?: Maybe<Scalars["String"]>
	isBuilderApproved?: Maybe<Scalars["Boolean"]>
	isCopiedFromPreSnagging?: Maybe<Scalars["Boolean"]>
	isCritical?: Maybe<Scalars["Boolean"]>
	isInternalApproved?: Maybe<Scalars["Boolean"]>
	isReInspected?: Maybe<Scalars["Boolean"]>
	label: Label
	offlineHash?: Maybe<Scalars["String"]>
	picture: Picture
	postSnaggingPicture?: Maybe<Picture>
	postSnaggingStatus?: Maybe<IssuePostSnaggingStatus>
	severity: IssueSeverity
	templateId?: Maybe<Scalars["String"]>
	updatedAt: Scalars["DateTime"]
}

export type IssueInput = {
	isCritical?: InputMaybe<Scalars["Boolean"]>
	label?: InputMaybe<LabelInput>
	offlineHash?: InputMaybe<Scalars["String"]>
	pictureKey: Scalars["String"]
	severity?: InputMaybe<IssueSeverity>
	templateId?: InputMaybe<Scalars["String"]>
}

export type IssueItem = {
	__typename?: "IssueItem"
	_id: Scalars["String"]
	createdAt: Scalars["DateTime"]
	issue: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export enum IssuePostSnaggingStatus {
	NotRectified = "NotRectified",
	Rectified = "Rectified",
}

export enum IssueSeverity {
	Cosmetic = "Cosmetic",
	Major = "Major",
	Minor = "Minor",
}

export type IssueTemplate = {
	__typename?: "IssueTemplate"
	_id: Scalars["String"]
	areaType?: Maybe<AreaTypes>
	element: Elements
	issue: Label
	label: Label
	severity: IssueSeverity
}

export type Label = {
	__typename?: "Label"
	description?: Maybe<Scalars["String"]>
	name: Scalars["String"]
}

export type LabelInput = {
	description?: InputMaybe<Scalars["String"]>
	name: Scalars["String"]
}

export type LayoutAreaCoordinates = {
	__typename?: "LayoutAreaCoordinates"
	_id: Scalars["String"]
	areaId: Scalars["String"]
	coordinates: Coordinates
}

export type MaterialCheck = {
	__typename?: "MaterialCheck"
	_id: Scalars["String"]
	areaId?: Maybe<Scalars["String"]>
	builderRemarks?: Maybe<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	internalRemarks?: Maybe<Scalars["String"]>
	isBuilderApproved?: Maybe<Scalars["Boolean"]>
	isInternalApproved?: Maybe<Scalars["Boolean"]>
	isOk?: Maybe<Scalars["Boolean"]>
	isReInspected?: Maybe<Scalars["Boolean"]>
	materialItem: MaterialItem
	materialItemId: Scalars["String"]
	remarks?: Maybe<Scalars["String"]>
	updatedAt: Scalars["DateTime"]
}

export type MaterialCheckInput = {
	isOk: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MaterialItem = {
	__typename?: "MaterialItem"
	_id: Scalars["String"]
	areaId?: Maybe<Scalars["String"]>
	blockId: Scalars["String"]
	builderId: Scalars["String"]
	clusterId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	isDeleted?: Maybe<Scalars["Boolean"]>
	label: Label
	projectId: Scalars["String"]
	unitId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type MaterialItemInput = {
	label: LabelInput
}

export type Mutation = {
	__typename?: "Mutation"
	addAdditionalIssuePicture: Inspection
	addAreaCoordinatesOnUnitCategoryLayout: UnitCategory
	addAreaCoordinatesOnUnitLayout: Unit
	addContractorToBuilder: Builder
	addFCMToken: Scalars["Boolean"]
	addIssue: Inspection
	addWaterQuality: Inspection
	addWorkInProgressItem: Inspection
	assignBrandItemToArea: BrandItem
	assignMaterialItemToArea: MaterialItem
	assignUnitCategoryBrandItemToArea: UnitCategoryBrandItem
	assignUnitCategoryMaterialItemToArea: UnitCategoryMaterialItem
	builderApproveAreaDimension: Inspection
	builderApproveBrandCheck: Inspection
	builderApproveIssue: Inspection
	builderApproveMaterialCheck: Inspection
	builderApproveUnitArea: Inspection
	builderApproveWaterQuality: Inspection
	builderApproveWorkInProgressItem: Inspection
	builderReviewIssueRectification: Rectification
	createAdmin: UserWithFieldErrorsResponse
	createArea: Area
	createBlock: BlockWithFieldErrorsResponse
	createBlockLayout: BlockLayoutWithFieldErrorsResponse
	createBrandItems: Array<BrandItem>
	createBuilder: BuilderWithFieldErrorsResponse
	createBuilderAdmin: UserWithFieldErrorsResponse
	createCluster: ClusterWithFieldErrorsResponse
	createContractor: UserWithFieldErrorsResponse
	createElement: Area
	createInspection: Inspection
	createInspector: UserWithFieldErrorsResponse
	createMaterialItems: Array<MaterialItem>
	createOfflineInspectionTask: OfflineInspectionTask
	createPostSnaggingInspectionRequest: Inspection
	createProject: ProjectWithFieldErrorsResponse
	createProjectHead: User
	createQualityHead: User
	createRectification: Rectification
	createService: Service
	createUnit: UnitWithFieldErrorsResponse
	createUnitCategory: UnitCategoryWithFieldErrorsResponse
	createUnitCategoryArea: Area
	createUnitCategoryBrandItems: Array<UnitCategoryBrandItem>
	createUnitCategoryElement: Area
	createUnitCategoryMaterialItems: Array<UnitCategoryMaterialItem>
	createUnitGroup: UnitGroupWithFieldErrorsResponse
	deleteArea: Scalars["Boolean"]
	deleteBlock: Scalars["Boolean"]
	deleteBlockLayout: Scalars["Boolean"]
	deleteBrandItem: Scalars["Boolean"]
	deleteBuilder: Scalars["Boolean"]
	deleteBuilderAdmin: Scalars["Boolean"]
	deleteCluster: Scalars["Boolean"]
	deleteContractor: Scalars["Boolean"]
	deleteElement: Scalars["Boolean"]
	deleteInspection: Scalars["Boolean"]
	deleteInspector: Scalars["Boolean"]
	deleteIssue: Inspection
	deleteMaterialItem: Scalars["Boolean"]
	deleteProject: Scalars["Boolean"]
	deleteProjectHead: Scalars["Boolean"]
	deleteQualityHead: Scalars["Boolean"]
	deleteService: Scalars["Boolean"]
	deleteUnit: Scalars["Boolean"]
	deleteUnitCategory: Scalars["Boolean"]
	deleteUnitCategoryArea: Scalars["Boolean"]
	deleteUnitCategoryBrandItem: Scalars["Boolean"]
	deleteUnitCategoryBrandItemFromArea: Scalars["Boolean"]
	deleteUnitCategoryElement: Scalars["Boolean"]
	deleteUnitCategoryMaterialItem: Scalars["Boolean"]
	deleteUnitCategoryMaterialItemFromArea: Scalars["Boolean"]
	deleteUnitGroup: Scalars["Boolean"]
	deleteWorkInProgressItem: Inspection
	finishAvatarUpload: Picture
	finishBuilderPictureUpload: Picture
	finishInspection: Inspection
	finishUnitCategoryLayoutPictureUpload: UnitCategory
	finishUnitCustomerInspectionTemplatePictureUpload: Unit
	finishUnitLayoutPictureUpload: Unit
	internalApproveAreaDimension: Inspection
	internalApproveBrandCheck: Inspection
	internalApproveIssue: Inspection
	internalApproveMaterialCheck: Inspection
	internalApproveUnitArea: Inspection
	internalApproveWaterQuality: Inspection
	internalApproveWorkInProgressItem: Inspection
	mapUnitToBlockLayout: Scalars["Boolean"]
	rejectBuilderReview: Inspection
	removeAdditionalIssuePicture: Inspection
	removeAreaCoordinatesFromUnitCategoryLayout: UnitCategory
	removeAreaCoordinatesFromUnitLayout: Unit
	removeContractorFromBuilder: Builder
	removeCustomerInspectionTemplatePictureFromUnit: Unit
	removeUnitFromBlockLayout: Scalars["Boolean"]
	sendChangePasswordEmail: Scalars["Boolean"]
	sendPasswordResetEmail: Scalars["Boolean"]
	signAvatarUpload: UploadSignatureResponse
	signBuilderPictureUpload: UploadSignatureResponse
	signIssuePictureUpload: UploadSignatureResponse
	signIssueRectificationPictureUpload: UploadSignatureResponse
	signOfflineInspectionLogsUpload: UploadSignatureResponse
	signUnitCategoryLayoutPictureUpload: UploadSignatureResponse
	signUnitCustomerInspectionTemplatePictureUpload: UploadSignatureResponse
	signUnitLayoutPictureUpload: UploadSignatureResponse
	signWorkInProgressItemPictureUpload: UploadSignatureResponse
	signin: UserAuthResponse
	signinWithEmailToken: UserAuthResponse
	signout: Scalars["Boolean"]
	startInspection: Inspection
	startRectification: Rectification
	submitBuilderElementWiseRectificationReview: Rectification
	submitBuilderRectificationReview: Rectification
	submitBuilderReview: Inspection
	submitElementRectification: Rectification
	submitInternalReview: Inspection
	updateArea: Area
	updateAreaDimensions: Inspection
	updateBlock: BlockWithFieldErrorsResponse
	updateBlockLayout: BlockLayoutWithFieldErrorsResponse
	updateBrandCheck: Inspection
	updateBrandItem: BrandItem
	updateBuilder: BuilderWithFieldErrorsResponse
	updateBuilderAdmin: UserWithFieldErrorsResponse
	updateBuilderReviewerofInspection: Inspection
	updateCluster: ClusterWithFieldErrorsResponse
	updateContractor: UserWithFieldErrorsResponse
	updateContractorForElementRectification: Rectification
	updateInspector: UserWithFieldErrorsResponse
	updateInspectorofInspection: Inspection
	updateInternalReviewerofInspection: Inspection
	updateIssue: Inspection
	updateIssueOnPostSnagging: Inspection
	updateIssueRectification: Rectification
	updateMaterialCheck: Inspection
	updateMaterialItem: MaterialItem
	updateProject: ProjectWithFieldErrorsResponse
	updateService: Service
	updateUnit: UnitWithFieldErrorsResponse
	updateUnitCategoryArea: Area
	updateUnitCategoryBrandItem: UnitCategoryBrandItem
	updateUnitCategoryLabel: UnitCategoryWithFieldErrorsResponse
	updateUnitCategoryMaterialItem: UnitCategoryMaterialItem
	updateUnitGroupLabel: UnitGroupWithFieldErrorsResponse
	updateWorkInProgressItem: Inspection
	updateWorkInProgressItemOnPostSnagging: Inspection
	verifySigninWithEmailToken: Scalars["Boolean"]
}

export type MutationaddAdditionalIssuePictureArgs = {
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
	pictureKey: Scalars["String"]
}

export type MutationaddAreaCoordinatesOnUnitCategoryLayoutArgs = {
	areaId: Scalars["String"]
	coordinates: CoordinatesInput
	unitCategoryId: Scalars["String"]
}

export type MutationaddAreaCoordinatesOnUnitLayoutArgs = {
	areaId: Scalars["String"]
	coordinates: CoordinatesInput
	unitId: Scalars["String"]
}

export type MutationaddContractorToBuilderArgs = {
	builderId: Scalars["String"]
	contractorId: Scalars["String"]
}

export type MutationaddFCMTokenArgs = {
	token: Scalars["String"]
}

export type MutationaddIssueArgs = {
	areaId: Scalars["String"]
	element: Elements
	input: IssueInput
	inspectionId: Scalars["String"]
}

export type MutationaddWaterQualityArgs = {
	input: WaterQualityInput
	inspectionId: Scalars["String"]
}

export type MutationaddWorkInProgressItemArgs = {
	input: WorkInProgressItemInput
	inspectionId: Scalars["String"]
}

export type MutationassignBrandItemToAreaArgs = {
	areaId: Scalars["String"]
	brandItemId: Scalars["String"]
}

export type MutationassignMaterialItemToAreaArgs = {
	areaId: Scalars["String"]
	materialItemId: Scalars["String"]
}

export type MutationassignUnitCategoryBrandItemToAreaArgs = {
	areaId: Scalars["String"]
	brandItemId: Scalars["String"]
}

export type MutationassignUnitCategoryMaterialItemToAreaArgs = {
	areaId: Scalars["String"]
	materialItemId: Scalars["String"]
}

export type MutationbuilderApproveAreaDimensionArgs = {
	approval: Scalars["Boolean"]
	areaDimensionId: Scalars["String"]
	inspectionId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationbuilderApproveBrandCheckArgs = {
	approval: Scalars["Boolean"]
	brandCheckId: Scalars["String"]
	inspectionId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationbuilderApproveIssueArgs = {
	approval: Scalars["Boolean"]
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationbuilderApproveMaterialCheckArgs = {
	approval: Scalars["Boolean"]
	inspectionId: Scalars["String"]
	materialCheckId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationbuilderApproveUnitAreaArgs = {
	approval: Scalars["Boolean"]
	inspectionId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationbuilderApproveWaterQualityArgs = {
	approval: Scalars["Boolean"]
	inspectionId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationbuilderApproveWorkInProgressItemArgs = {
	approval: Scalars["Boolean"]
	inspectionId: Scalars["String"]
	itemId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationbuilderReviewIssueRectificationArgs = {
	approval: Scalars["Boolean"]
	element: Elements
	issueId: Scalars["String"]
	rectificationId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationcreateAdminArgs = {
	input: UserInput
}

export type MutationcreateAreaArgs = {
	input: AreaInput
	unitId: Scalars["String"]
}

export type MutationcreateBlockArgs = {
	clusterId: Scalars["String"]
	input: BlockInput
}

export type MutationcreateBlockLayoutArgs = {
	blockId: Scalars["String"]
	columns: Scalars["Int"]
	rows: Scalars["Int"]
}

export type MutationcreateBrandItemsArgs = {
	areaId?: InputMaybe<Scalars["String"]>
	input: BrandItemInput
	quantity: Scalars["Int"]
	unitId: Scalars["String"]
}

export type MutationcreateBuilderArgs = {
	input: BuilderInput
}

export type MutationcreateBuilderAdminArgs = {
	builderId: Scalars["String"]
	input: UserInput
}

export type MutationcreateClusterArgs = {
	input: ClusterInput
	projectId: Scalars["String"]
}

export type MutationcreateContractorArgs = {
	input: UserInput
	linkedElements: Array<Elements>
}

export type MutationcreateElementArgs = {
	areaId: Scalars["String"]
	element: Elements
	unitId: Scalars["String"]
}

export type MutationcreateInspectionArgs = {
	builderReviewerId: Scalars["String"]
	inspectorId: Scalars["String"]
	internalReviewerId: Scalars["String"]
	preSnaggingInspectionId?: InputMaybe<Scalars["String"]>
	type: InspectionTypes
	unitId: Scalars["String"]
}

export type MutationcreateInspectorArgs = {
	input: UserInput
}

export type MutationcreateMaterialItemsArgs = {
	areaId?: InputMaybe<Scalars["String"]>
	input: MaterialItemInput
	quantity: Scalars["Int"]
	unitId: Scalars["String"]
}

export type MutationcreateOfflineInspectionTaskArgs = {
	inspectionId: Scalars["String"]
}

export type MutationcreatePostSnaggingInspectionRequestArgs = {
	inspectionId: Scalars["String"]
}

export type MutationcreateProjectArgs = {
	builderId: Scalars["String"]
	input: ProjectInput
}

export type MutationcreateProjectHeadArgs = {
	projectId: Scalars["String"]
	userId: Scalars["String"]
}

export type MutationcreateQualityHeadArgs = {
	projectId: Scalars["String"]
	userId: Scalars["String"]
}

export type MutationcreateRectificationArgs = {
	builderReviewerId: Scalars["String"]
	elementWiseContractors: Array<ElementWiseContractorInput>
	preSnaggingInspectionId: Scalars["String"]
}

export type MutationcreateServiceArgs = {
	input: ServiceInput
}

export type MutationcreateUnitArgs = {
	blockId: Scalars["String"]
	input: UnitInput
}

export type MutationcreateUnitCategoryArgs = {
	input: UnitCategoryInput
	projectId: Scalars["String"]
}

export type MutationcreateUnitCategoryAreaArgs = {
	input: AreaInput
	unitCategoryId: Scalars["String"]
}

export type MutationcreateUnitCategoryBrandItemsArgs = {
	areaId?: InputMaybe<Scalars["String"]>
	input: BrandItemInput
	quantity: Scalars["Int"]
	unitCategoryId: Scalars["String"]
}

export type MutationcreateUnitCategoryElementArgs = {
	areaId: Scalars["String"]
	element: Elements
	unitCategoryId: Scalars["String"]
}

export type MutationcreateUnitCategoryMaterialItemsArgs = {
	areaId?: InputMaybe<Scalars["String"]>
	input: MaterialItemInput
	quantity: Scalars["Int"]
	unitCategoryId: Scalars["String"]
}

export type MutationcreateUnitGroupArgs = {
	input: UnitGroupInput
	projectId: Scalars["String"]
}

export type MutationdeleteAreaArgs = {
	areaId: Scalars["String"]
	unitId: Scalars["String"]
}

export type MutationdeleteBlockArgs = {
	blockId: Scalars["String"]
}

export type MutationdeleteBlockLayoutArgs = {
	blockLayoutId: Scalars["String"]
}

export type MutationdeleteBrandItemArgs = {
	brandItemId: Scalars["String"]
}

export type MutationdeleteBuilderArgs = {
	builderId: Scalars["String"]
}

export type MutationdeleteBuilderAdminArgs = {
	builderAdminId: Scalars["String"]
}

export type MutationdeleteClusterArgs = {
	clusterId: Scalars["String"]
}

export type MutationdeleteContractorArgs = {
	contractorId: Scalars["String"]
}

export type MutationdeleteElementArgs = {
	areaId: Scalars["String"]
	element: Elements
	unitId: Scalars["String"]
}

export type MutationdeleteInspectionArgs = {
	inspectionId: Scalars["String"]
}

export type MutationdeleteInspectorArgs = {
	inspectorId: Scalars["String"]
}

export type MutationdeleteIssueArgs = {
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
}

export type MutationdeleteMaterialItemArgs = {
	materialItemId: Scalars["String"]
}

export type MutationdeleteProjectArgs = {
	projectId: Scalars["String"]
}

export type MutationdeleteProjectHeadArgs = {
	projectId: Scalars["String"]
	userId: Scalars["String"]
}

export type MutationdeleteQualityHeadArgs = {
	projectId: Scalars["String"]
	userId: Scalars["String"]
}

export type MutationdeleteServiceArgs = {
	serviceId: Scalars["String"]
}

export type MutationdeleteUnitArgs = {
	unitId: Scalars["String"]
}

export type MutationdeleteUnitCategoryArgs = {
	unitCategoryId: Scalars["String"]
}

export type MutationdeleteUnitCategoryAreaArgs = {
	areaId: Scalars["String"]
	unitCategoryId: Scalars["String"]
}

export type MutationdeleteUnitCategoryBrandItemArgs = {
	brandItemId: Scalars["String"]
}

export type MutationdeleteUnitCategoryBrandItemFromAreaArgs = {
	brandItemId: Scalars["String"]
}

export type MutationdeleteUnitCategoryElementArgs = {
	areaId: Scalars["String"]
	element: Elements
	unitCategoryId: Scalars["String"]
}

export type MutationdeleteUnitCategoryMaterialItemArgs = {
	materialItemId: Scalars["String"]
}

export type MutationdeleteUnitCategoryMaterialItemFromAreaArgs = {
	materialItemId: Scalars["String"]
}

export type MutationdeleteUnitGroupArgs = {
	unitGroupId: Scalars["String"]
}

export type MutationdeleteWorkInProgressItemArgs = {
	inspectionId: Scalars["String"]
	itemId: Scalars["String"]
}

export type MutationfinishAvatarUploadArgs = {
	input: FinishUploadInput
}

export type MutationfinishBuilderPictureUploadArgs = {
	builderId: Scalars["String"]
	input: FinishUploadInput
}

export type MutationfinishInspectionArgs = {
	inspectionId: Scalars["String"]
}

export type MutationfinishUnitCategoryLayoutPictureUploadArgs = {
	input: FinishUploadInput
	unitCategoryId: Scalars["String"]
}

export type MutationfinishUnitCustomerInspectionTemplatePictureUploadArgs = {
	input: FinishUploadInput
	unitId: Scalars["String"]
}

export type MutationfinishUnitLayoutPictureUploadArgs = {
	input: FinishUploadInput
	unitId: Scalars["String"]
}

export type MutationinternalApproveAreaDimensionArgs = {
	approval: Scalars["Boolean"]
	areaDimensionId: Scalars["String"]
	inspectionId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationinternalApproveBrandCheckArgs = {
	approval: Scalars["Boolean"]
	brandCheckId: Scalars["String"]
	inspectionId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationinternalApproveIssueArgs = {
	approval: Scalars["Boolean"]
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationinternalApproveMaterialCheckArgs = {
	approval: Scalars["Boolean"]
	inspectionId: Scalars["String"]
	materialCheckId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationinternalApproveUnitAreaArgs = {
	approval: Scalars["Boolean"]
	inspectionId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationinternalApproveWaterQualityArgs = {
	approval: Scalars["Boolean"]
	inspectionId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationinternalApproveWorkInProgressItemArgs = {
	approval: Scalars["Boolean"]
	inspectionId: Scalars["String"]
	itemId: Scalars["String"]
	remarks?: InputMaybe<Scalars["String"]>
}

export type MutationmapUnitToBlockLayoutArgs = {
	blockLayoutId: Scalars["String"]
	column: Scalars["Int"]
	row: Scalars["Int"]
	unitId: Scalars["String"]
}

export type MutationrejectBuilderReviewArgs = {
	inspectionId: Scalars["String"]
}

export type MutationremoveAdditionalIssuePictureArgs = {
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
}

export type MutationremoveAreaCoordinatesFromUnitCategoryLayoutArgs = {
	coordinatesId: Scalars["String"]
	unitCategoryId: Scalars["String"]
}

export type MutationremoveAreaCoordinatesFromUnitLayoutArgs = {
	coordinatesId: Scalars["String"]
	unitId: Scalars["String"]
}

export type MutationremoveContractorFromBuilderArgs = {
	builderId: Scalars["String"]
	contractorId: Scalars["String"]
}

export type MutationremoveCustomerInspectionTemplatePictureFromUnitArgs = {
	unitId: Scalars["String"]
}

export type MutationremoveUnitFromBlockLayoutArgs = {
	blockLayoutId: Scalars["String"]
	column: Scalars["Int"]
	row: Scalars["Int"]
	unitId: Scalars["String"]
}

export type MutationsendPasswordResetEmailArgs = {
	emailAddress: Scalars["String"]
}

export type MutationsignAvatarUploadArgs = {
	format: Scalars["String"]
}

export type MutationsignBuilderPictureUploadArgs = {
	builderId: Scalars["String"]
	format: Scalars["String"]
}

export type MutationsignIssuePictureUploadArgs = {
	contentType: Scalars["String"]
	inspectionId: Scalars["String"]
}

export type MutationsignIssueRectificationPictureUploadArgs = {
	contentType: Scalars["String"]
	rectificationId: Scalars["String"]
}

export type MutationsignOfflineInspectionLogsUploadArgs = {
	taskId: Scalars["String"]
}

export type MutationsignUnitCategoryLayoutPictureUploadArgs = {
	contentType: Scalars["String"]
	unitCategoryId: Scalars["String"]
}

export type MutationsignUnitCustomerInspectionTemplatePictureUploadArgs = {
	contentType: Scalars["String"]
	unitId: Scalars["String"]
}

export type MutationsignUnitLayoutPictureUploadArgs = {
	contentType: Scalars["String"]
	unitId: Scalars["String"]
}

export type MutationsignWorkInProgressItemPictureUploadArgs = {
	contentType: Scalars["String"]
	inspectionId: Scalars["String"]
}

export type MutationsigninArgs = {
	emailAddress: Scalars["String"]
	password: Scalars["String"]
}

export type MutationsigninWithEmailTokenArgs = {
	emailAddress: Scalars["String"]
	newPassword: Scalars["String"]
	token: Scalars["String"]
}

export type MutationstartInspectionArgs = {
	inspectionId: Scalars["String"]
}

export type MutationstartRectificationArgs = {
	element: Elements
	rectificationId: Scalars["String"]
}

export type MutationsubmitBuilderElementWiseRectificationReviewArgs = {
	element: Elements
	rectificationId: Scalars["String"]
}

export type MutationsubmitBuilderRectificationReviewArgs = {
	rectificationId: Scalars["String"]
}

export type MutationsubmitBuilderReviewArgs = {
	inspectionId: Scalars["String"]
}

export type MutationsubmitElementRectificationArgs = {
	element: Elements
	rectificationId: Scalars["String"]
}

export type MutationsubmitInternalReviewArgs = {
	inspectionId: Scalars["String"]
}

export type MutationupdateAreaArgs = {
	areaId: Scalars["String"]
	input: AreaInput
	unitId: Scalars["String"]
}

export type MutationupdateAreaDimensionsArgs = {
	areaDimensionsId: Scalars["String"]
	input: AreaDimensionsInput
	inspectionId: Scalars["String"]
}

export type MutationupdateBlockArgs = {
	blockId: Scalars["String"]
	input: BlockInput
}

export type MutationupdateBlockLayoutArgs = {
	blockLayoutId: Scalars["String"]
	columns: Scalars["Int"]
	rows: Scalars["Int"]
}

export type MutationupdateBrandCheckArgs = {
	brandCheckId: Scalars["String"]
	input: BrandCheckInput
	inspectionId: Scalars["String"]
}

export type MutationupdateBrandItemArgs = {
	brandItemId: Scalars["String"]
	input: BrandItemInput
}

export type MutationupdateBuilderArgs = {
	builderId: Scalars["String"]
	input: BuilderInput
}

export type MutationupdateBuilderAdminArgs = {
	builderAdminId: Scalars["String"]
	input: UpdateUserInput
}

export type MutationupdateBuilderReviewerofInspectionArgs = {
	builderReviewerId: Scalars["String"]
	inspectionId: Scalars["String"]
}

export type MutationupdateClusterArgs = {
	clusterId: Scalars["String"]
	input: ClusterInput
}

export type MutationupdateContractorArgs = {
	contractorId: Scalars["String"]
	input: UpdateUserInput
	linkedElements: Array<Elements>
}

export type MutationupdateContractorForElementRectificationArgs = {
	contractorId: Scalars["String"]
	element: Elements
	rectificationId: Scalars["String"]
	remarks: Scalars["String"]
}

export type MutationupdateInspectorArgs = {
	input: UpdateUserInput
	inspectorId: Scalars["String"]
}

export type MutationupdateInspectorofInspectionArgs = {
	inspectionId: Scalars["String"]
	inspectorId: Scalars["String"]
}

export type MutationupdateInternalReviewerofInspectionArgs = {
	inspectionId: Scalars["String"]
	internalReviewerId: Scalars["String"]
}

export type MutationupdateIssueArgs = {
	input: UpdateIssueInput
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
}

export type MutationupdateIssueOnPostSnaggingArgs = {
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
	pictureKey: Scalars["String"]
	status: IssuePostSnaggingStatus
}

export type MutationupdateIssueRectificationArgs = {
	element: Elements
	isRectified: Scalars["Boolean"]
	issueId: Scalars["String"]
	offlineHash?: InputMaybe<Scalars["String"]>
	pictureKey: Scalars["String"]
	rectificationId: Scalars["String"]
	rectificationRemarks?: InputMaybe<Scalars["String"]>
}

export type MutationupdateMaterialCheckArgs = {
	input: MaterialCheckInput
	inspectionId: Scalars["String"]
	materialCheckId: Scalars["String"]
}

export type MutationupdateMaterialItemArgs = {
	input: MaterialItemInput
	materialItemId: Scalars["String"]
}

export type MutationupdateProjectArgs = {
	input: ProjectInput
	projectId: Scalars["String"]
}

export type MutationupdateServiceArgs = {
	input: ServiceInput
	serviceId: Scalars["String"]
}

export type MutationupdateUnitArgs = {
	input: UnitInput
	unitId: Scalars["String"]
}

export type MutationupdateUnitCategoryAreaArgs = {
	areaId: Scalars["String"]
	input: AreaInput
	unitCategoryId: Scalars["String"]
}

export type MutationupdateUnitCategoryBrandItemArgs = {
	brandItemId: Scalars["String"]
	input: BrandItemInput
}

export type MutationupdateUnitCategoryLabelArgs = {
	label: LabelInput
	unitCategoryId: Scalars["String"]
}

export type MutationupdateUnitCategoryMaterialItemArgs = {
	input: MaterialItemInput
	materialItemId: Scalars["String"]
}

export type MutationupdateUnitGroupLabelArgs = {
	label: LabelInput
	unitGroupId: Scalars["String"]
}

export type MutationupdateWorkInProgressItemArgs = {
	input: UpdateWorkInProgressItemInput
	inspectionId: Scalars["String"]
	itemId: Scalars["String"]
}

export type MutationupdateWorkInProgressItemOnPostSnaggingArgs = {
	input: WorkInProgressItemInput
	inspectionId: Scalars["String"]
	itemId: Scalars["String"]
}

export type MutationverifySigninWithEmailTokenArgs = {
	emailAddress: Scalars["String"]
	token: Scalars["String"]
}

export type OfflineInspectionTask = {
	__typename?: "OfflineInspectionTask"
	_id: Scalars["String"]
	createdAt: Scalars["DateTime"]
	failureMessage?: Maybe<Scalars["String"]>
	inspectionId: Scalars["String"]
	inspectorId: Scalars["String"]
	logs?: Maybe<S3Object>
	status: OfflineInspectionTaskStatus
	statusLifecycle: Array<StatusLifecycle>
	updatedAt: Scalars["DateTime"]
}

export enum OfflineInspectionTaskStatus {
	COMPLETED = "COMPLETED",
	FAILED = "FAILED",
	LOGS_UPLOADED = "LOGS_UPLOADED",
	PROCESSING = "PROCESSING",
	TASK_CREATED = "TASK_CREATED",
	UPLOAD_URL_CREATED = "UPLOAD_URL_CREATED",
}

export type PaginatedBlocksResponse = {
	__typename?: "PaginatedBlocksResponse"
	blocks: Array<Block>
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
}

export type PaginatedBrandItemsResponse = {
	__typename?: "PaginatedBrandItemsResponse"
	brandItems: Array<BrandItem>
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
}

export type PaginatedBuildersResponse = {
	__typename?: "PaginatedBuildersResponse"
	builders: Array<Builder>
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
}

export type PaginatedClustersResponse = {
	__typename?: "PaginatedClustersResponse"
	clusters: Array<Cluster>
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
}

export type PaginatedInput = {
	limit: Scalars["Int"]
	page: Scalars["Float"]
}

export type PaginatedInspectionsResponse = {
	__typename?: "PaginatedInspectionsResponse"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	inspections: Array<Inspection>
}

export type PaginatedIssueTemplatesResponse = {
	__typename?: "PaginatedIssueTemplatesResponse"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	issueTemplates: Array<IssueTemplate>
}

export type PaginatedMaterialItemsResponse = {
	__typename?: "PaginatedMaterialItemsResponse"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	materialItems: Array<MaterialItem>
}

export type PaginatedOfflineInspectionTasks = {
	__typename?: "PaginatedOfflineInspectionTasks"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	offlineInspectionTasks: Array<OfflineInspectionTask>
}

export type PaginatedProjectsResponse = {
	__typename?: "PaginatedProjectsResponse"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	projects: Array<Project>
}

export type PaginatedRectificationsResponse = {
	__typename?: "PaginatedRectificationsResponse"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	rectifications: Array<Rectification>
}

export type PaginatedReportsResponse = {
	__typename?: "PaginatedReportsResponse"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	reports: Array<Report>
}

export type PaginatedUnitCategoriesResponse = {
	__typename?: "PaginatedUnitCategoriesResponse"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	unitCategories: Array<UnitCategory>
}

export type PaginatedUnitCategoryBrandItemsResponse = {
	__typename?: "PaginatedUnitCategoryBrandItemsResponse"
	brandItems: Array<UnitCategoryBrandItem>
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
}

export type PaginatedUnitCategoryMaterialItemsResponse = {
	__typename?: "PaginatedUnitCategoryMaterialItemsResponse"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	materialItems: Array<UnitCategoryMaterialItem>
}

export type PaginatedUnitGroupsResponse = {
	__typename?: "PaginatedUnitGroupsResponse"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	unitGroups: Array<UnitGroup>
}

export type PaginatedUnitsResponse = {
	__typename?: "PaginatedUnitsResponse"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	units: Array<Unit>
}

export type PaginatedUsersResponse = {
	__typename?: "PaginatedUsersResponse"
	currentPage: Scalars["Float"]
	hasNextPage: Scalars["Boolean"]
	hasPrevPage: Scalars["Boolean"]
	users: Array<User>
}

export type Phone = {
	__typename?: "Phone"
	countryCode: Scalars["String"]
	number: Scalars["String"]
}

export type PhoneInput = {
	countryCode: Scalars["String"]
	number: Scalars["String"]
}

export type Picture = {
	__typename?: "Picture"
	original: PictureObject
	variants?: Maybe<PictureVariants>
}

export type PictureObject = {
	__typename?: "PictureObject"
	height?: Maybe<Scalars["Float"]>
	key: Scalars["String"]
	url: Scalars["String"]
	width?: Maybe<Scalars["Float"]>
}

export type PictureVariants = {
	__typename?: "PictureVariants"
	large?: Maybe<PictureObject>
	medium?: Maybe<PictureObject>
	small?: Maybe<PictureObject>
	thumbnail?: Maybe<PictureObject>
}

export type PostSnaggingInspectionRequest = {
	__typename?: "PostSnaggingInspectionRequest"
	status: PostSnaggingInspectionRequestStatus
	statusLifecycle: Array<StatusLifecycle>
}

export enum PostSnaggingInspectionRequestStatus {
	Closed = "Closed",
	Open = "Open",
}

export type Project = {
	__typename?: "Project"
	_id: Scalars["String"]
	address: Address
	builder: Builder
	builderId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	elementWiseContractors?: Maybe<Array<ElementWiseContractors>>
	isDeleted?: Maybe<Scalars["Boolean"]>
	label: Label
	projectHeadIds?: Maybe<Array<Scalars["String"]>>
	projectHeads: Array<User>
	qualityHeadIds?: Maybe<Array<Scalars["String"]>>
	qualityHeads: Array<User>
	type: ProjectTypes
	updatedAt: Scalars["DateTime"]
}

export type ProjectAndSeverityWiseIssuesStats = {
	__typename?: "ProjectAndSeverityWiseIssuesStats"
	_id: Scalars["String"]
	builderId: Scalars["String"]
	cosmeticIssueIds: Array<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	majorIssueIds: Array<Scalars["String"]>
	minorIssueIds: Array<Scalars["String"]>
	project: Project
	projectId: Scalars["String"]
	unitId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type ProjectAndStatusWiseInspectionsStats = {
	__typename?: "ProjectAndStatusWiseInspectionsStats"
	_id: Scalars["String"]
	builderId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	isDeleted?: Maybe<Scalars["Boolean"]>
	project: Project
	projectId: Scalars["String"]
	statusWiseUnits: Array<UnitAndInspectionStatus>
	updatedAt: Scalars["DateTime"]
}

export type ProjectInput = {
	address: AddressInput
	label: LabelInput
	type: ProjectTypes
}

export enum ProjectTypes {
	Commercial = "Commercial",
	Residential = "Residential",
	Unknown = "Unknown",
}

export type ProjectWithFieldErrorsResponse = {
	__typename?: "ProjectWithFieldErrorsResponse"
	errors?: Maybe<Array<FieldError>>
	project?: Maybe<Project>
}

export type Query = {
	__typename?: "Query"
	admins: Array<User>
	allBuilders: Array<Builder>
	allServices: Array<Service>
	blockById?: Maybe<Block>
	blocksOfProject: Array<Block>
	brandItemById?: Maybe<BrandItem>
	brandItemsOfInspection: Array<BrandItem>
	builderAdmins: Array<User>
	builderAdminsOfBuilder: Array<User>
	builderAndStatusWiseInspectionStats: Array<StatusWiseInspectionsStats>
	builderById?: Maybe<Builder>
	clusterById?: Maybe<Cluster>
	clustersOfProject: Array<Cluster>
	contractors: Array<User>
	contractorsByRectificationId?: Maybe<Array<User>>
	elementAndSeverityWiseIssuesStats: Array<ElementAndSeverityWiseIssuesStats>
	elementsOfRectification?: Maybe<Array<ElementWiseRectification>>
	inspectionById?: Maybe<Inspection>
	inspections: PaginatedInspectionsResponse
	inspectionsForReview?: Maybe<Inspection>
	inspectionsWithoutPagination: Array<Inspection>
	inspectors: Array<User>
	issueAutofillItems: Array<Scalars["String"]>
	issueItems: Array<IssueItem>
	issueTemplates: PaginatedIssueTemplatesResponse
	issueTemplatesWithoutPagination: Array<IssueTemplate>
	latestInspectionOfUnit?: Maybe<Inspection>
	layoutOfBlock?: Maybe<BlockLayout>
	linkedContractorsOfBuilder?: Maybe<Array<User>>
	materialItemById?: Maybe<MaterialItem>
	materialItemsOfInspection: Array<MaterialItem>
	me?: Maybe<User>
	offlineInspectionTasks: PaginatedOfflineInspectionTasks
	projectAndSeverityWiseIssuesStats: Array<ProjectAndSeverityWiseIssuesStats>
	projectAndStatusWiseInspectionStats: Array<ProjectAndStatusWiseInspectionsStats>
	projectById?: Maybe<Project>
	projectHeadsOfProject: Array<User>
	qualityHeadsOfProject: Array<User>
	rectificationById?: Maybe<Rectification>
	rectifications: PaginatedRectificationsResponse
	reportByInspectionId?: Maybe<Array<Report>>
	reportByPublicId?: Maybe<Report>
	searchAdmins: PaginatedUsersResponse
	searchBlocksOfCluster: PaginatedBlocksResponse
	searchBrandItemsOfUnit: PaginatedBrandItemsResponse
	searchBrandItemsOfUnitCategory: PaginatedUnitCategoryBrandItemsResponse
	searchBuilderAdmins: PaginatedUsersResponse
	searchBuilders: PaginatedBuildersResponse
	searchClustersOfProject: PaginatedClustersResponse
	searchContractors: PaginatedUsersResponse
	searchContractorsOfBuilder: PaginatedUsersResponse
	searchInspectors: PaginatedUsersResponse
	searchMaterialItemsOfUnit: PaginatedMaterialItemsResponse
	searchMaterialItemsOfUnitCategory: PaginatedUnitCategoryMaterialItemsResponse
	searchProjectsOfBuilder: PaginatedProjectsResponse
	searchReports: PaginatedReportsResponse
	searchUnitCategoriesOfProject: PaginatedUnitCategoriesResponse
	searchUnitGroupsOfProject: PaginatedUnitGroupsResponse
	searchUnitsOfBlock: PaginatedUnitsResponse
	serviceById: Service
	servicesByKeyword: Array<Service>
	statusWiseInspectionStats?: Maybe<StatusWiseInspectionsStats>
	unassignedBrandItemsOfUnit: Array<BrandItem>
	unassignedBrandItemsOfUnitCategory: Array<UnitCategoryBrandItem>
	unassignedMaterialItemsOfUnit: Array<MaterialItem>
	unassignedMaterialItemsOfUnitCategory: Array<UnitCategoryMaterialItem>
	uniqueElementsOfUnit?: Maybe<Array<Elements>>
	unitById?: Maybe<Unit>
	unitCategoriesOfProject: Array<UnitCategory>
	unitCategoryBrandItemById?: Maybe<UnitCategoryBrandItem>
	unitCategoryById?: Maybe<UnitCategory>
	unitCategoryMaterialItemById?: Maybe<UnitCategoryMaterialItem>
	unitGroupById?: Maybe<UnitGroup>
	userById?: Maybe<User>
}

export type QueryblockByIdArgs = {
	blockId: Scalars["String"]
}

export type QueryblocksOfProjectArgs = {
	projectId: Scalars["String"]
}

export type QuerybrandItemByIdArgs = {
	brandItemId: Scalars["String"]
}

export type QuerybrandItemsOfInspectionArgs = {
	areaId?: InputMaybe<Scalars["String"]>
	inspectionId: Scalars["String"]
}

export type QuerybuilderAdminsArgs = {
	builderId: Scalars["String"]
}

export type QuerybuilderAdminsOfBuilderArgs = {
	builderId: Scalars["String"]
}

export type QuerybuilderByIdArgs = {
	builderId: Scalars["String"]
}

export type QueryclusterByIdArgs = {
	clusterId: Scalars["String"]
}

export type QueryclustersOfProjectArgs = {
	projectId: Scalars["String"]
}

export type QuerycontractorsArgs = {
	builderId: Scalars["String"]
	element?: InputMaybe<Elements>
}

export type QuerycontractorsByRectificationIdArgs = {
	rectificationId: Scalars["String"]
}

export type QueryelementsOfRectificationArgs = {
	rectificationId: Scalars["String"]
}

export type QueryinspectionByIdArgs = {
	inspectionId: Scalars["String"]
}

export type QueryinspectionsArgs = {
	builderId?: InputMaybe<Scalars["String"]>
	pagination: PaginatedInput
	projectId?: InputMaybe<Scalars["String"]>
	since?: InputMaybe<Scalars["DateTime"]>
	status?: InputMaybe<InspectionStatus>
	type?: InputMaybe<InspectionTypes>
	unitId?: InputMaybe<Scalars["String"]>
	until?: InputMaybe<Scalars["DateTime"]>
}

export type QueryinspectionsForReviewArgs = {
	inspectionId: Scalars["String"]
}

export type QueryinspectionsWithoutPaginationArgs = {
	builderId?: InputMaybe<Scalars["String"]>
	since?: InputMaybe<Scalars["DateTime"]>
	status?: InputMaybe<InspectionStatus>
	type?: InputMaybe<InspectionTypes>
	until?: InputMaybe<Scalars["DateTime"]>
}

export type QueryissueAutofillItemsArgs = {
	element: Elements
}

export type QueryissueTemplatesArgs = {
	areaType: AreaTypes
	element: Elements
	pagination: PaginatedInput
}

export type QueryissueTemplatesWithoutPaginationArgs = {
	areaType: AreaTypes
}

export type QuerylatestInspectionOfUnitArgs = {
	unitId: Scalars["String"]
}

export type QuerylayoutOfBlockArgs = {
	blockId: Scalars["String"]
}

export type QuerylinkedContractorsOfBuilderArgs = {
	builderId: Scalars["String"]
}

export type QuerymaterialItemByIdArgs = {
	materialItemId: Scalars["String"]
}

export type QuerymaterialItemsOfInspectionArgs = {
	areaId?: InputMaybe<Scalars["String"]>
	inspectionId: Scalars["String"]
}

export type QueryofflineInspectionTasksArgs = {
	inspectionId?: InputMaybe<Scalars["String"]>
	pagination: PaginatedInput
}

export type QueryprojectByIdArgs = {
	projectId: Scalars["String"]
}

export type QueryprojectHeadsOfProjectArgs = {
	projectId: Scalars["String"]
}

export type QueryqualityHeadsOfProjectArgs = {
	projectId: Scalars["String"]
}

export type QueryrectificationByIdArgs = {
	rectificationId: Scalars["String"]
}

export type QueryrectificationsArgs = {
	builderId?: InputMaybe<Scalars["String"]>
	pagination: PaginatedInput
	projectId?: InputMaybe<Scalars["String"]>
	since?: InputMaybe<Scalars["DateTime"]>
	status?: InputMaybe<RectificationStatus>
	unitId?: InputMaybe<Scalars["String"]>
	until?: InputMaybe<Scalars["DateTime"]>
}

export type QueryreportByInspectionIdArgs = {
	inspectionId: Scalars["String"]
}

export type QueryreportByPublicIdArgs = {
	reportPublicId: Scalars["String"]
}

export type QuerysearchAdminsArgs = {
	keyword: Scalars["String"]
	pagination: PaginatedInput
}

export type QuerysearchBlocksOfClusterArgs = {
	clusterId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}

export type QuerysearchBrandItemsOfUnitArgs = {
	areaId?: InputMaybe<Scalars["String"]>
	keyword: Scalars["String"]
	pagination: PaginatedInput
	unitId: Scalars["String"]
}

export type QuerysearchBrandItemsOfUnitCategoryArgs = {
	areaId?: InputMaybe<Scalars["String"]>
	keyword: Scalars["String"]
	pagination: PaginatedInput
	unitCategoryId: Scalars["String"]
}

export type QuerysearchBuilderAdminsArgs = {
	builderId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}

export type QuerysearchBuildersArgs = {
	keyword: Scalars["String"]
	pagination: PaginatedInput
}

export type QuerysearchClustersOfProjectArgs = {
	keyword: Scalars["String"]
	pagination: PaginatedInput
	projectId: Scalars["String"]
}

export type QuerysearchContractorsArgs = {
	element?: InputMaybe<Elements>
	keyword: Scalars["String"]
	pagination: PaginatedInput
}

export type QuerysearchContractorsOfBuilderArgs = {
	builderId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}

export type QuerysearchInspectorsArgs = {
	keyword: Scalars["String"]
	pagination: PaginatedInput
}

export type QuerysearchMaterialItemsOfUnitArgs = {
	areaId?: InputMaybe<Scalars["String"]>
	keyword: Scalars["String"]
	pagination: PaginatedInput
	unitId: Scalars["String"]
}

export type QuerysearchMaterialItemsOfUnitCategoryArgs = {
	areaId?: InputMaybe<Scalars["String"]>
	keyword: Scalars["String"]
	pagination: PaginatedInput
	unitCategoryId: Scalars["String"]
}

export type QuerysearchProjectsOfBuilderArgs = {
	builderId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}

export type QuerysearchReportsArgs = {
	builderId?: InputMaybe<Scalars["String"]>
	inspectorId?: InputMaybe<Scalars["String"]>
	keyword?: InputMaybe<Scalars["String"]>
	pagination: PaginatedInput
	since?: InputMaybe<Scalars["DateTime"]>
	type?: InputMaybe<ReportTypes>
	until?: InputMaybe<Scalars["DateTime"]>
}

export type QuerysearchUnitCategoriesOfProjectArgs = {
	keyword: Scalars["String"]
	pagination: PaginatedInput
	projectId: Scalars["String"]
}

export type QuerysearchUnitGroupsOfProjectArgs = {
	keyword: Scalars["String"]
	pagination: PaginatedInput
	projectId: Scalars["String"]
}

export type QuerysearchUnitsOfBlockArgs = {
	blockId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}

export type QueryserviceByIdArgs = {
	serviceId: Scalars["String"]
}

export type QueryservicesByKeywordArgs = {
	keyword: Scalars["String"]
}

export type QueryunassignedBrandItemsOfUnitArgs = {
	unitId: Scalars["String"]
}

export type QueryunassignedBrandItemsOfUnitCategoryArgs = {
	unitCategoryId: Scalars["String"]
}

export type QueryunassignedMaterialItemsOfUnitArgs = {
	unitId: Scalars["String"]
}

export type QueryunassignedMaterialItemsOfUnitCategoryArgs = {
	unitCategoryId: Scalars["String"]
}

export type QueryuniqueElementsOfUnitArgs = {
	unitId: Scalars["String"]
}

export type QueryunitByIdArgs = {
	unitId: Scalars["String"]
}

export type QueryunitCategoriesOfProjectArgs = {
	projectId: Scalars["String"]
}

export type QueryunitCategoryBrandItemByIdArgs = {
	brandItemId: Scalars["String"]
}

export type QueryunitCategoryByIdArgs = {
	unitCategoryId: Scalars["String"]
}

export type QueryunitCategoryMaterialItemByIdArgs = {
	materialItemId: Scalars["String"]
}

export type QueryunitGroupByIdArgs = {
	unitGroupId: Scalars["String"]
}

export type QueryuserByIdArgs = {
	userId: Scalars["String"]
}

export type RectDimensions = {
	__typename?: "RectDimensions"
	_id: Scalars["String"]
	length: Dimension
	width: Dimension
}

export type RectDimensionsInput = {
	length: DimensionInput
	width: DimensionInput
}

export type Rectification = {
	__typename?: "Rectification"
	_id: Scalars["String"]
	block: Block
	blockId: Scalars["String"]
	builder: Builder
	builderId: Scalars["String"]
	builderReviewer: User
	builderReviewerId: Scalars["String"]
	cluster: Cluster
	clusterId: Scalars["String"]
	contractorIds: Array<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	elementWiseRectifications: Array<ElementWiseRectification>
	isDeleted?: Maybe<Scalars["Boolean"]>
	preSnaggingInspection: Inspection
	preSnaggingInspectionId: Scalars["String"]
	project: Project
	projectId: Scalars["String"]
	status: RectificationStatus
	statusLifecycle: Array<StatusLifecycle>
	unit: Unit
	unitId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type RectificationIssue = {
	__typename?: "RectificationIssue"
	_id: Scalars["String"]
	additionalPicture?: Maybe<Picture>
	areaId: Scalars["String"]
	builderRemarks?: Maybe<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	element: Elements
	isBuilderApproved?: Maybe<Scalars["Boolean"]>
	isCritical?: Maybe<Scalars["Boolean"]>
	isRectified?: Maybe<Scalars["Boolean"]>
	label: Label
	offlineHash?: Maybe<Scalars["String"]>
	picture: Picture
	rectificationPicture?: Maybe<Picture>
	rectificationRemarks?: Maybe<Scalars["String"]>
	severity: IssueSeverity
	updatedAt: Scalars["DateTime"]
}

export enum RectificationStatus {
	Completed = "Completed",
	Ongoing = "Ongoing",
	Pending = "Pending",
	UnderReview = "UnderReview",
}

export type Reference = {
	__typename?: "Reference"
	_id: Scalars["String"]
	type: ReferenceTypes
}

export enum ReferenceTypes {
	User = "User",
}

export type Report = {
	__typename?: "Report"
	_id: Scalars["String"]
	block: Block
	blockId: Scalars["String"]
	builder: Builder
	builderId: Scalars["String"]
	cluster: Cluster
	clusterId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	inspection: Inspection
	inspectionId: Scalars["String"]
	inspector: User
	inspectorId: Scalars["String"]
	project: Project
	projectId: Scalars["String"]
	publicId: Scalars["String"]
	reports: Array<ReportObject>
	type: ReportTypes
	unit: Unit
	unitId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type ReportObject = {
	__typename?: "ReportObject"
	_id: Scalars["String"]
	element?: Maybe<Elements>
	key: Scalars["String"]
	label: Label
	type: ReportPartTypes
	url: Scalars["String"]
}

export enum ReportPartTypes {
	Complete = "Complete",
	CompleteWithCriticalIssuesOnly = "CompleteWithCriticalIssuesOnly",
	ElementWise = "ElementWise",
	ElementWiseWithCriticalIssuesOnly = "ElementWiseWithCriticalIssuesOnly",
}

export enum ReportTypes {
	Final = "Final",
	Inspector = "Inspector",
	Internal = "Internal",
}

export type ReviewedAreaDimensions = {
	__typename?: "ReviewedAreaDimensions"
	_id: Scalars["String"]
	additionalArea?: Maybe<ReviewedDimension>
	area: ReviewedDimension
	areaId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	height: ReviewedDimension
	length: ReviewedDimension
	rects: Array<ReviewedRectDimensions>
	updatedAt: Scalars["DateTime"]
	width: ReviewedDimension
}

export type ReviewedBrandCheck = {
	__typename?: "ReviewedBrandCheck"
	_id: Scalars["String"]
	areaId?: Maybe<Scalars["String"]>
	brandItem: BrandItem
	brandItemId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	isOk?: Maybe<Scalars["Boolean"]>
	remarks?: Maybe<Scalars["String"]>
	updatedAt: Scalars["DateTime"]
}

export type ReviewedDimension = {
	__typename?: "ReviewedDimension"
	unit: DimensionUnits
	value: Scalars["Float"]
}

export type ReviewedIssue = {
	__typename?: "ReviewedIssue"
	_id: Scalars["String"]
	areaId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	element: Elements
	isCritical?: Maybe<Scalars["Boolean"]>
	label: Label
	picture: Picture
	severity: IssueSeverity
	templateId?: Maybe<Scalars["String"]>
	updatedAt: Scalars["DateTime"]
}

export type ReviewedMaterialCheck = {
	__typename?: "ReviewedMaterialCheck"
	_id: Scalars["String"]
	areaId?: Maybe<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	isOk?: Maybe<Scalars["Boolean"]>
	materialItem: MaterialItem
	materialItemId: Scalars["String"]
	remarks?: Maybe<Scalars["String"]>
	updatedAt: Scalars["DateTime"]
}

export type ReviewedRectDimensions = {
	__typename?: "ReviewedRectDimensions"
	_id: Scalars["String"]
	length: Dimension
	width: Dimension
}

export type ReviewedWaterQuality = {
	__typename?: "ReviewedWaterQuality"
	_id: Scalars["String"]
	createdAt: Scalars["DateTime"]
	ph: Scalars["Float"]
	tds: Scalars["Float"]
	updatedAt: Scalars["DateTime"]
}

export type ReviewedWorkInProgressItem = {
	__typename?: "ReviewedWorkInProgressItem"
	_id: Scalars["String"]
	areaId: Scalars["String"]
	builderRemarks?: Maybe<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	element: Elements
	estimatedDeadline: Scalars["DateTime"]
	internalRemarks?: Maybe<Scalars["String"]>
	isBuilderApproved?: Maybe<Scalars["Boolean"]>
	isCopiedFromPreSnagging?: Maybe<Scalars["Boolean"]>
	isInternalApproved?: Maybe<Scalars["Boolean"]>
	isReInspected?: Maybe<Scalars["Boolean"]>
	label: Label
	picture: Picture
	postSnaggingPicture?: Maybe<Picture>
	postSnaggingStatus?: Maybe<WorkInProgressItemStatus>
	status: WorkInProgressItemStatus
	updatedAt: Scalars["DateTime"]
}

export type S3Object = {
	__typename?: "S3Object"
	key: Scalars["String"]
	url: Scalars["String"]
}

export type Service = {
	__typename?: "Service"
	_id: Scalars["String"]
	createdAt: Scalars["DateTime"]
	isActive?: Maybe<Scalars["Boolean"]>
	key: Scalars["String"]
	label: Label
	lastHeartbeatAt?: Maybe<Scalars["DateTime"]>
	updatedAt: Scalars["DateTime"]
}

export type ServiceInput = {
	key: Scalars["String"]
	label: LabelInput
}

export type StatusLifecycle = {
	__typename?: "StatusLifecycle"
	_id: Scalars["String"]
	createdAt: Scalars["DateTime"]
	reference?: Maybe<Reference>
	remarks?: Maybe<Scalars["String"]>
	status: Scalars["String"]
}

export type StatusWiseInspectionsStats = {
	__typename?: "StatusWiseInspectionsStats"
	_id: Scalars["String"]
	builder: Builder
	builderId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	statusWiseUnits: Array<UnitAndInspectionStatus>
	updatedAt: Scalars["DateTime"]
}

export type Subscription = {
	__typename?: "Subscription"
	offlineInspectionTaskUpdate: OfflineInspectionTask
}

export type SubscriptionofflineInspectionTaskUpdateArgs = {
	taskId: Scalars["String"]
}

export type Unit = {
	__typename?: "Unit"
	_id: Scalars["String"]
	areas?: Maybe<Array<Area>>
	block: Block
	blockId: Scalars["String"]
	builder: Builder
	builderId: Scalars["String"]
	cluster: Cluster
	clusterId: Scalars["String"]
	configuration: UnitConfigurations
	createdAt: Scalars["DateTime"]
	customerInspectionTemplatePicture?: Maybe<Picture>
	elementWiseContractors?: Maybe<Array<ElementWiseContractors>>
	isDeleted?: Maybe<Scalars["Boolean"]>
	label: Label
	layout?: Maybe<UnitLayout>
	project: Project
	projectId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type UnitAndInspectionStatus = {
	__typename?: "UnitAndInspectionStatus"
	status: InspectionStatus
	unitId: Scalars["String"]
}

export type UnitCategory = {
	__typename?: "UnitCategory"
	_id: Scalars["String"]
	areas?: Maybe<Array<Area>>
	builder: Builder
	builderId: Scalars["String"]
	configuration: UnitConfigurations
	createdAt: Scalars["DateTime"]
	isDeleted?: Maybe<Scalars["Boolean"]>
	label: Label
	layout?: Maybe<UnitLayout>
	project: Project
	projectId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type UnitCategoryBrandItem = {
	__typename?: "UnitCategoryBrandItem"
	_id: Scalars["String"]
	areaId?: Maybe<Scalars["String"]>
	builderId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	isDeleted?: Maybe<Scalars["Boolean"]>
	label: Label
	projectId: Scalars["String"]
	unitCategoryId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type UnitCategoryInput = {
	configuration: UnitConfigurations
	label: LabelInput
}

export type UnitCategoryMaterialItem = {
	__typename?: "UnitCategoryMaterialItem"
	_id: Scalars["String"]
	areaId?: Maybe<Scalars["String"]>
	builderId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	isDeleted?: Maybe<Scalars["Boolean"]>
	label: Label
	projectId: Scalars["String"]
	unitCategoryId: Scalars["String"]
	updatedAt: Scalars["DateTime"]
}

export type UnitCategoryWithFieldErrorsResponse = {
	__typename?: "UnitCategoryWithFieldErrorsResponse"
	errors?: Maybe<Array<FieldError>>
	unitCategory?: Maybe<UnitCategory>
}

export enum UnitConfigurations {
	Apartment = "Apartment",
	Condo = "Condo",
	Duplex = "Duplex",
	FiveBHK = "FiveBHK",
	FourBHK = "FourBHK",
	OneBHK = "OneBHK",
	Penthouse = "Penthouse",
	StudioApartment = "StudioApartment",
	ThreeBHK = "ThreeBHK",
	Townhouse = "Townhouse",
	Triplex = "Triplex",
	TwoBHK = "TwoBHK",
	Unknown = "Unknown",
	Villa = "Villa",
}

export type UnitGroup = {
	__typename?: "UnitGroup"
	_id: Scalars["String"]
	builderId: Scalars["String"]
	createdAt: Scalars["DateTime"]
	isDeleted?: Maybe<Scalars["Boolean"]>
	label: Label
	projectId: Scalars["String"]
	units: Array<GroupedUnits>
	updatedAt: Scalars["DateTime"]
}

export type UnitGroupInput = {
	label: LabelInput
	units: Array<GroupedUnitsInput>
}

export type UnitGroupWithFieldErrorsResponse = {
	__typename?: "UnitGroupWithFieldErrorsResponse"
	errors?: Maybe<Array<FieldError>>
	unitGroup?: Maybe<UnitGroup>
}

export type UnitInput = {
	configuration: UnitConfigurations
	label: LabelInput
}

export type UnitLayout = {
	__typename?: "UnitLayout"
	_id: Scalars["String"]
	areaCoordinates?: Maybe<Array<LayoutAreaCoordinates>>
	key: Scalars["String"]
	url: Scalars["String"]
}

export type UnitWithFieldErrorsResponse = {
	__typename?: "UnitWithFieldErrorsResponse"
	errors?: Maybe<Array<FieldError>>
	unit?: Maybe<Unit>
}

export type UpdateIssueInput = {
	areaId: Scalars["String"]
	element: Elements
	isCritical?: InputMaybe<Scalars["Boolean"]>
	label: LabelInput
	severity: IssueSeverity
}

export type UpdateUserInput = {
	address?: InputMaybe<AddressInput>
	name: Scalars["String"]
	phone?: InputMaybe<PhoneInput>
}

export type UpdateWorkInProgressItemInput = {
	areaId: Scalars["String"]
	element: Elements
	estimatedDeadline: Scalars["DateTime"]
	label: LabelInput
	status: WorkInProgressItemStatus
}

export type UploadSignatureResponse = {
	__typename?: "UploadSignatureResponse"
	key: Scalars["String"]
	signedUrl: Scalars["String"]
}

export type User = {
	__typename?: "User"
	_id: Scalars["String"]
	address?: Maybe<Address>
	builderId?: Maybe<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	email: Email
	fcmTokens?: Maybe<Array<Scalars["String"]>>
	isDeleted?: Maybe<Scalars["Boolean"]>
	linkedElements?: Maybe<Array<Elements>>
	name: Scalars["String"]
	phone?: Maybe<Phone>
	picture?: Maybe<Picture>
	type: UserTypes
	updatedAt: Scalars["DateTime"]
}

export type UserAuthResponse = {
	__typename?: "UserAuthResponse"
	errors?: Maybe<Array<FieldError>>
	sessionToken?: Maybe<Scalars["String"]>
	user?: Maybe<User>
}

export type UserInput = {
	address?: InputMaybe<AddressInput>
	email: EmailInput
	name: Scalars["String"]
	phone?: InputMaybe<PhoneInput>
}

export enum UserTypes {
	Admin = "Admin",
	BuilderAdmin = "BuilderAdmin",
	Contractor = "Contractor",
	Inspector = "Inspector",
	Unknown = "Unknown",
}

export type UserWithFieldErrorsResponse = {
	__typename?: "UserWithFieldErrorsResponse"
	errors?: Maybe<Array<FieldError>>
	user?: Maybe<User>
}

export type WaterQuality = {
	__typename?: "WaterQuality"
	_id: Scalars["String"]
	builderRemarks?: Maybe<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	internalRemarks?: Maybe<Scalars["String"]>
	isBuilderApproved?: Maybe<Scalars["Boolean"]>
	isInternalApproved?: Maybe<Scalars["Boolean"]>
	isReInspected?: Maybe<Scalars["Boolean"]>
	ph: Scalars["Float"]
	tds: Scalars["Float"]
	updatedAt: Scalars["DateTime"]
}

export type WaterQualityInput = {
	ph: Scalars["Float"]
	tds: Scalars["Float"]
}

export type WorkInProgressItem = {
	__typename?: "WorkInProgressItem"
	_id: Scalars["String"]
	areaId: Scalars["String"]
	builderRemarks?: Maybe<Scalars["String"]>
	createdAt: Scalars["DateTime"]
	element: Elements
	estimatedDeadline: Scalars["DateTime"]
	internalRemarks?: Maybe<Scalars["String"]>
	isBuilderApproved?: Maybe<Scalars["Boolean"]>
	isCopiedFromPreSnagging?: Maybe<Scalars["Boolean"]>
	isInternalApproved?: Maybe<Scalars["Boolean"]>
	isReInspected?: Maybe<Scalars["Boolean"]>
	label: Label
	picture: Picture
	postSnaggingPicture?: Maybe<Picture>
	postSnaggingStatus?: Maybe<WorkInProgressItemStatus>
	status: WorkInProgressItemStatus
	updatedAt: Scalars["DateTime"]
}

export type WorkInProgressItemInput = {
	areaId: Scalars["String"]
	element: Elements
	estimatedDeadline: Scalars["DateTime"]
	label: LabelInput
	pictureKey: Scalars["String"]
	status: WorkInProgressItemStatus
}

export enum WorkInProgressItemStatus {
	Done = "Done",
	InProgress = "InProgress",
	Pending = "Pending",
}

export type AddressFragment = { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }

export type AreaFragment = {
	__typename?: "Area"
	_id: string
	type: AreaTypes
	elements: Array<Elements>
	coordinatesOnUnitLayout?: Array<number> | null
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
}

export type AreaDimensionsFragment = {
	__typename?: "AreaDimensions"
	_id: string
	areaId: string
	isInternalApproved?: boolean | null
	internalRemarks?: string | null
	isBuilderApproved?: boolean | null
	builderRemarks?: string | null
	isReInspected?: boolean | null
	rects: Array<{
		__typename?: "RectDimensions"
		length: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		width: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
	}>
	length: {
		__typename?: "Dimension"
		unit: DimensionUnits
		value: number
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
	}
	width: {
		__typename?: "Dimension"
		unit: DimensionUnits
		value: number
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
	}
	height: {
		__typename?: "Dimension"
		unit: DimensionUnits
		value: number
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
	}
	area: {
		__typename?: "Dimension"
		unit: DimensionUnits
		value: number
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
	}
	additionalArea?: {
		__typename?: "Dimension"
		unit: DimensionUnits
		value: number
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
	} | null
}

export type BlockFragment = { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }

export type BlockLayoutFragment = {
	__typename?: "BlockLayout"
	_id: string
	builderId: string
	projectId: string
	clusterId: string
	blockId: string
	rows: number
	columns: number
	matrixUnitIds?: any | null
	createdAt: any
	updatedAt: any
}

export type BlockLayoutWithFieldErrorsResponseFragment = {
	__typename?: "BlockLayoutWithFieldErrorsResponse"
	errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
	blockLayout?: { __typename?: "BlockLayout"; _id: string; builderId: string; projectId: string; clusterId: string; blockId: string; rows: number; columns: number; matrixUnitIds?: any | null; createdAt: any; updatedAt: any } | null
}

export type BlockWithFieldErrorsResponseFragment = {
	__typename?: "BlockWithFieldErrorsResponse"
	errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
	block?: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } } | null
}

export type BrandCheckFragment = {
	__typename?: "BrandCheck"
	_id: string
	areaId?: string | null
	brandItemId: string
	isOk?: boolean | null
	remarks?: string | null
	isInternalApproved?: boolean | null
	internalRemarks?: string | null
	isBuilderApproved?: boolean | null
	builderRemarks?: string | null
	isReInspected?: boolean | null
	brandItem: {
		__typename?: "BrandItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type BrandItemFragment = {
	__typename?: "BrandItem"
	_id: string
	builderId: string
	projectId: string
	clusterId: string
	blockId: string
	unitId: string
	areaId?: string | null
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
}

export type BuilderFragment = {
	__typename?: "Builder"
	_id: string
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
	picture?: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	} | null
}

export type BuilderWithFieldErrorsResponseFragment = {
	__typename?: "BuilderWithFieldErrorsResponse"
	errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
	builder?: {
		__typename?: "Builder"
		_id: string
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	} | null
}

export type ClusterFragment = { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }

export type ClusterWithFieldErrorsResponseFragment = {
	__typename?: "ClusterWithFieldErrorsResponse"
	errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
	cluster?: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } } | null
}

export type CoordinatesFragment = { __typename?: "Coordinates"; x: number; y: number }

export type DimensionFragment = {
	__typename?: "Dimension"
	unit: DimensionUnits
	value: number
	isInternalApproved?: boolean | null
	internalRemarks?: string | null
	isBuilderApproved?: boolean | null
	builderRemarks?: string | null
	isReInspected?: boolean | null
}

export type ElementAndSeverityWiseIssuesFragment = {
	__typename?: "ElementAndSeverityWiseIssues"
	_id: string
	element: string
	cosmeticIssueIds: Array<string>
	minorIssueIds: Array<string>
	majorIssueIds: Array<string>
	createdAt: any
	updatedAt: any
}

export type ElementAndSeverityWiseIssuesStatsFragment = {
	__typename?: "ElementAndSeverityWiseIssuesStats"
	_id: string
	builderId: string
	unitId: string
	createdAt: any
	updatedAt: any
	elements: Array<{ __typename?: "ElementAndSeverityWiseIssues"; _id: string; element: string; cosmeticIssueIds: Array<string>; minorIssueIds: Array<string>; majorIssueIds: Array<string>; createdAt: any; updatedAt: any }>
}

export type ElementWiseRectificationFragment = {
	__typename?: "ElementWiseRectification"
	element: Elements
	contractorId: string
	status: RectificationStatus
	contractor: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
	issues: Array<{
		__typename?: "RectificationIssue"
		_id: string
		areaId: string
		element: Elements
		severity: IssueSeverity
		isCritical?: boolean | null
		isRectified?: boolean | null
		rectificationRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		offlineHash?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		}
		additionalPicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
		rectificationPicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}>
}

export type EmailFragment = { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }

export type FieldErrorFragment = { __typename?: "FieldError"; field: string; error: string }

export type GroupedUnitsFragment = {
	__typename?: "GroupedUnits"
	_id: string
	unitCategoryId: string
	clusterId: string
	blockId: string
	unitIds: Array<string>
	unitCategory: {
		__typename?: "UnitCategory"
		_id: string
		builderId: string
		projectId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
	}
	cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
	block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
	units: Array<{
		__typename?: "Unit"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
		customerInspectionTemplatePicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}>
}

export type InspectionFragment = {
	__typename?: "Inspection"
	_id: string
	builderId: string
	projectId: string
	clusterId: string
	blockId: string
	unitId: string
	inspectorId: string
	internalReviewerId: string
	builderReviewerId: string
	status: InspectionStatus
	type: InspectionTypes
	preSnaggingInspectionId?: string | null
	postSnaggingInspectionId?: string | null
	postSnaggingInspectionStatus?: InspectionStatus | null
	rectificationId?: string | null
	rectificationStatus?: RectificationStatus | null
	createdAt: any
	updatedAt: any
	project: {
		__typename?: "Project"
		_id: string
		builderId: string
		type: ProjectTypes
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
	}
	block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
	cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
	unit: {
		__typename?: "Unit"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
		customerInspectionTemplatePicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	builder: {
		__typename?: "Builder"
		_id: string
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	inspector: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	internalReviewer: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	builderReviewer: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
	unitArea: {
		__typename?: "Dimension"
		unit: DimensionUnits
		value: number
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
	}
	reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
	waterQuality: {
		__typename?: "WaterQuality"
		_id: string
		ph: number
		tds: number
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
	}
	reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
	dimensions: Array<{
		__typename?: "AreaDimensions"
		_id: string
		areaId: string
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
		rects: Array<{
			__typename?: "RectDimensions"
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
		}>
		length: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		width: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		height: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		area: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		additionalArea?: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		} | null
	}>
	reviewedDimensions?: Array<{
		__typename?: "ReviewedAreaDimensions"
		_id: string
		areaId: string
		rects: Array<{
			__typename?: "ReviewedRectDimensions"
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
		}>
		length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
		width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
		height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
		area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
		additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
	}> | null
	brandChecks: Array<{
		__typename?: "BrandCheck"
		_id: string
		areaId?: string | null
		brandItemId: string
		isOk?: boolean | null
		remarks?: string | null
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
		brandItem: {
			__typename?: "BrandItem"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			areaId?: string | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}
	}>
	reviewedBrandChecks?: Array<{
		__typename?: "ReviewedBrandCheck"
		_id: string
		areaId?: string | null
		brandItemId: string
		isOk?: boolean | null
		remarks?: string | null
		brandItem: {
			__typename?: "BrandItem"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			areaId?: string | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}
	}> | null
	materialChecks: Array<{
		__typename?: "MaterialCheck"
		_id: string
		areaId?: string | null
		materialItemId: string
		isOk?: boolean | null
		remarks?: string | null
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
		materialItem: {
			__typename?: "MaterialItem"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			areaId?: string | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}
	}>
	reviewedMaterialChecks?: Array<{
		__typename?: "ReviewedMaterialCheck"
		_id: string
		areaId?: string | null
		materialItemId: string
		isOk?: boolean | null
		remarks?: string | null
		materialItem: {
			__typename?: "MaterialItem"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			areaId?: string | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}
	}> | null
	issues?: Array<{
		__typename?: "Issue"
		_id: string
		areaId: string
		element: Elements
		severity: IssueSeverity
		isCritical?: boolean | null
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
		isCopiedFromPreSnagging?: boolean | null
		postSnaggingStatus?: IssuePostSnaggingStatus | null
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		}
		additionalPicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
		postSnaggingPicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}> | null
	reviewedIssues?: Array<{
		__typename?: "ReviewedIssue"
		_id: string
		areaId: string
		element: Elements
		severity: IssueSeverity
		isCritical?: boolean | null
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		}
	}> | null
	workInProgressItems?: Array<{
		__typename?: "WorkInProgressItem"
		_id: string
		areaId: string
		element: Elements
		status: WorkInProgressItemStatus
		estimatedDeadline: any
		isInternalApproved?: boolean | null
		internalRemarks?: string | null
		isBuilderApproved?: boolean | null
		builderRemarks?: string | null
		isReInspected?: boolean | null
		isCopiedFromPreSnagging?: boolean | null
		postSnaggingStatus?: WorkInProgressItemStatus | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		}
		postSnaggingPicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}> | null
	reviewedWorkInProgressItems?: Array<{
		__typename?: "ReviewedWorkInProgressItem"
		_id: string
		areaId: string
		element: Elements
		status: WorkInProgressItemStatus
		estimatedDeadline: any
		isCopiedFromPreSnagging?: boolean | null
		postSnaggingStatus?: WorkInProgressItemStatus | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		}
		postSnaggingPicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}> | null
	postSnaggingInspectionRequest?: {
		__typename?: "PostSnaggingInspectionRequest"
		status: PostSnaggingInspectionRequestStatus
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
	} | null
}

export type IssueFragment = {
	__typename?: "Issue"
	_id: string
	areaId: string
	element: Elements
	severity: IssueSeverity
	isCritical?: boolean | null
	isInternalApproved?: boolean | null
	internalRemarks?: string | null
	isBuilderApproved?: boolean | null
	builderRemarks?: string | null
	isReInspected?: boolean | null
	isCopiedFromPreSnagging?: boolean | null
	postSnaggingStatus?: IssuePostSnaggingStatus | null
	label: { __typename?: "Label"; name: string; description?: string | null }
	picture: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	}
	additionalPicture?: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	} | null
	postSnaggingPicture?: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	} | null
}

export type IssueItemFragment = { __typename?: "IssueItem"; _id: string; issue: string; createdAt: any; updatedAt: any }

export type IssueTemplateFragment = {
	__typename?: "IssueTemplate"
	_id: string
	element: Elements
	areaType?: AreaTypes | null
	severity: IssueSeverity
	label: { __typename?: "Label"; name: string; description?: string | null }
	issue: { __typename?: "Label"; name: string; description?: string | null }
}

export type LabelFragment = { __typename?: "Label"; name: string; description?: string | null }

export type LayoutAreaCoordinatesFragment = { __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }

export type MaterialCheckFragment = {
	__typename?: "MaterialCheck"
	_id: string
	areaId?: string | null
	materialItemId: string
	isOk?: boolean | null
	remarks?: string | null
	isInternalApproved?: boolean | null
	internalRemarks?: string | null
	isBuilderApproved?: boolean | null
	builderRemarks?: string | null
	isReInspected?: boolean | null
	materialItem: {
		__typename?: "MaterialItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type MaterialItemFragment = {
	__typename?: "MaterialItem"
	_id: string
	builderId: string
	projectId: string
	clusterId: string
	blockId: string
	unitId: string
	areaId?: string | null
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
}

export type PhoneFragment = { __typename?: "Phone"; countryCode: string; number: string }

export type PictureFragment = {
	__typename?: "Picture"
	original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
	variants?: {
		__typename?: "PictureVariants"
		small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
	} | null
}

export type PictureObjectFragment = { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }

export type PostSnaggingInspectionRequestFragment = {
	__typename?: "PostSnaggingInspectionRequest"
	status: PostSnaggingInspectionRequestStatus
	statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
}

export type ProjectFragment = {
	__typename?: "Project"
	_id: string
	builderId: string
	type: ProjectTypes
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
	address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
}

export type ProjectAndSeverityWiseIssuesStatsFragment = {
	__typename?: "ProjectAndSeverityWiseIssuesStats"
	_id: string
	builderId: string
	projectId: string
	unitId: string
	cosmeticIssueIds: Array<string>
	minorIssueIds: Array<string>
	majorIssueIds: Array<string>
	createdAt: any
	updatedAt: any
	project: {
		__typename?: "Project"
		_id: string
		builderId: string
		type: ProjectTypes
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
	}
}

export type ProjectAndStatusWiseInspectionsStatsFragment = {
	__typename?: "ProjectAndStatusWiseInspectionsStats"
	_id: string
	builderId: string
	projectId: string
	createdAt: any
	updatedAt: any
	project: {
		__typename?: "Project"
		_id: string
		builderId: string
		type: ProjectTypes
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
	}
	statusWiseUnits: Array<{ __typename?: "UnitAndInspectionStatus"; unitId: string; status: InspectionStatus }>
}

export type ProjectWithFieldErrorsResponseFragment = {
	__typename?: "ProjectWithFieldErrorsResponse"
	errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
	project?: {
		__typename?: "Project"
		_id: string
		builderId: string
		type: ProjectTypes
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
	} | null
}

export type RectificationFragment = {
	__typename?: "Rectification"
	_id: string
	builderId: string
	projectId: string
	clusterId: string
	blockId: string
	unitId: string
	builderReviewerId: string
	preSnaggingInspectionId: string
	contractorIds: Array<string>
	status: RectificationStatus
	isDeleted?: boolean | null
	createdAt: any
	updatedAt: any
	builder: {
		__typename?: "Builder"
		_id: string
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	project: {
		__typename?: "Project"
		_id: string
		builderId: string
		type: ProjectTypes
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
	}
	cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
	block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
	unit: {
		__typename?: "Unit"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
		customerInspectionTemplatePicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	builderReviewer: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	preSnaggingInspection: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
	elementWiseRectifications: Array<{
		__typename?: "ElementWiseRectification"
		element: Elements
		contractorId: string
		status: RectificationStatus
		contractor: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		issues: Array<{
			__typename?: "RectificationIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isRectified?: boolean | null
			rectificationRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			offlineHash?: string | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			rectificationPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}>
	}>
	statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
}

export type RectificationIssueFragment = {
	__typename?: "RectificationIssue"
	_id: string
	areaId: string
	element: Elements
	severity: IssueSeverity
	isCritical?: boolean | null
	isRectified?: boolean | null
	rectificationRemarks?: string | null
	isBuilderApproved?: boolean | null
	builderRemarks?: string | null
	offlineHash?: string | null
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
	picture: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	}
	additionalPicture?: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	} | null
	rectificationPicture?: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	} | null
}

export type ReferenceFragment = { __typename?: "Reference"; _id: string; type: ReferenceTypes }

export type ReportFragment = {
	__typename?: "Report"
	_id: string
	publicId: string
	type: ReportTypes
	builderId: string
	projectId: string
	clusterId: string
	blockId: string
	unitId: string
	inspectorId: string
	inspectionId: string
	createdAt: any
	updatedAt: any
	builder: {
		__typename?: "Builder"
		_id: string
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
	block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
	unit: {
		__typename?: "Unit"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
		customerInspectionTemplatePicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	inspector: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	inspection: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
	reports: Array<{ __typename?: "ReportObject"; _id: string; type: ReportPartTypes; element?: Elements | null; key: string; url: string; label: { __typename?: "Label"; name: string; description?: string | null } }>
}

export type ReportObjectFragment = { __typename?: "ReportObject"; _id: string; type: ReportPartTypes; element?: Elements | null; key: string; url: string; label: { __typename?: "Label"; name: string; description?: string | null } }

export type ReviewedAreaDimensionsFragment = {
	__typename?: "ReviewedAreaDimensions"
	_id: string
	areaId: string
	rects: Array<{
		__typename?: "ReviewedRectDimensions"
		length: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		width: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
	}>
	length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
	width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
	height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
	area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
	additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
}

export type ReviewedBrandCheckFragment = {
	__typename?: "ReviewedBrandCheck"
	_id: string
	areaId?: string | null
	brandItemId: string
	isOk?: boolean | null
	remarks?: string | null
	brandItem: {
		__typename?: "BrandItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type ReviewedDimensionFragment = { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }

export type ReviewedIssueFragment = {
	__typename?: "ReviewedIssue"
	_id: string
	areaId: string
	element: Elements
	severity: IssueSeverity
	isCritical?: boolean | null
	label: { __typename?: "Label"; name: string; description?: string | null }
	picture: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	}
}

export type ReviewedMaterialCheckFragment = {
	__typename?: "ReviewedMaterialCheck"
	_id: string
	areaId?: string | null
	materialItemId: string
	isOk?: boolean | null
	remarks?: string | null
	materialItem: {
		__typename?: "MaterialItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type ReviewedWaterQualityFragment = { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number }

export type ReviewedWorkInProgressItemFragment = {
	__typename?: "ReviewedWorkInProgressItem"
	_id: string
	areaId: string
	element: Elements
	status: WorkInProgressItemStatus
	estimatedDeadline: any
	isCopiedFromPreSnagging?: boolean | null
	postSnaggingStatus?: WorkInProgressItemStatus | null
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
	picture: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	}
	postSnaggingPicture?: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	} | null
}

export type ServiceFragment = {
	__typename?: "Service"
	_id: string
	key: string
	lastHeartbeatAt?: any | null
	isActive?: boolean | null
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
}

export type StatusLifecycleFragment = { __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }

export type StatusWiseInspectionsStatsFragment = {
	__typename?: "StatusWiseInspectionsStats"
	_id: string
	builderId: string
	createdAt: any
	updatedAt: any
	statusWiseUnits: Array<{ __typename?: "UnitAndInspectionStatus"; unitId: string; status: InspectionStatus }>
	builder: {
		__typename?: "Builder"
		_id: string
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
}

export type UnitFragment = {
	__typename?: "Unit"
	_id: string
	builderId: string
	projectId: string
	clusterId: string
	blockId: string
	configuration: UnitConfigurations
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
	areas?: Array<{
		__typename?: "Area"
		_id: string
		type: AreaTypes
		elements: Array<Elements>
		coordinatesOnUnitLayout?: Array<number> | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}> | null
	layout?: {
		__typename?: "UnitLayout"
		_id: string
		key: string
		url: string
		areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
	} | null
	customerInspectionTemplatePicture?: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	} | null
}

export type UnitAndInspectionStatusFragment = { __typename?: "UnitAndInspectionStatus"; unitId: string; status: InspectionStatus }

export type UnitCategoryFragment = {
	__typename?: "UnitCategory"
	_id: string
	builderId: string
	projectId: string
	configuration: UnitConfigurations
	createdAt: any
	updatedAt: any
	builder: {
		__typename?: "Builder"
		_id: string
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
	project: {
		__typename?: "Project"
		_id: string
		builderId: string
		type: ProjectTypes
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
	}
	label: { __typename?: "Label"; name: string; description?: string | null }
	areas?: Array<{
		__typename?: "Area"
		_id: string
		type: AreaTypes
		elements: Array<Elements>
		coordinatesOnUnitLayout?: Array<number> | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}> | null
	layout?: {
		__typename?: "UnitLayout"
		_id: string
		key: string
		url: string
		areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
	} | null
}

export type UnitCategoryBrandItemFragment = {
	__typename?: "UnitCategoryBrandItem"
	_id: string
	builderId: string
	projectId: string
	unitCategoryId: string
	areaId?: string | null
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
}

export type UnitCategoryMaterialItemFragment = {
	__typename?: "UnitCategoryMaterialItem"
	_id: string
	builderId: string
	projectId: string
	unitCategoryId: string
	areaId?: string | null
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
}

export type UnitGroupFragment = {
	__typename?: "UnitGroup"
	_id: string
	builderId: string
	projectId: string
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
	units: Array<{
		__typename?: "GroupedUnits"
		_id: string
		unitCategoryId: string
		clusterId: string
		blockId: string
		unitIds: Array<string>
		unitCategory: {
			__typename?: "UnitCategory"
			_id: string
			builderId: string
			projectId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
		}
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		units: Array<{
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}>
	}>
}

export type UnitWithFieldErrorsResponseFragment = {
	__typename?: "UnitWithFieldErrorsResponse"
	errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
	unit?: {
		__typename?: "Unit"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
		customerInspectionTemplatePicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	} | null
}

export type UploadSignatureResponseFragment = { __typename?: "UploadSignatureResponse"; signedUrl: string; key: string }

export type UserFragment = {
	__typename?: "User"
	_id: string
	builderId?: string | null
	type: UserTypes
	name: string
	linkedElements?: Array<Elements> | null
	createdAt: any
	updatedAt: any
	email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
	phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
	address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
	picture?: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	} | null
}

export type UserAuthResponseFragment = {
	__typename?: "UserAuthResponse"
	user?: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	} | null
	errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
}

export type UserWithFieldErrorsResponseFragment = {
	__typename?: "UserWithFieldErrorsResponse"
	errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
	user?: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	} | null
}

export type WaterQualityFragment = {
	__typename?: "WaterQuality"
	_id: string
	ph: number
	tds: number
	isInternalApproved?: boolean | null
	internalRemarks?: string | null
	isBuilderApproved?: boolean | null
	builderRemarks?: string | null
	isReInspected?: boolean | null
}

export type WorkInProgressItemFragment = {
	__typename?: "WorkInProgressItem"
	_id: string
	areaId: string
	element: Elements
	status: WorkInProgressItemStatus
	estimatedDeadline: any
	isInternalApproved?: boolean | null
	internalRemarks?: string | null
	isBuilderApproved?: boolean | null
	builderRemarks?: string | null
	isReInspected?: boolean | null
	isCopiedFromPreSnagging?: boolean | null
	postSnaggingStatus?: WorkInProgressItemStatus | null
	createdAt: any
	updatedAt: any
	label: { __typename?: "Label"; name: string; description?: string | null }
	picture: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	}
	postSnaggingPicture?: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	} | null
}

export type UpdateInternalReviewerofInspectionMutationVariables = Exact<{
	internalReviewerId: Scalars["String"]
	inspectionId: Scalars["String"]
}>

export type UpdateInternalReviewerofInspectionMutation = {
	__typename?: "Mutation"
	updateInternalReviewerofInspection: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type AddAdditionalIssuePictureMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
	pictureKey: Scalars["String"]
}>

export type AddAdditionalIssuePictureMutation = {
	__typename?: "Mutation"
	addAdditionalIssuePicture: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type AddAreaCoordinatesOnUnitCategoryLayoutMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	areaId: Scalars["String"]
	coordinates: CoordinatesInput
}>

export type AddAreaCoordinatesOnUnitCategoryLayoutMutation = {
	__typename?: "Mutation"
	addAreaCoordinatesOnUnitCategoryLayout: {
		__typename?: "UnitCategory"
		_id: string
		builderId: string
		projectId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
	}
}

export type AddAreaCoordinatesOnUnitLayoutMutationVariables = Exact<{
	unitId: Scalars["String"]
	areaId: Scalars["String"]
	coordinates: CoordinatesInput
}>

export type AddAreaCoordinatesOnUnitLayoutMutation = {
	__typename?: "Mutation"
	addAreaCoordinatesOnUnitLayout: {
		__typename?: "Unit"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
		customerInspectionTemplatePicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
}

export type AddContractorToBuilderMutationVariables = Exact<{
	builderId: Scalars["String"]
	contractorId: Scalars["String"]
}>

export type AddContractorToBuilderMutation = {
	__typename?: "Mutation"
	addContractorToBuilder: {
		__typename?: "Builder"
		_id: string
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
}

export type AddIssueMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	areaId: Scalars["String"]
	element: Elements
	input: IssueInput
}>

export type AddIssueMutation = {
	__typename?: "Mutation"
	addIssue: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type AddWaterQualityMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	input: WaterQualityInput
}>

export type AddWaterQualityMutation = {
	__typename?: "Mutation"
	addWaterQuality: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type AssignBrandItemToAreaMutationVariables = Exact<{
	brandItemId: Scalars["String"]
	areaId: Scalars["String"]
}>

export type AssignBrandItemToAreaMutation = {
	__typename?: "Mutation"
	assignBrandItemToArea: {
		__typename?: "BrandItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type AssignMaterialItemToAreaMutationVariables = Exact<{
	materialItemId: Scalars["String"]
	areaId: Scalars["String"]
}>

export type AssignMaterialItemToAreaMutation = {
	__typename?: "Mutation"
	assignMaterialItemToArea: {
		__typename?: "MaterialItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type AssignUnitCategoryBrandItemToAreaMutationVariables = Exact<{
	brandItemId: Scalars["String"]
	areaId: Scalars["String"]
}>

export type AssignUnitCategoryBrandItemToAreaMutation = {
	__typename?: "Mutation"
	assignUnitCategoryBrandItemToArea: {
		__typename?: "UnitCategoryBrandItem"
		_id: string
		builderId: string
		projectId: string
		unitCategoryId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type AssignUnitCategoryMaterialItemToAreaMutationVariables = Exact<{
	materialItemId: Scalars["String"]
	areaId: Scalars["String"]
}>

export type AssignUnitCategoryMaterialItemToAreaMutation = {
	__typename?: "Mutation"
	assignUnitCategoryMaterialItemToArea: {
		__typename?: "UnitCategoryMaterialItem"
		_id: string
		builderId: string
		projectId: string
		unitCategoryId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type BuilderApproveAreaDimensionMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	areaDimensionId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type BuilderApproveAreaDimensionMutation = {
	__typename?: "Mutation"
	builderApproveAreaDimension: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type BuilderApproveBrandCheckMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	brandCheckId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type BuilderApproveBrandCheckMutation = {
	__typename?: "Mutation"
	builderApproveBrandCheck: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type BuilderApproveIssueMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type BuilderApproveIssueMutation = {
	__typename?: "Mutation"
	builderApproveIssue: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type BuilderApproveMaterialCheckMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	materialCheckId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type BuilderApproveMaterialCheckMutation = {
	__typename?: "Mutation"
	builderApproveMaterialCheck: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type BuilderApproveUnitAreaMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type BuilderApproveUnitAreaMutation = {
	__typename?: "Mutation"
	builderApproveUnitArea: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type BuilderApproveWaterQualityMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type BuilderApproveWaterQualityMutation = {
	__typename?: "Mutation"
	builderApproveWaterQuality: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type BuilderApproveWorkInProgressItemMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	itemId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type BuilderApproveWorkInProgressItemMutation = {
	__typename?: "Mutation"
	builderApproveWorkInProgressItem: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type BuilderReviewIssueRectificationMutationVariables = Exact<{
	rectificationId: Scalars["String"]
	element: Elements
	issueId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type BuilderReviewIssueRectificationMutation = {
	__typename?: "Mutation"
	builderReviewIssueRectification: {
		__typename?: "Rectification"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		builderReviewerId: string
		preSnaggingInspectionId: string
		contractorIds: Array<string>
		status: RectificationStatus
		isDeleted?: boolean | null
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		preSnaggingInspection: {
			__typename?: "Inspection"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			inspectorId: string
			internalReviewerId: string
			builderReviewerId: string
			status: InspectionStatus
			type: InspectionTypes
			preSnaggingInspectionId?: string | null
			postSnaggingInspectionId?: string | null
			postSnaggingInspectionStatus?: InspectionStatus | null
			rectificationId?: string | null
			rectificationStatus?: RectificationStatus | null
			createdAt: any
			updatedAt: any
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			unit: {
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			inspector: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			internalReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builderReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			unitArea: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			waterQuality: {
				__typename?: "WaterQuality"
				_id: string
				ph: number
				tds: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
			dimensions: Array<{
				__typename?: "AreaDimensions"
				_id: string
				areaId: string
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				rects: Array<{
					__typename?: "RectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				height: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				area: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				additionalArea?: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				} | null
			}>
			reviewedDimensions?: Array<{
				__typename?: "ReviewedAreaDimensions"
				_id: string
				areaId: string
				rects: Array<{
					__typename?: "ReviewedRectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			}> | null
			brandChecks: Array<{
				__typename?: "BrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedBrandChecks?: Array<{
				__typename?: "ReviewedBrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			materialChecks: Array<{
				__typename?: "MaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedMaterialChecks?: Array<{
				__typename?: "ReviewedMaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			issues?: Array<{
				__typename?: "Issue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: IssuePostSnaggingStatus | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedIssues?: Array<{
				__typename?: "ReviewedIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
			}> | null
			workInProgressItems?: Array<{
				__typename?: "WorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedWorkInProgressItems?: Array<{
				__typename?: "ReviewedWorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			postSnaggingInspectionRequest?: {
				__typename?: "PostSnaggingInspectionRequest"
				status: PostSnaggingInspectionRequestStatus
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			} | null
		}
		elementWiseRectifications: Array<{
			__typename?: "ElementWiseRectification"
			element: Elements
			contractorId: string
			status: RectificationStatus
			contractor: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			issues: Array<{
				__typename?: "RectificationIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isRectified?: boolean | null
				rectificationRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				offlineHash?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				rectificationPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}>
		}>
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
	}
}

export type CreateAdminMutationVariables = Exact<{
	input: UserInput
}>

export type CreateAdminMutation = {
	__typename?: "Mutation"
	createAdmin: {
		__typename?: "UserWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		user?: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
	}
}

export type CreateAreaMutationVariables = Exact<{
	unitId: Scalars["String"]
	input: AreaInput
}>

export type CreateAreaMutation = {
	__typename?: "Mutation"
	createArea: {
		__typename?: "Area"
		_id: string
		type: AreaTypes
		elements: Array<Elements>
		coordinatesOnUnitLayout?: Array<number> | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type CreateBlockMutationVariables = Exact<{
	clusterId: Scalars["String"]
	input: BlockInput
}>

export type CreateBlockMutation = {
	__typename?: "Mutation"
	createBlock: {
		__typename?: "BlockWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		block?: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } } | null
	}
}

export type CreateBlockLayoutMutationVariables = Exact<{
	blockId: Scalars["String"]
	rows: Scalars["Int"]
	columns: Scalars["Int"]
}>

export type CreateBlockLayoutMutation = {
	__typename?: "Mutation"
	createBlockLayout: {
		__typename?: "BlockLayoutWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		blockLayout?: { __typename?: "BlockLayout"; _id: string; builderId: string; projectId: string; clusterId: string; blockId: string; rows: number; columns: number; matrixUnitIds?: any | null; createdAt: any; updatedAt: any } | null
	}
}

export type CreateBrandItemsMutationVariables = Exact<{
	unitId: Scalars["String"]
	areaId?: InputMaybe<Scalars["String"]>
	input: BrandItemInput
	quantity: Scalars["Int"]
}>

export type CreateBrandItemsMutation = {
	__typename?: "Mutation"
	createBrandItems: Array<{
		__typename?: "BrandItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}>
}

export type CreateBuilderMutationVariables = Exact<{
	input: BuilderInput
}>

export type CreateBuilderMutation = {
	__typename?: "Mutation"
	createBuilder: {
		__typename?: "BuilderWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		builder?: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
	}
}

export type CreateBuilderAdminMutationVariables = Exact<{
	builderId: Scalars["String"]
	input: UserInput
}>

export type CreateBuilderAdminMutation = {
	__typename?: "Mutation"
	createBuilderAdmin: {
		__typename?: "UserWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		user?: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
	}
}

export type CreateClusterMutationVariables = Exact<{
	projectId: Scalars["String"]
	input: ClusterInput
}>

export type CreateClusterMutation = {
	__typename?: "Mutation"
	createCluster: {
		__typename?: "ClusterWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		cluster?: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } } | null
	}
}

export type CreateContractorMutationVariables = Exact<{
	input: UserInput
	linkedElements: Array<Elements> | Elements
}>

export type CreateContractorMutation = {
	__typename?: "Mutation"
	createContractor: {
		__typename?: "UserWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		user?: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
	}
}

export type CreateElementMutationVariables = Exact<{
	unitId: Scalars["String"]
	areaId: Scalars["String"]
	element: Elements
}>

export type CreateElementMutation = {
	__typename?: "Mutation"
	createElement: {
		__typename?: "Area"
		_id: string
		type: AreaTypes
		elements: Array<Elements>
		coordinatesOnUnitLayout?: Array<number> | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type CreateInspectionMutationVariables = Exact<{
	unitId: Scalars["String"]
	inspectorId: Scalars["String"]
	type: InspectionTypes
	builderReviewerId: Scalars["String"]
	internalReviewerId: Scalars["String"]
	preSnaggingInspectionId?: InputMaybe<Scalars["String"]>
}>

export type CreateInspectionMutation = {
	__typename?: "Mutation"
	createInspection: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type CreateInspectorMutationVariables = Exact<{
	input: UserInput
}>

export type CreateInspectorMutation = {
	__typename?: "Mutation"
	createInspector: {
		__typename?: "UserWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		user?: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
	}
}

export type CreateMaterialItemsMutationVariables = Exact<{
	unitId: Scalars["String"]
	areaId?: InputMaybe<Scalars["String"]>
	input: MaterialItemInput
	quantity: Scalars["Int"]
}>

export type CreateMaterialItemsMutation = {
	__typename?: "Mutation"
	createMaterialItems: Array<{
		__typename?: "MaterialItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}>
}

export type CreatePostSnaggingInspectionRequestMutationVariables = Exact<{
	inspectionId: Scalars["String"]
}>

export type CreatePostSnaggingInspectionRequestMutation = {
	__typename?: "Mutation"
	createPostSnaggingInspectionRequest: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type CreateProjectMutationVariables = Exact<{
	builderId: Scalars["String"]
	input: ProjectInput
}>

export type CreateProjectMutation = {
	__typename?: "Mutation"
	createProject: {
		__typename?: "ProjectWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		project?: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		} | null
	}
}

export type CreateProjectHeadMutationVariables = Exact<{
	projectId: Scalars["String"]
	userId: Scalars["String"]
}>

export type CreateProjectHeadMutation = {
	__typename?: "Mutation"
	createProjectHead: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
}

export type CreateQualityHeadMutationVariables = Exact<{
	projectId: Scalars["String"]
	userId: Scalars["String"]
}>

export type CreateQualityHeadMutation = {
	__typename?: "Mutation"
	createQualityHead: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
}

export type CreateRectificationMutationVariables = Exact<{
	preSnaggingInspectionId: Scalars["String"]
	builderReviewerId: Scalars["String"]
	elementWiseContractors: Array<ElementWiseContractorInput> | ElementWiseContractorInput
}>

export type CreateRectificationMutation = {
	__typename?: "Mutation"
	createRectification: {
		__typename?: "Rectification"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		builderReviewerId: string
		preSnaggingInspectionId: string
		contractorIds: Array<string>
		status: RectificationStatus
		isDeleted?: boolean | null
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		preSnaggingInspection: {
			__typename?: "Inspection"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			inspectorId: string
			internalReviewerId: string
			builderReviewerId: string
			status: InspectionStatus
			type: InspectionTypes
			preSnaggingInspectionId?: string | null
			postSnaggingInspectionId?: string | null
			postSnaggingInspectionStatus?: InspectionStatus | null
			rectificationId?: string | null
			rectificationStatus?: RectificationStatus | null
			createdAt: any
			updatedAt: any
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			unit: {
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			inspector: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			internalReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builderReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			unitArea: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			waterQuality: {
				__typename?: "WaterQuality"
				_id: string
				ph: number
				tds: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
			dimensions: Array<{
				__typename?: "AreaDimensions"
				_id: string
				areaId: string
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				rects: Array<{
					__typename?: "RectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				height: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				area: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				additionalArea?: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				} | null
			}>
			reviewedDimensions?: Array<{
				__typename?: "ReviewedAreaDimensions"
				_id: string
				areaId: string
				rects: Array<{
					__typename?: "ReviewedRectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			}> | null
			brandChecks: Array<{
				__typename?: "BrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedBrandChecks?: Array<{
				__typename?: "ReviewedBrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			materialChecks: Array<{
				__typename?: "MaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedMaterialChecks?: Array<{
				__typename?: "ReviewedMaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			issues?: Array<{
				__typename?: "Issue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: IssuePostSnaggingStatus | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedIssues?: Array<{
				__typename?: "ReviewedIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
			}> | null
			workInProgressItems?: Array<{
				__typename?: "WorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedWorkInProgressItems?: Array<{
				__typename?: "ReviewedWorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			postSnaggingInspectionRequest?: {
				__typename?: "PostSnaggingInspectionRequest"
				status: PostSnaggingInspectionRequestStatus
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			} | null
		}
		elementWiseRectifications: Array<{
			__typename?: "ElementWiseRectification"
			element: Elements
			contractorId: string
			status: RectificationStatus
			contractor: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			issues: Array<{
				__typename?: "RectificationIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isRectified?: boolean | null
				rectificationRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				offlineHash?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				rectificationPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}>
		}>
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
	}
}

export type CreateUnitMutationVariables = Exact<{
	blockId: Scalars["String"]
	input: UnitInput
}>

export type CreateUnitMutation = {
	__typename?: "Mutation"
	createUnit: {
		__typename?: "UnitWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		unit?: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
	}
}

export type CreateUnitCategoryMutationVariables = Exact<{
	projectId: Scalars["String"]
	input: UnitCategoryInput
}>

export type CreateUnitCategoryMutation = {
	__typename?: "Mutation"
	createUnitCategory: {
		__typename?: "UnitCategoryWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		unitCategory?: {
			__typename?: "UnitCategory"
			_id: string
			builderId: string
			projectId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
		} | null
	}
}

export type CreateUnitCategoryAreaMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	input: AreaInput
}>

export type CreateUnitCategoryAreaMutation = {
	__typename?: "Mutation"
	createUnitCategoryArea: {
		__typename?: "Area"
		_id: string
		type: AreaTypes
		elements: Array<Elements>
		coordinatesOnUnitLayout?: Array<number> | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type CreateUnitCategoryBrandItemsMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	input: BrandItemInput
	quantity: Scalars["Int"]
	areaId?: InputMaybe<Scalars["String"]>
}>

export type CreateUnitCategoryBrandItemsMutation = {
	__typename?: "Mutation"
	createUnitCategoryBrandItems: Array<{
		__typename?: "UnitCategoryBrandItem"
		_id: string
		builderId: string
		projectId: string
		unitCategoryId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}>
}

export type CreateUnitCategoryElementMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	areaId: Scalars["String"]
	element: Elements
}>

export type CreateUnitCategoryElementMutation = {
	__typename?: "Mutation"
	createUnitCategoryElement: {
		__typename?: "Area"
		_id: string
		type: AreaTypes
		elements: Array<Elements>
		coordinatesOnUnitLayout?: Array<number> | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type CreateUnitCategoryMaterialItemsMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	input: MaterialItemInput
	quantity: Scalars["Int"]
	areaId?: InputMaybe<Scalars["String"]>
}>

export type CreateUnitCategoryMaterialItemsMutation = {
	__typename?: "Mutation"
	createUnitCategoryMaterialItems: Array<{
		__typename?: "UnitCategoryMaterialItem"
		_id: string
		builderId: string
		projectId: string
		unitCategoryId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}>
}

export type CreateUnitGroupMutationVariables = Exact<{
	projectId: Scalars["String"]
	input: UnitGroupInput
}>

export type CreateUnitGroupMutation = {
	__typename?: "Mutation"
	createUnitGroup: {
		__typename?: "UnitGroupWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		unitGroup?: {
			__typename?: "UnitGroup"
			_id: string
			builderId: string
			projectId: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			units: Array<{
				__typename?: "GroupedUnits"
				_id: string
				unitCategoryId: string
				clusterId: string
				blockId: string
				unitIds: Array<string>
				unitCategory: {
					__typename?: "UnitCategory"
					_id: string
					builderId: string
					projectId: string
					configuration: UnitConfigurations
					createdAt: any
					updatedAt: any
					builder: {
						__typename?: "Builder"
						_id: string
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
						picture?: {
							__typename?: "Picture"
							original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
							variants?: {
								__typename?: "PictureVariants"
								small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
								medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
								large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
								thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							} | null
						} | null
					}
					project: {
						__typename?: "Project"
						_id: string
						builderId: string
						type: ProjectTypes
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
						address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
					}
					label: { __typename?: "Label"; name: string; description?: string | null }
					areas?: Array<{
						__typename?: "Area"
						_id: string
						type: AreaTypes
						elements: Array<Elements>
						coordinatesOnUnitLayout?: Array<number> | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}> | null
					layout?: {
						__typename?: "UnitLayout"
						_id: string
						key: string
						url: string
						areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
					} | null
				}
				cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
				block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
				units: Array<{
					__typename?: "Unit"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					configuration: UnitConfigurations
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					areas?: Array<{
						__typename?: "Area"
						_id: string
						type: AreaTypes
						elements: Array<Elements>
						coordinatesOnUnitLayout?: Array<number> | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}> | null
					layout?: {
						__typename?: "UnitLayout"
						_id: string
						key: string
						url: string
						areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
					} | null
					customerInspectionTemplatePicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}>
			}>
		} | null
	}
}

export type DeleteAreaMutationVariables = Exact<{
	unitId: Scalars["String"]
	areaId: Scalars["String"]
}>

export type DeleteAreaMutation = { __typename?: "Mutation"; deleteArea: boolean }

export type DeleteBlockMutationVariables = Exact<{
	blockId: Scalars["String"]
}>

export type DeleteBlockMutation = { __typename?: "Mutation"; deleteBlock: boolean }

export type DeleteBlockLayoutMutationVariables = Exact<{
	blockLayoutId: Scalars["String"]
}>

export type DeleteBlockLayoutMutation = { __typename?: "Mutation"; deleteBlockLayout: boolean }

export type DeleteBrandItemMutationVariables = Exact<{
	brandItemId: Scalars["String"]
}>

export type DeleteBrandItemMutation = { __typename?: "Mutation"; deleteBrandItem: boolean }

export type DeleteBuilderMutationVariables = Exact<{
	builderId: Scalars["String"]
}>

export type DeleteBuilderMutation = { __typename?: "Mutation"; deleteBuilder: boolean }

export type DeleteBuilderAdminMutationVariables = Exact<{
	builderAdminId: Scalars["String"]
}>

export type DeleteBuilderAdminMutation = { __typename?: "Mutation"; deleteBuilderAdmin: boolean }

export type DeleteClusterMutationVariables = Exact<{
	clusterId: Scalars["String"]
}>

export type DeleteClusterMutation = { __typename?: "Mutation"; deleteCluster: boolean }

export type DeleteContractorMutationVariables = Exact<{
	contractorId: Scalars["String"]
}>

export type DeleteContractorMutation = { __typename?: "Mutation"; deleteContractor: boolean }

export type DeleteElementMutationVariables = Exact<{
	unitId: Scalars["String"]
	areaId: Scalars["String"]
	element: Elements
}>

export type DeleteElementMutation = { __typename?: "Mutation"; deleteElement: boolean }

export type DeleteInspectionMutationVariables = Exact<{
	inspectionId: Scalars["String"]
}>

export type DeleteInspectionMutation = { __typename?: "Mutation"; deleteInspection: boolean }

export type DeleteInspectorMutationVariables = Exact<{
	inspectorId: Scalars["String"]
}>

export type DeleteInspectorMutation = { __typename?: "Mutation"; deleteInspector: boolean }

export type DeleteIssueMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
}>

export type DeleteIssueMutation = {
	__typename?: "Mutation"
	deleteIssue: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type DeleteMaterialItemMutationVariables = Exact<{
	materialItemId: Scalars["String"]
}>

export type DeleteMaterialItemMutation = { __typename?: "Mutation"; deleteMaterialItem: boolean }

export type DeleteProjectMutationVariables = Exact<{
	projectId: Scalars["String"]
}>

export type DeleteProjectMutation = { __typename?: "Mutation"; deleteProject: boolean }

export type DeleteUnitMutationVariables = Exact<{
	unitId: Scalars["String"]
}>

export type DeleteUnitMutation = { __typename?: "Mutation"; deleteUnit: boolean }

export type DeleteUnitCategoryMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
}>

export type DeleteUnitCategoryMutation = { __typename?: "Mutation"; deleteUnitCategory: boolean }

export type DeleteUnitCategoryAreaMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	areaId: Scalars["String"]
}>

export type DeleteUnitCategoryAreaMutation = { __typename?: "Mutation"; deleteUnitCategoryArea: boolean }

export type DeleteUnitCategoryBrandItemMutationVariables = Exact<{
	brandItemId: Scalars["String"]
}>

export type DeleteUnitCategoryBrandItemMutation = { __typename?: "Mutation"; deleteUnitCategoryBrandItem: boolean }

export type DeleteUnitCategoryBrandItemFromAreaMutationVariables = Exact<{
	brandItemId: Scalars["String"]
}>

export type DeleteUnitCategoryBrandItemFromAreaMutation = { __typename?: "Mutation"; deleteUnitCategoryBrandItemFromArea: boolean }

export type DeleteUnitCategoryElementMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	areaId: Scalars["String"]
	element: Elements
}>

export type DeleteUnitCategoryElementMutation = { __typename?: "Mutation"; deleteUnitCategoryElement: boolean }

export type DeleteUnitCategoryMaterialItemMutationVariables = Exact<{
	materialItemId: Scalars["String"]
}>

export type DeleteUnitCategoryMaterialItemMutation = { __typename?: "Mutation"; deleteUnitCategoryMaterialItem: boolean }

export type DeleteUnitCategoryMaterialItemFromAreaMutationVariables = Exact<{
	materialItemId: Scalars["String"]
}>

export type DeleteUnitCategoryMaterialItemFromAreaMutation = { __typename?: "Mutation"; deleteUnitCategoryMaterialItemFromArea: boolean }

export type DeleteUnitGroupMutationVariables = Exact<{
	unitGroupId: Scalars["String"]
}>

export type DeleteUnitGroupMutation = { __typename?: "Mutation"; deleteUnitGroup: boolean }

export type DeleteWorkInProgressItemMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	itemId: Scalars["String"]
}>

export type DeleteWorkInProgressItemMutation = {
	__typename?: "Mutation"
	deleteWorkInProgressItem: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type FinishAvatarUploadMutationVariables = Exact<{
	input: FinishUploadInput
}>

export type FinishAvatarUploadMutation = {
	__typename?: "Mutation"
	finishAvatarUpload: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	}
}

export type FinishBuilderPictureUploadMutationVariables = Exact<{
	builderId: Scalars["String"]
	input: FinishUploadInput
}>

export type FinishBuilderPictureUploadMutation = {
	__typename?: "Mutation"
	finishBuilderPictureUpload: {
		__typename?: "Picture"
		original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
		variants?: {
			__typename?: "PictureVariants"
			small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
		} | null
	}
}

export type FinishInspectionMutationVariables = Exact<{
	inspectionId: Scalars["String"]
}>

export type FinishInspectionMutation = {
	__typename?: "Mutation"
	finishInspection: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type FinishUnitCategoryLayoutPictureUploadMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	input: FinishUploadInput
}>

export type FinishUnitCategoryLayoutPictureUploadMutation = {
	__typename?: "Mutation"
	finishUnitCategoryLayoutPictureUpload: {
		__typename?: "UnitCategory"
		_id: string
		builderId: string
		projectId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
	}
}

export type FinishUnitCustomerInspectionTemplatePictureUploadMutationVariables = Exact<{
	unitId: Scalars["String"]
	input: FinishUploadInput
}>

export type FinishUnitCustomerInspectionTemplatePictureUploadMutation = {
	__typename?: "Mutation"
	finishUnitCustomerInspectionTemplatePictureUpload: {
		__typename?: "Unit"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
		customerInspectionTemplatePicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
}

export type FinishUnitLayoutPictureUploadMutationVariables = Exact<{
	unitId: Scalars["String"]
	input: FinishUploadInput
}>

export type FinishUnitLayoutPictureUploadMutation = {
	__typename?: "Mutation"
	finishUnitLayoutPictureUpload: {
		__typename?: "Unit"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
		customerInspectionTemplatePicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
}

export type InternalApproveAreaDimensionMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	areaDimensionId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type InternalApproveAreaDimensionMutation = {
	__typename?: "Mutation"
	internalApproveAreaDimension: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type InternalApproveBrandCheckMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	brandCheckId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type InternalApproveBrandCheckMutation = {
	__typename?: "Mutation"
	internalApproveBrandCheck: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type InternalApproveIssueMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type InternalApproveIssueMutation = {
	__typename?: "Mutation"
	internalApproveIssue: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type InternalApproveMaterialCheckMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	materialCheckId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type InternalApproveMaterialCheckMutation = {
	__typename?: "Mutation"
	internalApproveMaterialCheck: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type InternalApproveUnitAreaMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type InternalApproveUnitAreaMutation = {
	__typename?: "Mutation"
	internalApproveUnitArea: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type InternalApproveWaterQualityMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type InternalApproveWaterQualityMutation = {
	__typename?: "Mutation"
	internalApproveWaterQuality: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type InternalApproveWorkInProgressItemMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	itemId: Scalars["String"]
	approval: Scalars["Boolean"]
	remarks?: InputMaybe<Scalars["String"]>
}>

export type InternalApproveWorkInProgressItemMutation = {
	__typename?: "Mutation"
	internalApproveWorkInProgressItem: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type MapUnitToBlockLayoutMutationVariables = Exact<{
	blockLayoutId: Scalars["String"]
	unitId: Scalars["String"]
	column: Scalars["Int"]
	row: Scalars["Int"]
}>

export type MapUnitToBlockLayoutMutation = { __typename?: "Mutation"; mapUnitToBlockLayout: boolean }

export type RejectBuilderReviewMutationVariables = Exact<{
	inspectionId: Scalars["String"]
}>

export type RejectBuilderReviewMutation = {
	__typename?: "Mutation"
	rejectBuilderReview: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type RemoveAdditionalIssuePictureMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
}>

export type RemoveAdditionalIssuePictureMutation = {
	__typename?: "Mutation"
	removeAdditionalIssuePicture: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type RemoveAreaCoordinatesFromUnitCategoryLayoutMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	coordinatesId: Scalars["String"]
}>

export type RemoveAreaCoordinatesFromUnitCategoryLayoutMutation = {
	__typename?: "Mutation"
	removeAreaCoordinatesFromUnitCategoryLayout: {
		__typename?: "UnitCategory"
		_id: string
		builderId: string
		projectId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
	}
}

export type RemoveAreaCoordinatesFromUnitLayoutMutationVariables = Exact<{
	unitId: Scalars["String"]
	coordinatesId: Scalars["String"]
}>

export type RemoveAreaCoordinatesFromUnitLayoutMutation = {
	__typename?: "Mutation"
	removeAreaCoordinatesFromUnitLayout: {
		__typename?: "Unit"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
		customerInspectionTemplatePicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
}

export type RemoveContractorFromBuilderMutationVariables = Exact<{
	builderId: Scalars["String"]
	contractorId: Scalars["String"]
}>

export type RemoveContractorFromBuilderMutation = {
	__typename?: "Mutation"
	removeContractorFromBuilder: {
		__typename?: "Builder"
		_id: string
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
}

export type RemoveCustomerInspectionTemplatePictureFromUnitMutationVariables = Exact<{
	unitId: Scalars["String"]
}>

export type RemoveCustomerInspectionTemplatePictureFromUnitMutation = {
	__typename?: "Mutation"
	removeCustomerInspectionTemplatePictureFromUnit: {
		__typename?: "Unit"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
		customerInspectionTemplatePicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}
}

export type RemoveUnitFromBlockLayoutMutationVariables = Exact<{
	blockLayoutId: Scalars["String"]
	unitId: Scalars["String"]
	column: Scalars["Int"]
	row: Scalars["Int"]
}>

export type RemoveUnitFromBlockLayoutMutation = { __typename?: "Mutation"; removeUnitFromBlockLayout: boolean }

export type SendChangePasswordEmailMutationVariables = Exact<{ [key: string]: never }>

export type SendChangePasswordEmailMutation = { __typename?: "Mutation"; sendChangePasswordEmail: boolean }

export type SendPasswordResetEmailMutationVariables = Exact<{
	emailAddress: Scalars["String"]
}>

export type SendPasswordResetEmailMutation = { __typename?: "Mutation"; sendPasswordResetEmail: boolean }

export type SignAvatarUploadMutationVariables = Exact<{
	format: Scalars["String"]
}>

export type SignAvatarUploadMutation = { __typename?: "Mutation"; signAvatarUpload: { __typename?: "UploadSignatureResponse"; signedUrl: string; key: string } }

export type SignBuilderPictureUploadMutationVariables = Exact<{
	builderId: Scalars["String"]
	format: Scalars["String"]
}>

export type SignBuilderPictureUploadMutation = { __typename?: "Mutation"; signBuilderPictureUpload: { __typename?: "UploadSignatureResponse"; signedUrl: string; key: string } }

export type SignIssuePictureUploadMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	contentType: Scalars["String"]
}>

export type SignIssuePictureUploadMutation = { __typename?: "Mutation"; signIssuePictureUpload: { __typename?: "UploadSignatureResponse"; key: string; signedUrl: string } }

export type SignUnitCategoryLayoutPictureUploadMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	contentType: Scalars["String"]
}>

export type SignUnitCategoryLayoutPictureUploadMutation = { __typename?: "Mutation"; signUnitCategoryLayoutPictureUpload: { __typename?: "UploadSignatureResponse"; key: string; signedUrl: string } }

export type SignUnitCustomerInspectionTemplatePictureUploadMutationVariables = Exact<{
	unitId: Scalars["String"]
	contentType: Scalars["String"]
}>

export type SignUnitCustomerInspectionTemplatePictureUploadMutation = { __typename?: "Mutation"; signUnitCustomerInspectionTemplatePictureUpload: { __typename?: "UploadSignatureResponse"; key: string; signedUrl: string } }

export type SignUnitLayoutPictureUploadMutationVariables = Exact<{
	unitId: Scalars["String"]
	contentType: Scalars["String"]
}>

export type SignUnitLayoutPictureUploadMutation = { __typename?: "Mutation"; signUnitLayoutPictureUpload: { __typename?: "UploadSignatureResponse"; key: string; signedUrl: string } }

export type SigninMutationVariables = Exact<{
	emailAddress: Scalars["String"]
	password: Scalars["String"]
}>

export type SigninMutation = {
	__typename?: "Mutation"
	signin: {
		__typename?: "UserAuthResponse"
		user?: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
	}
}

export type SigninWithEmailTokenMutationVariables = Exact<{
	emailAddress: Scalars["String"]
	token: Scalars["String"]
	newPassword: Scalars["String"]
}>

export type SigninWithEmailTokenMutation = {
	__typename?: "Mutation"
	signinWithEmailToken: {
		__typename?: "UserAuthResponse"
		user?: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
	}
}

export type SignoutMutationVariables = Exact<{ [key: string]: never }>

export type SignoutMutation = { __typename?: "Mutation"; signout: boolean }

export type StartInspectionMutationVariables = Exact<{
	inspectionId: Scalars["String"]
}>

export type StartInspectionMutation = {
	__typename?: "Mutation"
	startInspection: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type SubmitBuilderElementWiseRectificationReviewMutationVariables = Exact<{
	rectificationId: Scalars["String"]
	element: Elements
}>

export type SubmitBuilderElementWiseRectificationReviewMutation = {
	__typename?: "Mutation"
	submitBuilderElementWiseRectificationReview: {
		__typename?: "Rectification"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		builderReviewerId: string
		preSnaggingInspectionId: string
		contractorIds: Array<string>
		status: RectificationStatus
		isDeleted?: boolean | null
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		preSnaggingInspection: {
			__typename?: "Inspection"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			inspectorId: string
			internalReviewerId: string
			builderReviewerId: string
			status: InspectionStatus
			type: InspectionTypes
			preSnaggingInspectionId?: string | null
			postSnaggingInspectionId?: string | null
			postSnaggingInspectionStatus?: InspectionStatus | null
			rectificationId?: string | null
			rectificationStatus?: RectificationStatus | null
			createdAt: any
			updatedAt: any
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			unit: {
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			inspector: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			internalReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builderReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			unitArea: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			waterQuality: {
				__typename?: "WaterQuality"
				_id: string
				ph: number
				tds: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
			dimensions: Array<{
				__typename?: "AreaDimensions"
				_id: string
				areaId: string
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				rects: Array<{
					__typename?: "RectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				height: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				area: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				additionalArea?: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				} | null
			}>
			reviewedDimensions?: Array<{
				__typename?: "ReviewedAreaDimensions"
				_id: string
				areaId: string
				rects: Array<{
					__typename?: "ReviewedRectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			}> | null
			brandChecks: Array<{
				__typename?: "BrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedBrandChecks?: Array<{
				__typename?: "ReviewedBrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			materialChecks: Array<{
				__typename?: "MaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedMaterialChecks?: Array<{
				__typename?: "ReviewedMaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			issues?: Array<{
				__typename?: "Issue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: IssuePostSnaggingStatus | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedIssues?: Array<{
				__typename?: "ReviewedIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
			}> | null
			workInProgressItems?: Array<{
				__typename?: "WorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedWorkInProgressItems?: Array<{
				__typename?: "ReviewedWorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			postSnaggingInspectionRequest?: {
				__typename?: "PostSnaggingInspectionRequest"
				status: PostSnaggingInspectionRequestStatus
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			} | null
		}
		elementWiseRectifications: Array<{
			__typename?: "ElementWiseRectification"
			element: Elements
			contractorId: string
			status: RectificationStatus
			contractor: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			issues: Array<{
				__typename?: "RectificationIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isRectified?: boolean | null
				rectificationRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				offlineHash?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				rectificationPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}>
		}>
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
	}
}

export type SubmitBuilderRectificationReviewMutationVariables = Exact<{
	rectificationId: Scalars["String"]
}>

export type SubmitBuilderRectificationReviewMutation = {
	__typename?: "Mutation"
	submitBuilderRectificationReview: {
		__typename?: "Rectification"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		builderReviewerId: string
		preSnaggingInspectionId: string
		contractorIds: Array<string>
		status: RectificationStatus
		isDeleted?: boolean | null
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		preSnaggingInspection: {
			__typename?: "Inspection"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			inspectorId: string
			internalReviewerId: string
			builderReviewerId: string
			status: InspectionStatus
			type: InspectionTypes
			preSnaggingInspectionId?: string | null
			postSnaggingInspectionId?: string | null
			postSnaggingInspectionStatus?: InspectionStatus | null
			rectificationId?: string | null
			rectificationStatus?: RectificationStatus | null
			createdAt: any
			updatedAt: any
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			unit: {
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			inspector: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			internalReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builderReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			unitArea: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			waterQuality: {
				__typename?: "WaterQuality"
				_id: string
				ph: number
				tds: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
			dimensions: Array<{
				__typename?: "AreaDimensions"
				_id: string
				areaId: string
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				rects: Array<{
					__typename?: "RectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				height: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				area: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				additionalArea?: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				} | null
			}>
			reviewedDimensions?: Array<{
				__typename?: "ReviewedAreaDimensions"
				_id: string
				areaId: string
				rects: Array<{
					__typename?: "ReviewedRectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			}> | null
			brandChecks: Array<{
				__typename?: "BrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedBrandChecks?: Array<{
				__typename?: "ReviewedBrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			materialChecks: Array<{
				__typename?: "MaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedMaterialChecks?: Array<{
				__typename?: "ReviewedMaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			issues?: Array<{
				__typename?: "Issue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: IssuePostSnaggingStatus | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedIssues?: Array<{
				__typename?: "ReviewedIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
			}> | null
			workInProgressItems?: Array<{
				__typename?: "WorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedWorkInProgressItems?: Array<{
				__typename?: "ReviewedWorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			postSnaggingInspectionRequest?: {
				__typename?: "PostSnaggingInspectionRequest"
				status: PostSnaggingInspectionRequestStatus
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			} | null
		}
		elementWiseRectifications: Array<{
			__typename?: "ElementWiseRectification"
			element: Elements
			contractorId: string
			status: RectificationStatus
			contractor: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			issues: Array<{
				__typename?: "RectificationIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isRectified?: boolean | null
				rectificationRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				offlineHash?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				rectificationPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}>
		}>
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
	}
}

export type SubmitBuilderReviewMutationVariables = Exact<{
	inspectionId: Scalars["String"]
}>

export type SubmitBuilderReviewMutation = {
	__typename?: "Mutation"
	submitBuilderReview: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type SubmitInternalReviewMutationVariables = Exact<{
	inspectionId: Scalars["String"]
}>

export type SubmitInternalReviewMutation = {
	__typename?: "Mutation"
	submitInternalReview: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type UpdateAreaMutationVariables = Exact<{
	unitId: Scalars["String"]
	areaId: Scalars["String"]
	input: AreaInput
}>

export type UpdateAreaMutation = {
	__typename?: "Mutation"
	updateArea: {
		__typename?: "Area"
		_id: string
		type: AreaTypes
		elements: Array<Elements>
		coordinatesOnUnitLayout?: Array<number> | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type UpdateAreaDimensionsMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	areaDimensionsId: Scalars["String"]
	input: AreaDimensionsInput
}>

export type UpdateAreaDimensionsMutation = {
	__typename?: "Mutation"
	updateAreaDimensions: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type UpdateBlockMutationVariables = Exact<{
	blockId: Scalars["String"]
	input: BlockInput
}>

export type UpdateBlockMutation = {
	__typename?: "Mutation"
	updateBlock: {
		__typename?: "BlockWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		block?: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } } | null
	}
}

export type UpdateBlockLayoutMutationVariables = Exact<{
	blockLayoutId: Scalars["String"]
	rows: Scalars["Int"]
	columns: Scalars["Int"]
}>

export type UpdateBlockLayoutMutation = {
	__typename?: "Mutation"
	updateBlockLayout: {
		__typename?: "BlockLayoutWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		blockLayout?: { __typename?: "BlockLayout"; _id: string; builderId: string; projectId: string; clusterId: string; blockId: string; rows: number; columns: number; matrixUnitIds?: any | null; createdAt: any; updatedAt: any } | null
	}
}

export type UpdateBrandCheckMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	brandCheckId: Scalars["String"]
	input: BrandCheckInput
}>

export type UpdateBrandCheckMutation = {
	__typename?: "Mutation"
	updateBrandCheck: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type UpdateBrandItemMutationVariables = Exact<{
	brandItemId: Scalars["String"]
	input: BrandItemInput
}>

export type UpdateBrandItemMutation = {
	__typename?: "Mutation"
	updateBrandItem: {
		__typename?: "BrandItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type UpdateBuilderMutationVariables = Exact<{
	builderId: Scalars["String"]
	input: BuilderInput
}>

export type UpdateBuilderMutation = {
	__typename?: "Mutation"
	updateBuilder: {
		__typename?: "BuilderWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		builder?: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
	}
}

export type UpdateBuilderAdminMutationVariables = Exact<{
	builderAdminId: Scalars["String"]
	input: UpdateUserInput
}>

export type UpdateBuilderAdminMutation = {
	__typename?: "Mutation"
	updateBuilderAdmin: {
		__typename?: "UserWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		user?: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
	}
}

export type UpdateBuilderReviewerofInspectionMutationVariables = Exact<{
	builderReviewerId: Scalars["String"]
	inspectionId: Scalars["String"]
}>

export type UpdateBuilderReviewerofInspectionMutation = {
	__typename?: "Mutation"
	updateBuilderReviewerofInspection: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type UpdateClusterMutationVariables = Exact<{
	clusterId: Scalars["String"]
	input: ClusterInput
}>

export type UpdateClusterMutation = {
	__typename?: "Mutation"
	updateCluster: {
		__typename?: "ClusterWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		cluster?: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } } | null
	}
}

export type UpdateContractorMutationVariables = Exact<{
	contractorId: Scalars["String"]
	input: UpdateUserInput
	linkedElements: Array<Elements> | Elements
}>

export type UpdateContractorMutation = {
	__typename?: "Mutation"
	updateContractor: {
		__typename?: "UserWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		user?: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
	}
}

export type UpdateContractorForElementRectificationMutationVariables = Exact<{
	rectificationId: Scalars["String"]
	element: Elements
	contractorId: Scalars["String"]
	remarks: Scalars["String"]
}>

export type UpdateContractorForElementRectificationMutation = {
	__typename?: "Mutation"
	updateContractorForElementRectification: {
		__typename?: "Rectification"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		builderReviewerId: string
		preSnaggingInspectionId: string
		contractorIds: Array<string>
		status: RectificationStatus
		isDeleted?: boolean | null
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		preSnaggingInspection: {
			__typename?: "Inspection"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			inspectorId: string
			internalReviewerId: string
			builderReviewerId: string
			status: InspectionStatus
			type: InspectionTypes
			preSnaggingInspectionId?: string | null
			postSnaggingInspectionId?: string | null
			postSnaggingInspectionStatus?: InspectionStatus | null
			rectificationId?: string | null
			rectificationStatus?: RectificationStatus | null
			createdAt: any
			updatedAt: any
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			unit: {
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			inspector: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			internalReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builderReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			unitArea: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			waterQuality: {
				__typename?: "WaterQuality"
				_id: string
				ph: number
				tds: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
			dimensions: Array<{
				__typename?: "AreaDimensions"
				_id: string
				areaId: string
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				rects: Array<{
					__typename?: "RectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				height: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				area: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				additionalArea?: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				} | null
			}>
			reviewedDimensions?: Array<{
				__typename?: "ReviewedAreaDimensions"
				_id: string
				areaId: string
				rects: Array<{
					__typename?: "ReviewedRectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			}> | null
			brandChecks: Array<{
				__typename?: "BrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedBrandChecks?: Array<{
				__typename?: "ReviewedBrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			materialChecks: Array<{
				__typename?: "MaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedMaterialChecks?: Array<{
				__typename?: "ReviewedMaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			issues?: Array<{
				__typename?: "Issue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: IssuePostSnaggingStatus | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedIssues?: Array<{
				__typename?: "ReviewedIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
			}> | null
			workInProgressItems?: Array<{
				__typename?: "WorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedWorkInProgressItems?: Array<{
				__typename?: "ReviewedWorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			postSnaggingInspectionRequest?: {
				__typename?: "PostSnaggingInspectionRequest"
				status: PostSnaggingInspectionRequestStatus
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			} | null
		}
		elementWiseRectifications: Array<{
			__typename?: "ElementWiseRectification"
			element: Elements
			contractorId: string
			status: RectificationStatus
			contractor: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			issues: Array<{
				__typename?: "RectificationIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isRectified?: boolean | null
				rectificationRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				offlineHash?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				rectificationPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}>
		}>
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
	}
}

export type UpdateInspectorMutationVariables = Exact<{
	inspectorId: Scalars["String"]
	input: UpdateUserInput
}>

export type UpdateInspectorMutation = {
	__typename?: "Mutation"
	updateInspector: {
		__typename?: "UserWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		user?: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
	}
}

export type UpdateInspectorofInspectionMutationVariables = Exact<{
	inspectorId: Scalars["String"]
	inspectionId: Scalars["String"]
}>

export type UpdateInspectorofInspectionMutation = {
	__typename?: "Mutation"
	updateInspectorofInspection: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type UpdateIssueMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	issueId: Scalars["String"]
	input: UpdateIssueInput
}>

export type UpdateIssueMutation = {
	__typename?: "Mutation"
	updateIssue: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type UpdateMaterialCheckMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	materialCheckId: Scalars["String"]
	input: MaterialCheckInput
}>

export type UpdateMaterialCheckMutation = {
	__typename?: "Mutation"
	updateMaterialCheck: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type UpdateMaterialItemMutationVariables = Exact<{
	materialItemId: Scalars["String"]
	input: MaterialItemInput
}>

export type UpdateMaterialItemMutation = {
	__typename?: "Mutation"
	updateMaterialItem: {
		__typename?: "MaterialItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type UpdateProjectMutationVariables = Exact<{
	projectId: Scalars["String"]
	input: ProjectInput
}>

export type UpdateProjectMutation = {
	__typename?: "Mutation"
	updateProject: {
		__typename?: "ProjectWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		project?: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		} | null
	}
}

export type UpdateUnitMutationVariables = Exact<{
	unitId: Scalars["String"]
	input: UnitInput
}>

export type UpdateUnitMutation = {
	__typename?: "Mutation"
	updateUnit: {
		__typename?: "UnitWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		unit?: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		} | null
	}
}

export type UpdateUnitCategoryAreaMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	areaId: Scalars["String"]
	input: AreaInput
}>

export type UpdateUnitCategoryAreaMutation = {
	__typename?: "Mutation"
	updateUnitCategoryArea: {
		__typename?: "Area"
		_id: string
		type: AreaTypes
		elements: Array<Elements>
		coordinatesOnUnitLayout?: Array<number> | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type UpdateUnitCategoryBrandItemMutationVariables = Exact<{
	brandItemId: Scalars["String"]
	input: BrandItemInput
}>

export type UpdateUnitCategoryBrandItemMutation = {
	__typename?: "Mutation"
	updateUnitCategoryBrandItem: {
		__typename?: "UnitCategoryBrandItem"
		_id: string
		builderId: string
		projectId: string
		unitCategoryId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type UpdateUnitCategoryLabelMutationVariables = Exact<{
	unitCategoryId: Scalars["String"]
	label: LabelInput
}>

export type UpdateUnitCategoryLabelMutation = {
	__typename?: "Mutation"
	updateUnitCategoryLabel: {
		__typename?: "UnitCategoryWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		unitCategory?: {
			__typename?: "UnitCategory"
			_id: string
			builderId: string
			projectId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
		} | null
	}
}

export type UpdateUnitCategoryMaterialItemMutationVariables = Exact<{
	materialItemId: Scalars["String"]
	input: MaterialItemInput
}>

export type UpdateUnitCategoryMaterialItemMutation = {
	__typename?: "Mutation"
	updateUnitCategoryMaterialItem: {
		__typename?: "UnitCategoryMaterialItem"
		_id: string
		builderId: string
		projectId: string
		unitCategoryId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}
}

export type UpdateUnitGroupLabelMutationVariables = Exact<{
	unitGroupId: Scalars["String"]
	label: LabelInput
}>

export type UpdateUnitGroupLabelMutation = {
	__typename?: "Mutation"
	updateUnitGroupLabel: {
		__typename?: "UnitGroupWithFieldErrorsResponse"
		errors?: Array<{ __typename?: "FieldError"; field: string; error: string }> | null
		unitGroup?: {
			__typename?: "UnitGroup"
			_id: string
			builderId: string
			projectId: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			units: Array<{
				__typename?: "GroupedUnits"
				_id: string
				unitCategoryId: string
				clusterId: string
				blockId: string
				unitIds: Array<string>
				unitCategory: {
					__typename?: "UnitCategory"
					_id: string
					builderId: string
					projectId: string
					configuration: UnitConfigurations
					createdAt: any
					updatedAt: any
					builder: {
						__typename?: "Builder"
						_id: string
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
						picture?: {
							__typename?: "Picture"
							original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
							variants?: {
								__typename?: "PictureVariants"
								small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
								medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
								large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
								thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							} | null
						} | null
					}
					project: {
						__typename?: "Project"
						_id: string
						builderId: string
						type: ProjectTypes
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
						address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
					}
					label: { __typename?: "Label"; name: string; description?: string | null }
					areas?: Array<{
						__typename?: "Area"
						_id: string
						type: AreaTypes
						elements: Array<Elements>
						coordinatesOnUnitLayout?: Array<number> | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}> | null
					layout?: {
						__typename?: "UnitLayout"
						_id: string
						key: string
						url: string
						areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
					} | null
				}
				cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
				block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
				units: Array<{
					__typename?: "Unit"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					configuration: UnitConfigurations
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					areas?: Array<{
						__typename?: "Area"
						_id: string
						type: AreaTypes
						elements: Array<Elements>
						coordinatesOnUnitLayout?: Array<number> | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}> | null
					layout?: {
						__typename?: "UnitLayout"
						_id: string
						key: string
						url: string
						areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
					} | null
					customerInspectionTemplatePicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}>
			}>
		} | null
	}
}

export type UpdateWorkInProgressItemMutationVariables = Exact<{
	inspectionId: Scalars["String"]
	itemId: Scalars["String"]
	input: UpdateWorkInProgressItemInput
}>

export type UpdateWorkInProgressItemMutation = {
	__typename?: "Mutation"
	updateWorkInProgressItem: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}
}

export type VerifySigninWithEmailTokenMutationVariables = Exact<{
	emailAddress: Scalars["String"]
	token: Scalars["String"]
}>

export type VerifySigninWithEmailTokenMutation = { __typename?: "Mutation"; verifySigninWithEmailToken: boolean }

export type AdminsQueryVariables = Exact<{ [key: string]: never }>

export type AdminsQuery = {
	__typename?: "Query"
	admins: Array<{
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}>
}

export type AllBuildersQueryVariables = Exact<{ [key: string]: never }>

export type AllBuildersQuery = {
	__typename?: "Query"
	allBuilders: Array<{
		__typename?: "Builder"
		_id: string
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}>
}

export type BlockByIdQueryVariables = Exact<{
	blockId: Scalars["String"]
}>

export type BlockByIdQuery = {
	__typename?: "Query"
	blockById?: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } } | null
}

export type BlocksOfProjectQueryVariables = Exact<{
	projectId: Scalars["String"]
}>

export type BlocksOfProjectQuery = {
	__typename?: "Query"
	blocksOfProject: Array<{ __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }>
}

export type BrandItemByIdQueryVariables = Exact<{
	brandItemId: Scalars["String"]
}>

export type BrandItemByIdQuery = {
	__typename?: "Query"
	brandItemById?: {
		__typename?: "BrandItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	} | null
}

export type BrandItemsOfInspectionQueryVariables = Exact<{
	inspectionId: Scalars["String"]
	areaId?: InputMaybe<Scalars["String"]>
}>

export type BrandItemsOfInspectionQuery = {
	__typename?: "Query"
	brandItemsOfInspection: Array<{
		__typename?: "BrandItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}>
}

export type BuilderAdminsQueryVariables = Exact<{
	builderId: Scalars["String"]
}>

export type BuilderAdminsQuery = {
	__typename?: "Query"
	builderAdmins: Array<{
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}>
}

export type BuilderAdminsOfBuilderQueryVariables = Exact<{
	builderId: Scalars["String"]
}>

export type BuilderAdminsOfBuilderQuery = {
	__typename?: "Query"
	builderAdminsOfBuilder: Array<{
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}>
}

export type BuilderAndStatusWiseInspectionStatsQueryVariables = Exact<{ [key: string]: never }>

export type BuilderAndStatusWiseInspectionStatsQuery = {
	__typename?: "Query"
	builderAndStatusWiseInspectionStats: Array<{
		__typename?: "StatusWiseInspectionsStats"
		_id: string
		builderId: string
		createdAt: any
		updatedAt: any
		statusWiseUnits: Array<{ __typename?: "UnitAndInspectionStatus"; unitId: string; status: InspectionStatus }>
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
	}>
}

export type BuilderByIdQueryVariables = Exact<{
	builderId: Scalars["String"]
}>

export type BuilderByIdQuery = {
	__typename?: "Query"
	builderById?: {
		__typename?: "Builder"
		_id: string
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	} | null
}

export type ClusterByIdQueryVariables = Exact<{
	clusterId: Scalars["String"]
}>

export type ClusterByIdQuery = {
	__typename?: "Query"
	clusterById?: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } } | null
}

export type ClustersOfProjectQueryVariables = Exact<{
	projectId: Scalars["String"]
}>

export type ClustersOfProjectQuery = {
	__typename?: "Query"
	clustersOfProject: Array<{ __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }>
}

export type ContractorsQueryVariables = Exact<{
	builderId: Scalars["String"]
	element?: InputMaybe<Elements>
}>

export type ContractorsQuery = {
	__typename?: "Query"
	contractors: Array<{
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}>
}

export type ContractorsByRectificationIdQueryVariables = Exact<{
	rectificationId: Scalars["String"]
}>

export type ContractorsByRectificationIdQuery = {
	__typename?: "Query"
	contractorsByRectificationId?: Array<{
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}> | null
}

export type ElementAndSeverityWiseIssuesStatsQueryVariables = Exact<{ [key: string]: never }>

export type ElementAndSeverityWiseIssuesStatsQuery = {
	__typename?: "Query"
	elementAndSeverityWiseIssuesStats: Array<{
		__typename?: "ElementAndSeverityWiseIssuesStats"
		_id: string
		builderId: string
		unitId: string
		createdAt: any
		updatedAt: any
		elements: Array<{ __typename?: "ElementAndSeverityWiseIssues"; _id: string; element: string; cosmeticIssueIds: Array<string>; minorIssueIds: Array<string>; majorIssueIds: Array<string>; createdAt: any; updatedAt: any }>
	}>
}

export type ElementsOfRectificationQueryVariables = Exact<{
	rectificationId: Scalars["String"]
}>

export type ElementsOfRectificationQuery = {
	__typename?: "Query"
	elementsOfRectification?: Array<{
		__typename?: "ElementWiseRectification"
		element: Elements
		contractorId: string
		status: RectificationStatus
		contractor: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		issues: Array<{
			__typename?: "RectificationIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isRectified?: boolean | null
			rectificationRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			offlineHash?: string | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			rectificationPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}>
	}> | null
}

export type InspectionByIdQueryVariables = Exact<{
	inspectionId: Scalars["String"]
}>

export type InspectionByIdQuery = {
	__typename?: "Query"
	inspectionById?: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	} | null
}

export type InspectionsQueryVariables = Exact<{
	unitId?: InputMaybe<Scalars["String"]>
	builderId?: InputMaybe<Scalars["String"]>
	projectId?: InputMaybe<Scalars["String"]>
	status?: InputMaybe<InspectionStatus>
	type?: InputMaybe<InspectionTypes>
	since?: InputMaybe<Scalars["DateTime"]>
	until?: InputMaybe<Scalars["DateTime"]>
	pagination: PaginatedInput
}>

export type InspectionsQuery = {
	__typename?: "Query"
	inspections: {
		__typename?: "PaginatedInspectionsResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		inspections: Array<{
			__typename?: "Inspection"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			inspectorId: string
			internalReviewerId: string
			builderReviewerId: string
			status: InspectionStatus
			type: InspectionTypes
			preSnaggingInspectionId?: string | null
			postSnaggingInspectionId?: string | null
			postSnaggingInspectionStatus?: InspectionStatus | null
			rectificationId?: string | null
			rectificationStatus?: RectificationStatus | null
			createdAt: any
			updatedAt: any
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			unit: {
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			inspector: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			internalReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builderReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			unitArea: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			waterQuality: {
				__typename?: "WaterQuality"
				_id: string
				ph: number
				tds: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
			dimensions: Array<{
				__typename?: "AreaDimensions"
				_id: string
				areaId: string
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				rects: Array<{
					__typename?: "RectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				height: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				area: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				additionalArea?: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				} | null
			}>
			reviewedDimensions?: Array<{
				__typename?: "ReviewedAreaDimensions"
				_id: string
				areaId: string
				rects: Array<{
					__typename?: "ReviewedRectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			}> | null
			brandChecks: Array<{
				__typename?: "BrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedBrandChecks?: Array<{
				__typename?: "ReviewedBrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			materialChecks: Array<{
				__typename?: "MaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedMaterialChecks?: Array<{
				__typename?: "ReviewedMaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			issues?: Array<{
				__typename?: "Issue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: IssuePostSnaggingStatus | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedIssues?: Array<{
				__typename?: "ReviewedIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
			}> | null
			workInProgressItems?: Array<{
				__typename?: "WorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedWorkInProgressItems?: Array<{
				__typename?: "ReviewedWorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			postSnaggingInspectionRequest?: {
				__typename?: "PostSnaggingInspectionRequest"
				status: PostSnaggingInspectionRequestStatus
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			} | null
		}>
	}
}

export type InspectionsWithoutPaginationQueryVariables = Exact<{
	builderId?: InputMaybe<Scalars["String"]>
	status?: InputMaybe<InspectionStatus>
	type?: InputMaybe<InspectionTypes>
	since?: InputMaybe<Scalars["DateTime"]>
	until?: InputMaybe<Scalars["DateTime"]>
}>

export type InspectionsWithoutPaginationQuery = {
	__typename?: "Query"
	inspectionsWithoutPagination: Array<{
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	}>
}

export type InspectorsQueryVariables = Exact<{ [key: string]: never }>

export type InspectorsQuery = {
	__typename?: "Query"
	inspectors: Array<{
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}>
}

export type IssueItemsQueryVariables = Exact<{ [key: string]: never }>

export type IssueItemsQuery = { __typename?: "Query"; issueItems: Array<{ __typename?: "IssueItem"; _id: string; issue: string; createdAt: any; updatedAt: any }> }

export type IssueTemplatesQueryVariables = Exact<{
	element: Elements
	areaType: AreaTypes
	pagination: PaginatedInput
}>

export type IssueTemplatesQuery = {
	__typename?: "Query"
	issueTemplates: {
		__typename?: "PaginatedIssueTemplatesResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		issueTemplates: Array<{
			__typename?: "IssueTemplate"
			_id: string
			element: Elements
			areaType?: AreaTypes | null
			severity: IssueSeverity
			label: { __typename?: "Label"; name: string; description?: string | null }
			issue: { __typename?: "Label"; name: string; description?: string | null }
		}>
	}
}

export type LatestInspectionOfUnitQueryVariables = Exact<{
	unitId: Scalars["String"]
}>

export type LatestInspectionOfUnitQuery = {
	__typename?: "Query"
	latestInspectionOfUnit?: {
		__typename?: "Inspection"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		internalReviewerId: string
		builderReviewerId: string
		status: InspectionStatus
		type: InspectionTypes
		preSnaggingInspectionId?: string | null
		postSnaggingInspectionId?: string | null
		postSnaggingInspectionStatus?: InspectionStatus | null
		rectificationId?: string | null
		rectificationStatus?: RectificationStatus | null
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		internalReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		unitArea: {
			__typename?: "Dimension"
			unit: DimensionUnits
			value: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		waterQuality: {
			__typename?: "WaterQuality"
			_id: string
			ph: number
			tds: number
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
		}
		reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
		dimensions: Array<{
			__typename?: "AreaDimensions"
			_id: string
			areaId: string
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			rects: Array<{
				__typename?: "RectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			width: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			height: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			area: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			additionalArea?: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			} | null
		}>
		reviewedDimensions?: Array<{
			__typename?: "ReviewedAreaDimensions"
			_id: string
			areaId: string
			rects: Array<{
				__typename?: "ReviewedRectDimensions"
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
			}>
			length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
			additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
		}> | null
		brandChecks: Array<{
			__typename?: "BrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedBrandChecks?: Array<{
			__typename?: "ReviewedBrandCheck"
			_id: string
			areaId?: string | null
			brandItemId: string
			isOk?: boolean | null
			remarks?: string | null
			brandItem: {
				__typename?: "BrandItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		materialChecks: Array<{
			__typename?: "MaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}>
		reviewedMaterialChecks?: Array<{
			__typename?: "ReviewedMaterialCheck"
			_id: string
			areaId?: string | null
			materialItemId: string
			isOk?: boolean | null
			remarks?: string | null
			materialItem: {
				__typename?: "MaterialItem"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				areaId?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}
		}> | null
		issues?: Array<{
			__typename?: "Issue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: IssuePostSnaggingStatus | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			additionalPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedIssues?: Array<{
			__typename?: "ReviewedIssue"
			_id: string
			areaId: string
			element: Elements
			severity: IssueSeverity
			isCritical?: boolean | null
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
		}> | null
		workInProgressItems?: Array<{
			__typename?: "WorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isInternalApproved?: boolean | null
			internalRemarks?: string | null
			isBuilderApproved?: boolean | null
			builderRemarks?: string | null
			isReInspected?: boolean | null
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		reviewedWorkInProgressItems?: Array<{
			__typename?: "ReviewedWorkInProgressItem"
			_id: string
			areaId: string
			element: Elements
			status: WorkInProgressItemStatus
			estimatedDeadline: any
			isCopiedFromPreSnagging?: boolean | null
			postSnaggingStatus?: WorkInProgressItemStatus | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			}
			postSnaggingPicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}> | null
		postSnaggingInspectionRequest?: {
			__typename?: "PostSnaggingInspectionRequest"
			status: PostSnaggingInspectionRequestStatus
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		} | null
	} | null
}

export type LayoutOfBlockQueryVariables = Exact<{
	blockId: Scalars["String"]
}>

export type LayoutOfBlockQuery = {
	__typename?: "Query"
	layoutOfBlock?: { __typename?: "BlockLayout"; _id: string; builderId: string; projectId: string; clusterId: string; blockId: string; rows: number; columns: number; matrixUnitIds?: any | null; createdAt: any; updatedAt: any } | null
}

export type LinkedContractorsOfBuilderQueryVariables = Exact<{
	builderId: Scalars["String"]
}>

export type LinkedContractorsOfBuilderQuery = {
	__typename?: "Query"
	linkedContractorsOfBuilder?: Array<{
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}> | null
}

export type MaterialItemByIdQueryVariables = Exact<{
	materialItemId: Scalars["String"]
}>

export type MaterialItemByIdQuery = {
	__typename?: "Query"
	materialItemById?: {
		__typename?: "MaterialItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	} | null
}

export type MaterialItemsOfInspectionQueryVariables = Exact<{
	inspectionId: Scalars["String"]
	areaId?: InputMaybe<Scalars["String"]>
}>

export type MaterialItemsOfInspectionQuery = {
	__typename?: "Query"
	materialItemsOfInspection: Array<{
		__typename?: "MaterialItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}>
}

export type MeQueryVariables = Exact<{ [key: string]: never }>

export type MeQuery = {
	__typename?: "Query"
	me?: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	} | null
}

export type ProjectAndSeverityWiseIssuesStatsQueryVariables = Exact<{ [key: string]: never }>

export type ProjectAndSeverityWiseIssuesStatsQuery = {
	__typename?: "Query"
	projectAndSeverityWiseIssuesStats: Array<{
		__typename?: "ProjectAndSeverityWiseIssuesStats"
		_id: string
		builderId: string
		projectId: string
		unitId: string
		cosmeticIssueIds: Array<string>
		minorIssueIds: Array<string>
		majorIssueIds: Array<string>
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
	}>
}

export type ProjectAndStatusWiseInspectionStatsQueryVariables = Exact<{ [key: string]: never }>

export type ProjectAndStatusWiseInspectionStatsQuery = {
	__typename?: "Query"
	projectAndStatusWiseInspectionStats: Array<{
		__typename?: "ProjectAndStatusWiseInspectionsStats"
		_id: string
		builderId: string
		projectId: string
		createdAt: any
		updatedAt: any
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		statusWiseUnits: Array<{ __typename?: "UnitAndInspectionStatus"; unitId: string; status: InspectionStatus }>
	}>
}

export type ProjectByIdQueryVariables = Exact<{
	projectId: Scalars["String"]
}>

export type ProjectByIdQuery = {
	__typename?: "Query"
	projectById?: {
		__typename?: "Project"
		_id: string
		builderId: string
		type: ProjectTypes
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
	} | null
}

export type ProjectHeadsOfProjectQueryVariables = Exact<{
	projectId: Scalars["String"]
}>

export type ProjectHeadsOfProjectQuery = {
	__typename?: "Query"
	projectHeadsOfProject: Array<{
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}>
}

export type QualityHeadsOfProjectQueryVariables = Exact<{
	projectId: Scalars["String"]
}>

export type QualityHeadsOfProjectQuery = {
	__typename?: "Query"
	qualityHeadsOfProject: Array<{
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	}>
}

export type RectificationByIdQueryVariables = Exact<{
	rectificationId: Scalars["String"]
}>

export type RectificationByIdQuery = {
	__typename?: "Query"
	rectificationById?: {
		__typename?: "Rectification"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		builderReviewerId: string
		preSnaggingInspectionId: string
		contractorIds: Array<string>
		status: RectificationStatus
		isDeleted?: boolean | null
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		builderReviewer: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		preSnaggingInspection: {
			__typename?: "Inspection"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			inspectorId: string
			internalReviewerId: string
			builderReviewerId: string
			status: InspectionStatus
			type: InspectionTypes
			preSnaggingInspectionId?: string | null
			postSnaggingInspectionId?: string | null
			postSnaggingInspectionStatus?: InspectionStatus | null
			rectificationId?: string | null
			rectificationStatus?: RectificationStatus | null
			createdAt: any
			updatedAt: any
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			unit: {
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			inspector: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			internalReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builderReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			unitArea: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			waterQuality: {
				__typename?: "WaterQuality"
				_id: string
				ph: number
				tds: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
			dimensions: Array<{
				__typename?: "AreaDimensions"
				_id: string
				areaId: string
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				rects: Array<{
					__typename?: "RectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				height: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				area: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				additionalArea?: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				} | null
			}>
			reviewedDimensions?: Array<{
				__typename?: "ReviewedAreaDimensions"
				_id: string
				areaId: string
				rects: Array<{
					__typename?: "ReviewedRectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			}> | null
			brandChecks: Array<{
				__typename?: "BrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedBrandChecks?: Array<{
				__typename?: "ReviewedBrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			materialChecks: Array<{
				__typename?: "MaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedMaterialChecks?: Array<{
				__typename?: "ReviewedMaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			issues?: Array<{
				__typename?: "Issue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: IssuePostSnaggingStatus | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedIssues?: Array<{
				__typename?: "ReviewedIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
			}> | null
			workInProgressItems?: Array<{
				__typename?: "WorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedWorkInProgressItems?: Array<{
				__typename?: "ReviewedWorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			postSnaggingInspectionRequest?: {
				__typename?: "PostSnaggingInspectionRequest"
				status: PostSnaggingInspectionRequestStatus
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			} | null
		}
		elementWiseRectifications: Array<{
			__typename?: "ElementWiseRectification"
			element: Elements
			contractorId: string
			status: RectificationStatus
			contractor: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			issues: Array<{
				__typename?: "RectificationIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isRectified?: boolean | null
				rectificationRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				offlineHash?: string | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				rectificationPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}>
		}>
		statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
	} | null
}

export type RectificationsQueryVariables = Exact<{
	unitId?: InputMaybe<Scalars["String"]>
	builderId?: InputMaybe<Scalars["String"]>
	projectId?: InputMaybe<Scalars["String"]>
	status?: InputMaybe<RectificationStatus>
	since?: InputMaybe<Scalars["DateTime"]>
	until?: InputMaybe<Scalars["DateTime"]>
	pagination: PaginatedInput
}>

export type RectificationsQuery = {
	__typename?: "Query"
	rectifications: {
		__typename?: "PaginatedRectificationsResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		rectifications: Array<{
			__typename?: "Rectification"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			builderReviewerId: string
			preSnaggingInspectionId: string
			contractorIds: Array<string>
			status: RectificationStatus
			isDeleted?: boolean | null
			createdAt: any
			updatedAt: any
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			unit: {
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builderReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			preSnaggingInspection: {
				__typename?: "Inspection"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				inspectorId: string
				internalReviewerId: string
				builderReviewerId: string
				status: InspectionStatus
				type: InspectionTypes
				preSnaggingInspectionId?: string | null
				postSnaggingInspectionId?: string | null
				postSnaggingInspectionStatus?: InspectionStatus | null
				rectificationId?: string | null
				rectificationStatus?: RectificationStatus | null
				createdAt: any
				updatedAt: any
				project: {
					__typename?: "Project"
					_id: string
					builderId: string
					type: ProjectTypes
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
				}
				block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
				cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
				unit: {
					__typename?: "Unit"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					configuration: UnitConfigurations
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					areas?: Array<{
						__typename?: "Area"
						_id: string
						type: AreaTypes
						elements: Array<Elements>
						coordinatesOnUnitLayout?: Array<number> | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}> | null
					layout?: {
						__typename?: "UnitLayout"
						_id: string
						key: string
						url: string
						areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
					} | null
					customerInspectionTemplatePicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				builder: {
					__typename?: "Builder"
					_id: string
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				inspector: {
					__typename?: "User"
					_id: string
					builderId?: string | null
					type: UserTypes
					name: string
					linkedElements?: Array<Elements> | null
					createdAt: any
					updatedAt: any
					email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
					phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
					address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
					picture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				internalReviewer: {
					__typename?: "User"
					_id: string
					builderId?: string | null
					type: UserTypes
					name: string
					linkedElements?: Array<Elements> | null
					createdAt: any
					updatedAt: any
					email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
					phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
					address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
					picture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				builderReviewer: {
					__typename?: "User"
					_id: string
					builderId?: string | null
					type: UserTypes
					name: string
					linkedElements?: Array<Elements> | null
					createdAt: any
					updatedAt: any
					email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
					phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
					address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
					picture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
				unitArea: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
				waterQuality: {
					__typename?: "WaterQuality"
					_id: string
					ph: number
					tds: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
				dimensions: Array<{
					__typename?: "AreaDimensions"
					_id: string
					areaId: string
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
					rects: Array<{
						__typename?: "RectDimensions"
						length: {
							__typename?: "Dimension"
							unit: DimensionUnits
							value: number
							isInternalApproved?: boolean | null
							internalRemarks?: string | null
							isBuilderApproved?: boolean | null
							builderRemarks?: string | null
							isReInspected?: boolean | null
						}
						width: {
							__typename?: "Dimension"
							unit: DimensionUnits
							value: number
							isInternalApproved?: boolean | null
							internalRemarks?: string | null
							isBuilderApproved?: boolean | null
							builderRemarks?: string | null
							isReInspected?: boolean | null
						}
					}>
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					height: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					area: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					additionalArea?: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					} | null
				}>
				reviewedDimensions?: Array<{
					__typename?: "ReviewedAreaDimensions"
					_id: string
					areaId: string
					rects: Array<{
						__typename?: "ReviewedRectDimensions"
						length: {
							__typename?: "Dimension"
							unit: DimensionUnits
							value: number
							isInternalApproved?: boolean | null
							internalRemarks?: string | null
							isBuilderApproved?: boolean | null
							builderRemarks?: string | null
							isReInspected?: boolean | null
						}
						width: {
							__typename?: "Dimension"
							unit: DimensionUnits
							value: number
							isInternalApproved?: boolean | null
							internalRemarks?: string | null
							isBuilderApproved?: boolean | null
							builderRemarks?: string | null
							isReInspected?: boolean | null
						}
					}>
					length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
					width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
					height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
					area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
					additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
				}> | null
				brandChecks: Array<{
					__typename?: "BrandCheck"
					_id: string
					areaId?: string | null
					brandItemId: string
					isOk?: boolean | null
					remarks?: string | null
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
					brandItem: {
						__typename?: "BrandItem"
						_id: string
						builderId: string
						projectId: string
						clusterId: string
						blockId: string
						unitId: string
						areaId?: string | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}
				}>
				reviewedBrandChecks?: Array<{
					__typename?: "ReviewedBrandCheck"
					_id: string
					areaId?: string | null
					brandItemId: string
					isOk?: boolean | null
					remarks?: string | null
					brandItem: {
						__typename?: "BrandItem"
						_id: string
						builderId: string
						projectId: string
						clusterId: string
						blockId: string
						unitId: string
						areaId?: string | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}
				}> | null
				materialChecks: Array<{
					__typename?: "MaterialCheck"
					_id: string
					areaId?: string | null
					materialItemId: string
					isOk?: boolean | null
					remarks?: string | null
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
					materialItem: {
						__typename?: "MaterialItem"
						_id: string
						builderId: string
						projectId: string
						clusterId: string
						blockId: string
						unitId: string
						areaId?: string | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}
				}>
				reviewedMaterialChecks?: Array<{
					__typename?: "ReviewedMaterialCheck"
					_id: string
					areaId?: string | null
					materialItemId: string
					isOk?: boolean | null
					remarks?: string | null
					materialItem: {
						__typename?: "MaterialItem"
						_id: string
						builderId: string
						projectId: string
						clusterId: string
						blockId: string
						unitId: string
						areaId?: string | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}
				}> | null
				issues?: Array<{
					__typename?: "Issue"
					_id: string
					areaId: string
					element: Elements
					severity: IssueSeverity
					isCritical?: boolean | null
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
					isCopiedFromPreSnagging?: boolean | null
					postSnaggingStatus?: IssuePostSnaggingStatus | null
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					}
					additionalPicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
					postSnaggingPicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}> | null
				reviewedIssues?: Array<{
					__typename?: "ReviewedIssue"
					_id: string
					areaId: string
					element: Elements
					severity: IssueSeverity
					isCritical?: boolean | null
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					}
				}> | null
				workInProgressItems?: Array<{
					__typename?: "WorkInProgressItem"
					_id: string
					areaId: string
					element: Elements
					status: WorkInProgressItemStatus
					estimatedDeadline: any
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
					isCopiedFromPreSnagging?: boolean | null
					postSnaggingStatus?: WorkInProgressItemStatus | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					}
					postSnaggingPicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}> | null
				reviewedWorkInProgressItems?: Array<{
					__typename?: "ReviewedWorkInProgressItem"
					_id: string
					areaId: string
					element: Elements
					status: WorkInProgressItemStatus
					estimatedDeadline: any
					isCopiedFromPreSnagging?: boolean | null
					postSnaggingStatus?: WorkInProgressItemStatus | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					}
					postSnaggingPicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}> | null
				postSnaggingInspectionRequest?: {
					__typename?: "PostSnaggingInspectionRequest"
					status: PostSnaggingInspectionRequestStatus
					statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
				} | null
			}
			elementWiseRectifications: Array<{
				__typename?: "ElementWiseRectification"
				element: Elements
				contractorId: string
				status: RectificationStatus
				contractor: {
					__typename?: "User"
					_id: string
					builderId?: string | null
					type: UserTypes
					name: string
					linkedElements?: Array<Elements> | null
					createdAt: any
					updatedAt: any
					email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
					phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
					address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
					picture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
				issues: Array<{
					__typename?: "RectificationIssue"
					_id: string
					areaId: string
					element: Elements
					severity: IssueSeverity
					isCritical?: boolean | null
					isRectified?: boolean | null
					rectificationRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					offlineHash?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					}
					additionalPicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
					rectificationPicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}>
			}>
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
		}>
	}
}

export type ReportByInspectionIdQueryVariables = Exact<{
	inspectionId: Scalars["String"]
}>

export type ReportByInspectionIdQuery = {
	__typename?: "Query"
	reportByInspectionId?: Array<{
		__typename?: "Report"
		_id: string
		publicId: string
		type: ReportTypes
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		inspectionId: string
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspection: {
			__typename?: "Inspection"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			inspectorId: string
			internalReviewerId: string
			builderReviewerId: string
			status: InspectionStatus
			type: InspectionTypes
			preSnaggingInspectionId?: string | null
			postSnaggingInspectionId?: string | null
			postSnaggingInspectionStatus?: InspectionStatus | null
			rectificationId?: string | null
			rectificationStatus?: RectificationStatus | null
			createdAt: any
			updatedAt: any
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			unit: {
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			inspector: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			internalReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builderReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			unitArea: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			waterQuality: {
				__typename?: "WaterQuality"
				_id: string
				ph: number
				tds: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
			dimensions: Array<{
				__typename?: "AreaDimensions"
				_id: string
				areaId: string
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				rects: Array<{
					__typename?: "RectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				height: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				area: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				additionalArea?: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				} | null
			}>
			reviewedDimensions?: Array<{
				__typename?: "ReviewedAreaDimensions"
				_id: string
				areaId: string
				rects: Array<{
					__typename?: "ReviewedRectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			}> | null
			brandChecks: Array<{
				__typename?: "BrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedBrandChecks?: Array<{
				__typename?: "ReviewedBrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			materialChecks: Array<{
				__typename?: "MaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedMaterialChecks?: Array<{
				__typename?: "ReviewedMaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			issues?: Array<{
				__typename?: "Issue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: IssuePostSnaggingStatus | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedIssues?: Array<{
				__typename?: "ReviewedIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
			}> | null
			workInProgressItems?: Array<{
				__typename?: "WorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedWorkInProgressItems?: Array<{
				__typename?: "ReviewedWorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			postSnaggingInspectionRequest?: {
				__typename?: "PostSnaggingInspectionRequest"
				status: PostSnaggingInspectionRequestStatus
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			} | null
		}
		reports: Array<{ __typename?: "ReportObject"; _id: string; type: ReportPartTypes; element?: Elements | null; key: string; url: string; label: { __typename?: "Label"; name: string; description?: string | null } }>
	}> | null
}

export type ReportByPublicIdQueryVariables = Exact<{
	reportPublicId: Scalars["String"]
}>

export type ReportByPublicIdQuery = {
	__typename?: "Query"
	reportByPublicId?: {
		__typename?: "Report"
		_id: string
		publicId: string
		type: ReportTypes
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		inspectorId: string
		inspectionId: string
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
		unit: {
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspector: {
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		inspection: {
			__typename?: "Inspection"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			inspectorId: string
			internalReviewerId: string
			builderReviewerId: string
			status: InspectionStatus
			type: InspectionTypes
			preSnaggingInspectionId?: string | null
			postSnaggingInspectionId?: string | null
			postSnaggingInspectionStatus?: InspectionStatus | null
			rectificationId?: string | null
			rectificationStatus?: RectificationStatus | null
			createdAt: any
			updatedAt: any
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			unit: {
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			inspector: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			internalReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			builderReviewer: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			unitArea: {
				__typename?: "Dimension"
				unit: DimensionUnits
				value: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			waterQuality: {
				__typename?: "WaterQuality"
				_id: string
				ph: number
				tds: number
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
			}
			reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
			dimensions: Array<{
				__typename?: "AreaDimensions"
				_id: string
				areaId: string
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				rects: Array<{
					__typename?: "RectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				width: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				height: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				area: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				additionalArea?: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				} | null
			}>
			reviewedDimensions?: Array<{
				__typename?: "ReviewedAreaDimensions"
				_id: string
				areaId: string
				rects: Array<{
					__typename?: "ReviewedRectDimensions"
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
				}>
				length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
				additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
			}> | null
			brandChecks: Array<{
				__typename?: "BrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedBrandChecks?: Array<{
				__typename?: "ReviewedBrandCheck"
				_id: string
				areaId?: string | null
				brandItemId: string
				isOk?: boolean | null
				remarks?: string | null
				brandItem: {
					__typename?: "BrandItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			materialChecks: Array<{
				__typename?: "MaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}>
			reviewedMaterialChecks?: Array<{
				__typename?: "ReviewedMaterialCheck"
				_id: string
				areaId?: string | null
				materialItemId: string
				isOk?: boolean | null
				remarks?: string | null
				materialItem: {
					__typename?: "MaterialItem"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					unitId: string
					areaId?: string | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}
			}> | null
			issues?: Array<{
				__typename?: "Issue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: IssuePostSnaggingStatus | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				additionalPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedIssues?: Array<{
				__typename?: "ReviewedIssue"
				_id: string
				areaId: string
				element: Elements
				severity: IssueSeverity
				isCritical?: boolean | null
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
			}> | null
			workInProgressItems?: Array<{
				__typename?: "WorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isInternalApproved?: boolean | null
				internalRemarks?: string | null
				isBuilderApproved?: boolean | null
				builderRemarks?: string | null
				isReInspected?: boolean | null
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			reviewedWorkInProgressItems?: Array<{
				__typename?: "ReviewedWorkInProgressItem"
				_id: string
				areaId: string
				element: Elements
				status: WorkInProgressItemStatus
				estimatedDeadline: any
				isCopiedFromPreSnagging?: boolean | null
				postSnaggingStatus?: WorkInProgressItemStatus | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				}
				postSnaggingPicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}> | null
			postSnaggingInspectionRequest?: {
				__typename?: "PostSnaggingInspectionRequest"
				status: PostSnaggingInspectionRequestStatus
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
			} | null
		}
		reports: Array<{ __typename?: "ReportObject"; _id: string; type: ReportPartTypes; element?: Elements | null; key: string; url: string; label: { __typename?: "Label"; name: string; description?: string | null } }>
	} | null
}

export type SearchAdminsQueryVariables = Exact<{
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchAdminsQuery = {
	__typename?: "Query"
	searchAdmins: {
		__typename?: "PaginatedUsersResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		users: Array<{
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}>
	}
}

export type SearchBlocksOfClusterQueryVariables = Exact<{
	clusterId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchBlocksOfClusterQuery = {
	__typename?: "Query"
	searchBlocksOfCluster: {
		__typename?: "PaginatedBlocksResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		blocks: Array<{ __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }>
	}
}

export type SearchBrandItemsOfUnitQueryVariables = Exact<{
	unitId: Scalars["String"]
	areaId?: InputMaybe<Scalars["String"]>
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchBrandItemsOfUnitQuery = {
	__typename?: "Query"
	searchBrandItemsOfUnit: {
		__typename?: "PaginatedBrandItemsResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		brandItems: Array<{
			__typename?: "BrandItem"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			areaId?: string | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}>
	}
}

export type SearchBrandItemsOfUnitCategoryQueryVariables = Exact<{
	unitCategoryId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
	areaId?: InputMaybe<Scalars["String"]>
}>

export type SearchBrandItemsOfUnitCategoryQuery = {
	__typename?: "Query"
	searchBrandItemsOfUnitCategory: {
		__typename?: "PaginatedUnitCategoryBrandItemsResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		brandItems: Array<{
			__typename?: "UnitCategoryBrandItem"
			_id: string
			builderId: string
			projectId: string
			unitCategoryId: string
			areaId?: string | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}>
	}
}

export type SearchBuilderAdminsQueryVariables = Exact<{
	builderId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchBuilderAdminsQuery = {
	__typename?: "Query"
	searchBuilderAdmins: {
		__typename?: "PaginatedUsersResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		users: Array<{
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}>
	}
}

export type SearchBuildersQueryVariables = Exact<{
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchBuildersQuery = {
	__typename?: "Query"
	searchBuilders: {
		__typename?: "PaginatedBuildersResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		builders: Array<{
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}>
	}
}

export type SearchClustersOfProjectQueryVariables = Exact<{
	projectId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchClustersOfProjectQuery = {
	__typename?: "Query"
	searchClustersOfProject: {
		__typename?: "PaginatedClustersResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		clusters: Array<{ __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }>
	}
}

export type SearchContractorsQueryVariables = Exact<{
	keyword: Scalars["String"]
	pagination: PaginatedInput
	element?: InputMaybe<Elements>
}>

export type SearchContractorsQuery = {
	__typename?: "Query"
	searchContractors: {
		__typename?: "PaginatedUsersResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		users: Array<{
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}>
	}
}

export type SearchInspectorsQueryVariables = Exact<{
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchInspectorsQuery = {
	__typename?: "Query"
	searchInspectors: {
		__typename?: "PaginatedUsersResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		users: Array<{
			__typename?: "User"
			_id: string
			builderId?: string | null
			type: UserTypes
			name: string
			linkedElements?: Array<Elements> | null
			createdAt: any
			updatedAt: any
			email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
			phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
			address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}>
	}
}

export type SearchMaterialItemsOfUnitQueryVariables = Exact<{
	unitId: Scalars["String"]
	areaId?: InputMaybe<Scalars["String"]>
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchMaterialItemsOfUnitQuery = {
	__typename?: "Query"
	searchMaterialItemsOfUnit: {
		__typename?: "PaginatedMaterialItemsResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		materialItems: Array<{
			__typename?: "MaterialItem"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			areaId?: string | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}>
	}
}

export type SearchMaterialItemsOfUnitCategoryQueryVariables = Exact<{
	unitCategoryId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
	areaId?: InputMaybe<Scalars["String"]>
}>

export type SearchMaterialItemsOfUnitCategoryQuery = {
	__typename?: "Query"
	searchMaterialItemsOfUnitCategory: {
		__typename?: "PaginatedUnitCategoryMaterialItemsResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		materialItems: Array<{
			__typename?: "UnitCategoryMaterialItem"
			_id: string
			builderId: string
			projectId: string
			unitCategoryId: string
			areaId?: string | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}>
	}
}

export type SearchProjectsOfBuilderQueryVariables = Exact<{
	builderId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchProjectsOfBuilderQuery = {
	__typename?: "Query"
	searchProjectsOfBuilder: {
		__typename?: "PaginatedProjectsResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		projects: Array<{
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}>
	}
}

export type SearchReportsQueryVariables = Exact<{
	keyword?: InputMaybe<Scalars["String"]>
	pagination: PaginatedInput
	inspectorId?: InputMaybe<Scalars["String"]>
	since?: InputMaybe<Scalars["DateTime"]>
	until?: InputMaybe<Scalars["DateTime"]>
	builderId?: InputMaybe<Scalars["String"]>
	type?: InputMaybe<ReportTypes>
}>

export type SearchReportsQuery = {
	__typename?: "Query"
	searchReports: {
		__typename?: "PaginatedReportsResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		reports: Array<{
			__typename?: "Report"
			_id: string
			publicId: string
			type: ReportTypes
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			unitId: string
			inspectorId: string
			inspectionId: string
			createdAt: any
			updatedAt: any
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			unit: {
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			inspector: {
				__typename?: "User"
				_id: string
				builderId?: string | null
				type: UserTypes
				name: string
				linkedElements?: Array<Elements> | null
				createdAt: any
				updatedAt: any
				email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
				phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
				address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			inspection: {
				__typename?: "Inspection"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				unitId: string
				inspectorId: string
				internalReviewerId: string
				builderReviewerId: string
				status: InspectionStatus
				type: InspectionTypes
				preSnaggingInspectionId?: string | null
				postSnaggingInspectionId?: string | null
				postSnaggingInspectionStatus?: InspectionStatus | null
				rectificationId?: string | null
				rectificationStatus?: RectificationStatus | null
				createdAt: any
				updatedAt: any
				project: {
					__typename?: "Project"
					_id: string
					builderId: string
					type: ProjectTypes
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
				}
				block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
				cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
				unit: {
					__typename?: "Unit"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					configuration: UnitConfigurations
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					areas?: Array<{
						__typename?: "Area"
						_id: string
						type: AreaTypes
						elements: Array<Elements>
						coordinatesOnUnitLayout?: Array<number> | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}> | null
					layout?: {
						__typename?: "UnitLayout"
						_id: string
						key: string
						url: string
						areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
					} | null
					customerInspectionTemplatePicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				builder: {
					__typename?: "Builder"
					_id: string
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				inspector: {
					__typename?: "User"
					_id: string
					builderId?: string | null
					type: UserTypes
					name: string
					linkedElements?: Array<Elements> | null
					createdAt: any
					updatedAt: any
					email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
					phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
					address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
					picture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				internalReviewer: {
					__typename?: "User"
					_id: string
					builderId?: string | null
					type: UserTypes
					name: string
					linkedElements?: Array<Elements> | null
					createdAt: any
					updatedAt: any
					email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
					phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
					address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
					picture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				builderReviewer: {
					__typename?: "User"
					_id: string
					builderId?: string | null
					type: UserTypes
					name: string
					linkedElements?: Array<Elements> | null
					createdAt: any
					updatedAt: any
					email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
					phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
					address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
					picture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
				unitArea: {
					__typename?: "Dimension"
					unit: DimensionUnits
					value: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				reviewedUnitArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
				waterQuality: {
					__typename?: "WaterQuality"
					_id: string
					ph: number
					tds: number
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
				}
				reviewedWaterQuality?: { __typename?: "ReviewedWaterQuality"; _id: string; ph: number; tds: number } | null
				dimensions: Array<{
					__typename?: "AreaDimensions"
					_id: string
					areaId: string
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
					rects: Array<{
						__typename?: "RectDimensions"
						length: {
							__typename?: "Dimension"
							unit: DimensionUnits
							value: number
							isInternalApproved?: boolean | null
							internalRemarks?: string | null
							isBuilderApproved?: boolean | null
							builderRemarks?: string | null
							isReInspected?: boolean | null
						}
						width: {
							__typename?: "Dimension"
							unit: DimensionUnits
							value: number
							isInternalApproved?: boolean | null
							internalRemarks?: string | null
							isBuilderApproved?: boolean | null
							builderRemarks?: string | null
							isReInspected?: boolean | null
						}
					}>
					length: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					width: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					height: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					area: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					}
					additionalArea?: {
						__typename?: "Dimension"
						unit: DimensionUnits
						value: number
						isInternalApproved?: boolean | null
						internalRemarks?: string | null
						isBuilderApproved?: boolean | null
						builderRemarks?: string | null
						isReInspected?: boolean | null
					} | null
				}>
				reviewedDimensions?: Array<{
					__typename?: "ReviewedAreaDimensions"
					_id: string
					areaId: string
					rects: Array<{
						__typename?: "ReviewedRectDimensions"
						length: {
							__typename?: "Dimension"
							unit: DimensionUnits
							value: number
							isInternalApproved?: boolean | null
							internalRemarks?: string | null
							isBuilderApproved?: boolean | null
							builderRemarks?: string | null
							isReInspected?: boolean | null
						}
						width: {
							__typename?: "Dimension"
							unit: DimensionUnits
							value: number
							isInternalApproved?: boolean | null
							internalRemarks?: string | null
							isBuilderApproved?: boolean | null
							builderRemarks?: string | null
							isReInspected?: boolean | null
						}
					}>
					length: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
					width: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
					height: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
					area: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number }
					additionalArea?: { __typename?: "ReviewedDimension"; unit: DimensionUnits; value: number } | null
				}> | null
				brandChecks: Array<{
					__typename?: "BrandCheck"
					_id: string
					areaId?: string | null
					brandItemId: string
					isOk?: boolean | null
					remarks?: string | null
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
					brandItem: {
						__typename?: "BrandItem"
						_id: string
						builderId: string
						projectId: string
						clusterId: string
						blockId: string
						unitId: string
						areaId?: string | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}
				}>
				reviewedBrandChecks?: Array<{
					__typename?: "ReviewedBrandCheck"
					_id: string
					areaId?: string | null
					brandItemId: string
					isOk?: boolean | null
					remarks?: string | null
					brandItem: {
						__typename?: "BrandItem"
						_id: string
						builderId: string
						projectId: string
						clusterId: string
						blockId: string
						unitId: string
						areaId?: string | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}
				}> | null
				materialChecks: Array<{
					__typename?: "MaterialCheck"
					_id: string
					areaId?: string | null
					materialItemId: string
					isOk?: boolean | null
					remarks?: string | null
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
					materialItem: {
						__typename?: "MaterialItem"
						_id: string
						builderId: string
						projectId: string
						clusterId: string
						blockId: string
						unitId: string
						areaId?: string | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}
				}>
				reviewedMaterialChecks?: Array<{
					__typename?: "ReviewedMaterialCheck"
					_id: string
					areaId?: string | null
					materialItemId: string
					isOk?: boolean | null
					remarks?: string | null
					materialItem: {
						__typename?: "MaterialItem"
						_id: string
						builderId: string
						projectId: string
						clusterId: string
						blockId: string
						unitId: string
						areaId?: string | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}
				}> | null
				issues?: Array<{
					__typename?: "Issue"
					_id: string
					areaId: string
					element: Elements
					severity: IssueSeverity
					isCritical?: boolean | null
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
					isCopiedFromPreSnagging?: boolean | null
					postSnaggingStatus?: IssuePostSnaggingStatus | null
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					}
					additionalPicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
					postSnaggingPicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}> | null
				reviewedIssues?: Array<{
					__typename?: "ReviewedIssue"
					_id: string
					areaId: string
					element: Elements
					severity: IssueSeverity
					isCritical?: boolean | null
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					}
				}> | null
				workInProgressItems?: Array<{
					__typename?: "WorkInProgressItem"
					_id: string
					areaId: string
					element: Elements
					status: WorkInProgressItemStatus
					estimatedDeadline: any
					isInternalApproved?: boolean | null
					internalRemarks?: string | null
					isBuilderApproved?: boolean | null
					builderRemarks?: string | null
					isReInspected?: boolean | null
					isCopiedFromPreSnagging?: boolean | null
					postSnaggingStatus?: WorkInProgressItemStatus | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					}
					postSnaggingPicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}> | null
				reviewedWorkInProgressItems?: Array<{
					__typename?: "ReviewedWorkInProgressItem"
					_id: string
					areaId: string
					element: Elements
					status: WorkInProgressItemStatus
					estimatedDeadline: any
					isCopiedFromPreSnagging?: boolean | null
					postSnaggingStatus?: WorkInProgressItemStatus | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					}
					postSnaggingPicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}> | null
				postSnaggingInspectionRequest?: {
					__typename?: "PostSnaggingInspectionRequest"
					status: PostSnaggingInspectionRequestStatus
					statusLifecycle: Array<{ __typename?: "StatusLifecycle"; _id: string; status: string; createdAt: any; remarks?: string | null; reference?: { __typename?: "Reference"; _id: string; type: ReferenceTypes } | null }>
				} | null
			}
			reports: Array<{ __typename?: "ReportObject"; _id: string; type: ReportPartTypes; element?: Elements | null; key: string; url: string; label: { __typename?: "Label"; name: string; description?: string | null } }>
		}>
	}
}

export type SearchUnitCategoriesOfProjectQueryVariables = Exact<{
	projectId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchUnitCategoriesOfProjectQuery = {
	__typename?: "Query"
	searchUnitCategoriesOfProject: {
		__typename?: "PaginatedUnitCategoriesResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		unitCategories: Array<{
			__typename?: "UnitCategory"
			_id: string
			builderId: string
			projectId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			builder: {
				__typename?: "Builder"
				_id: string
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				picture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}
			project: {
				__typename?: "Project"
				_id: string
				builderId: string
				type: ProjectTypes
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
			}
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
		}>
	}
}

export type SearchUnitGroupsOfProjectQueryVariables = Exact<{
	projectId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchUnitGroupsOfProjectQuery = {
	__typename?: "Query"
	searchUnitGroupsOfProject: {
		__typename?: "PaginatedUnitGroupsResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		unitGroups: Array<{
			__typename?: "UnitGroup"
			_id: string
			builderId: string
			projectId: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			units: Array<{
				__typename?: "GroupedUnits"
				_id: string
				unitCategoryId: string
				clusterId: string
				blockId: string
				unitIds: Array<string>
				unitCategory: {
					__typename?: "UnitCategory"
					_id: string
					builderId: string
					projectId: string
					configuration: UnitConfigurations
					createdAt: any
					updatedAt: any
					builder: {
						__typename?: "Builder"
						_id: string
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
						picture?: {
							__typename?: "Picture"
							original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
							variants?: {
								__typename?: "PictureVariants"
								small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
								medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
								large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
								thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							} | null
						} | null
					}
					project: {
						__typename?: "Project"
						_id: string
						builderId: string
						type: ProjectTypes
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
						address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
					}
					label: { __typename?: "Label"; name: string; description?: string | null }
					areas?: Array<{
						__typename?: "Area"
						_id: string
						type: AreaTypes
						elements: Array<Elements>
						coordinatesOnUnitLayout?: Array<number> | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}> | null
					layout?: {
						__typename?: "UnitLayout"
						_id: string
						key: string
						url: string
						areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
					} | null
				}
				cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
				block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
				units: Array<{
					__typename?: "Unit"
					_id: string
					builderId: string
					projectId: string
					clusterId: string
					blockId: string
					configuration: UnitConfigurations
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					areas?: Array<{
						__typename?: "Area"
						_id: string
						type: AreaTypes
						elements: Array<Elements>
						coordinatesOnUnitLayout?: Array<number> | null
						createdAt: any
						updatedAt: any
						label: { __typename?: "Label"; name: string; description?: string | null }
					}> | null
					layout?: {
						__typename?: "UnitLayout"
						_id: string
						key: string
						url: string
						areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
					} | null
					customerInspectionTemplatePicture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}>
			}>
		}>
	}
}

export type SearchUnitsOfBlockQueryVariables = Exact<{
	blockId: Scalars["String"]
	keyword: Scalars["String"]
	pagination: PaginatedInput
}>

export type SearchUnitsOfBlockQuery = {
	__typename?: "Query"
	searchUnitsOfBlock: {
		__typename?: "PaginatedUnitsResponse"
		hasPrevPage: boolean
		hasNextPage: boolean
		currentPage: number
		units: Array<{
			__typename?: "Unit"
			_id: string
			builderId: string
			projectId: string
			clusterId: string
			blockId: string
			configuration: UnitConfigurations
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			areas?: Array<{
				__typename?: "Area"
				_id: string
				type: AreaTypes
				elements: Array<Elements>
				coordinatesOnUnitLayout?: Array<number> | null
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
			}> | null
			layout?: {
				__typename?: "UnitLayout"
				_id: string
				key: string
				url: string
				areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
			} | null
			customerInspectionTemplatePicture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}>
	}
}

export type StatusWiseInspectionStatsQueryVariables = Exact<{ [key: string]: never }>

export type StatusWiseInspectionStatsQuery = {
	__typename?: "Query"
	statusWiseInspectionStats?: {
		__typename?: "StatusWiseInspectionsStats"
		_id: string
		builderId: string
		createdAt: any
		updatedAt: any
		statusWiseUnits: Array<{ __typename?: "UnitAndInspectionStatus"; unitId: string; status: InspectionStatus }>
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
	} | null
}

export type UnassignedBrandItemsOfUnitQueryVariables = Exact<{
	unitId: Scalars["String"]
}>

export type UnassignedBrandItemsOfUnitQuery = {
	__typename?: "Query"
	unassignedBrandItemsOfUnit: Array<{
		__typename?: "BrandItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}>
}

export type UnassignedBrandItemsOfUnitCategoryQueryVariables = Exact<{
	unitCategoryId: Scalars["String"]
}>

export type UnassignedBrandItemsOfUnitCategoryQuery = {
	__typename?: "Query"
	unassignedBrandItemsOfUnitCategory: Array<{
		__typename?: "UnitCategoryBrandItem"
		_id: string
		builderId: string
		projectId: string
		unitCategoryId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}>
}

export type UnassignedMaterialItemsOfUnitQueryVariables = Exact<{
	unitId: Scalars["String"]
}>

export type UnassignedMaterialItemsOfUnitQuery = {
	__typename?: "Query"
	unassignedMaterialItemsOfUnit: Array<{
		__typename?: "MaterialItem"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		unitId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}>
}

export type UnassignedMaterialItemsOfUnitCategoryQueryVariables = Exact<{
	unitCategoryId: Scalars["String"]
}>

export type UnassignedMaterialItemsOfUnitCategoryQuery = {
	__typename?: "Query"
	unassignedMaterialItemsOfUnitCategory: Array<{
		__typename?: "UnitCategoryMaterialItem"
		_id: string
		builderId: string
		projectId: string
		unitCategoryId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	}>
}

export type UniqueElementsOfUnitQueryVariables = Exact<{
	unitId: Scalars["String"]
}>

export type UniqueElementsOfUnitQuery = { __typename?: "Query"; uniqueElementsOfUnit?: Array<Elements> | null }

export type UnitByIdQueryVariables = Exact<{
	unitId: Scalars["String"]
}>

export type UnitByIdQuery = {
	__typename?: "Query"
	unitById?: {
		__typename?: "Unit"
		_id: string
		builderId: string
		projectId: string
		clusterId: string
		blockId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
		customerInspectionTemplatePicture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	} | null
}

export type UnitCategoriesOfProjectQueryVariables = Exact<{
	projectId: Scalars["String"]
}>

export type UnitCategoriesOfProjectQuery = {
	__typename?: "Query"
	unitCategoriesOfProject: Array<{
		__typename?: "UnitCategory"
		_id: string
		builderId: string
		projectId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
	}>
}

export type UnitCategoryBrandItemByIdQueryVariables = Exact<{
	brandItemId: Scalars["String"]
}>

export type UnitCategoryBrandItemByIdQuery = {
	__typename?: "Query"
	unitCategoryBrandItemById?: {
		__typename?: "UnitCategoryBrandItem"
		_id: string
		builderId: string
		projectId: string
		unitCategoryId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	} | null
}

export type UnitCategoryByIdQueryVariables = Exact<{
	unitCategoryId: Scalars["String"]
}>

export type UnitCategoryByIdQuery = {
	__typename?: "Query"
	unitCategoryById?: {
		__typename?: "UnitCategory"
		_id: string
		builderId: string
		projectId: string
		configuration: UnitConfigurations
		createdAt: any
		updatedAt: any
		builder: {
			__typename?: "Builder"
			_id: string
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			picture?: {
				__typename?: "Picture"
				original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
				variants?: {
					__typename?: "PictureVariants"
					small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				} | null
			} | null
		}
		project: {
			__typename?: "Project"
			_id: string
			builderId: string
			type: ProjectTypes
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
			address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
		}
		label: { __typename?: "Label"; name: string; description?: string | null }
		areas?: Array<{
			__typename?: "Area"
			_id: string
			type: AreaTypes
			elements: Array<Elements>
			coordinatesOnUnitLayout?: Array<number> | null
			createdAt: any
			updatedAt: any
			label: { __typename?: "Label"; name: string; description?: string | null }
		}> | null
		layout?: {
			__typename?: "UnitLayout"
			_id: string
			key: string
			url: string
			areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
		} | null
	} | null
}

export type UnitCategoryMaterialItemByIdQueryVariables = Exact<{
	materialItemId: Scalars["String"]
}>

export type UnitCategoryMaterialItemByIdQuery = {
	__typename?: "Query"
	unitCategoryMaterialItemById?: {
		__typename?: "UnitCategoryMaterialItem"
		_id: string
		builderId: string
		projectId: string
		unitCategoryId: string
		areaId?: string | null
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
	} | null
}

export type UnitGroupByIdQueryVariables = Exact<{
	unitGroupId: Scalars["String"]
}>

export type UnitGroupByIdQuery = {
	__typename?: "Query"
	unitGroupById?: {
		__typename?: "UnitGroup"
		_id: string
		builderId: string
		projectId: string
		createdAt: any
		updatedAt: any
		label: { __typename?: "Label"; name: string; description?: string | null }
		units: Array<{
			__typename?: "GroupedUnits"
			_id: string
			unitCategoryId: string
			clusterId: string
			blockId: string
			unitIds: Array<string>
			unitCategory: {
				__typename?: "UnitCategory"
				_id: string
				builderId: string
				projectId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				builder: {
					__typename?: "Builder"
					_id: string
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					picture?: {
						__typename?: "Picture"
						original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
						variants?: {
							__typename?: "PictureVariants"
							small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
							thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						} | null
					} | null
				}
				project: {
					__typename?: "Project"
					_id: string
					builderId: string
					type: ProjectTypes
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
					address: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string }
				}
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
			}
			cluster: { __typename?: "Cluster"; _id: string; builderId: string; projectId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			block: { __typename?: "Block"; _id: string; builderId: string; projectId: string; clusterId: string; createdAt: any; updatedAt: any; label: { __typename?: "Label"; name: string; description?: string | null } }
			units: Array<{
				__typename?: "Unit"
				_id: string
				builderId: string
				projectId: string
				clusterId: string
				blockId: string
				configuration: UnitConfigurations
				createdAt: any
				updatedAt: any
				label: { __typename?: "Label"; name: string; description?: string | null }
				areas?: Array<{
					__typename?: "Area"
					_id: string
					type: AreaTypes
					elements: Array<Elements>
					coordinatesOnUnitLayout?: Array<number> | null
					createdAt: any
					updatedAt: any
					label: { __typename?: "Label"; name: string; description?: string | null }
				}> | null
				layout?: {
					__typename?: "UnitLayout"
					_id: string
					key: string
					url: string
					areaCoordinates?: Array<{ __typename?: "LayoutAreaCoordinates"; _id: string; areaId: string; coordinates: { __typename?: "Coordinates"; x: number; y: number } }> | null
				} | null
				customerInspectionTemplatePicture?: {
					__typename?: "Picture"
					original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
					variants?: {
						__typename?: "PictureVariants"
						small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
						thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
					} | null
				} | null
			}>
		}>
	} | null
}

export type UserByIdQueryVariables = Exact<{
	userId: Scalars["String"]
}>

export type UserByIdQuery = {
	__typename?: "Query"
	userById?: {
		__typename?: "User"
		_id: string
		builderId?: string | null
		type: UserTypes
		name: string
		linkedElements?: Array<Elements> | null
		createdAt: any
		updatedAt: any
		email: { __typename?: "Email"; address: string; isVerified: boolean; verifiedAt?: any | null; createdAt: any; updatedAt: any }
		phone?: { __typename?: "Phone"; countryCode: string; number: string } | null
		address?: { __typename?: "Address"; street: string; city: string; state: string; country: string; postalCode: string } | null
		picture?: {
			__typename?: "Picture"
			original: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null }
			variants?: {
				__typename?: "PictureVariants"
				small?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				medium?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				large?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
				thumbnail?: { __typename?: "PictureObject"; key: string; url: string; height?: number | null; width?: number | null } | null
			} | null
		} | null
	} | null
}

export const FieldErrorFragmentDoc = gql`
	fragment FieldError on FieldError {
		field
		error
	}
`
export const BlockLayoutFragmentDoc = gql`
	fragment BlockLayout on BlockLayout {
		_id
		builderId
		projectId
		clusterId
		blockId
		rows
		columns
		matrixUnitIds
		createdAt
		updatedAt
	}
`
export const BlockLayoutWithFieldErrorsResponseFragmentDoc = gql`
	fragment BlockLayoutWithFieldErrorsResponse on BlockLayoutWithFieldErrorsResponse {
		errors {
			...FieldError
		}
		blockLayout {
			...BlockLayout
		}
	}
	${FieldErrorFragmentDoc}
	${BlockLayoutFragmentDoc}
`
export const LabelFragmentDoc = gql`
	fragment Label on Label {
		name
		description
	}
`
export const BlockFragmentDoc = gql`
	fragment Block on Block {
		_id
		builderId
		projectId
		clusterId
		label {
			...Label
		}
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
`
export const BlockWithFieldErrorsResponseFragmentDoc = gql`
	fragment BlockWithFieldErrorsResponse on BlockWithFieldErrorsResponse {
		errors {
			...FieldError
		}
		block {
			...Block
		}
	}
	${FieldErrorFragmentDoc}
	${BlockFragmentDoc}
`
export const PictureObjectFragmentDoc = gql`
	fragment PictureObject on PictureObject {
		key
		url
		height
		width
	}
`
export const PictureFragmentDoc = gql`
	fragment Picture on Picture {
		original {
			...PictureObject
		}
		variants {
			small {
				...PictureObject
			}
			medium {
				...PictureObject
			}
			large {
				...PictureObject
			}
			thumbnail {
				...PictureObject
			}
		}
	}
	${PictureObjectFragmentDoc}
`
export const BuilderFragmentDoc = gql`
	fragment Builder on Builder {
		_id
		label {
			...Label
		}
		picture {
			...Picture
		}
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
	${PictureFragmentDoc}
`
export const BuilderWithFieldErrorsResponseFragmentDoc = gql`
	fragment BuilderWithFieldErrorsResponse on BuilderWithFieldErrorsResponse {
		errors {
			...FieldError
		}
		builder {
			...Builder
		}
	}
	${FieldErrorFragmentDoc}
	${BuilderFragmentDoc}
`
export const ClusterFragmentDoc = gql`
	fragment Cluster on Cluster {
		_id
		builderId
		projectId
		label {
			...Label
		}
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
`
export const ClusterWithFieldErrorsResponseFragmentDoc = gql`
	fragment ClusterWithFieldErrorsResponse on ClusterWithFieldErrorsResponse {
		errors {
			...FieldError
		}
		cluster {
			...Cluster
		}
	}
	${FieldErrorFragmentDoc}
	${ClusterFragmentDoc}
`
export const ElementAndSeverityWiseIssuesFragmentDoc = gql`
	fragment ElementAndSeverityWiseIssues on ElementAndSeverityWiseIssues {
		_id
		element
		cosmeticIssueIds
		minorIssueIds
		majorIssueIds
		createdAt
		updatedAt
	}
`
export const ElementAndSeverityWiseIssuesStatsFragmentDoc = gql`
	fragment ElementAndSeverityWiseIssuesStats on ElementAndSeverityWiseIssuesStats {
		_id
		builderId
		unitId
		elements {
			...ElementAndSeverityWiseIssues
		}
		createdAt
		updatedAt
	}
	${ElementAndSeverityWiseIssuesFragmentDoc}
`
export const IssueItemFragmentDoc = gql`
	fragment IssueItem on IssueItem {
		_id
		issue
		createdAt
		updatedAt
	}
`
export const IssueTemplateFragmentDoc = gql`
	fragment IssueTemplate on IssueTemplate {
		_id
		element
		areaType
		label {
			...Label
		}
		issue {
			...Label
		}
		severity
	}
	${LabelFragmentDoc}
`
export const AddressFragmentDoc = gql`
	fragment Address on Address {
		street
		city
		state
		country
		postalCode
	}
`
export const ProjectFragmentDoc = gql`
	fragment Project on Project {
		_id
		builderId
		type
		label {
			...Label
		}
		address {
			...Address
		}
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
	${AddressFragmentDoc}
`
export const ProjectAndSeverityWiseIssuesStatsFragmentDoc = gql`
	fragment ProjectAndSeverityWiseIssuesStats on ProjectAndSeverityWiseIssuesStats {
		_id
		builderId
		projectId
		project {
			...Project
		}
		unitId
		cosmeticIssueIds
		minorIssueIds
		majorIssueIds
		createdAt
		updatedAt
	}
	${ProjectFragmentDoc}
`
export const UnitAndInspectionStatusFragmentDoc = gql`
	fragment UnitAndInspectionStatus on UnitAndInspectionStatus {
		unitId
		status
	}
`
export const ProjectAndStatusWiseInspectionsStatsFragmentDoc = gql`
	fragment ProjectAndStatusWiseInspectionsStats on ProjectAndStatusWiseInspectionsStats {
		_id
		builderId
		projectId
		project {
			...Project
		}
		statusWiseUnits {
			...UnitAndInspectionStatus
		}
		createdAt
		updatedAt
	}
	${ProjectFragmentDoc}
	${UnitAndInspectionStatusFragmentDoc}
`
export const ProjectWithFieldErrorsResponseFragmentDoc = gql`
	fragment ProjectWithFieldErrorsResponse on ProjectWithFieldErrorsResponse {
		errors {
			...FieldError
		}
		project {
			...Project
		}
	}
	${FieldErrorFragmentDoc}
	${ProjectFragmentDoc}
`
export const AreaFragmentDoc = gql`
	fragment Area on Area {
		_id
		label {
			...Label
		}
		type
		elements
		coordinatesOnUnitLayout
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
`
export const CoordinatesFragmentDoc = gql`
	fragment Coordinates on Coordinates {
		x
		y
	}
`
export const LayoutAreaCoordinatesFragmentDoc = gql`
	fragment LayoutAreaCoordinates on LayoutAreaCoordinates {
		_id
		areaId
		coordinates {
			...Coordinates
		}
	}
	${CoordinatesFragmentDoc}
`
export const UnitFragmentDoc = gql`
	fragment Unit on Unit {
		_id
		builderId
		projectId
		clusterId
		blockId
		label {
			...Label
		}
		configuration
		areas {
			...Area
		}
		layout {
			_id
			key
			url
			areaCoordinates {
				...LayoutAreaCoordinates
			}
		}
		customerInspectionTemplatePicture {
			...Picture
		}
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
	${AreaFragmentDoc}
	${LayoutAreaCoordinatesFragmentDoc}
	${PictureFragmentDoc}
`
export const EmailFragmentDoc = gql`
	fragment Email on Email {
		address
		isVerified
		verifiedAt
		createdAt
		updatedAt
	}
`
export const PhoneFragmentDoc = gql`
	fragment Phone on Phone {
		countryCode
		number
	}
`
export const UserFragmentDoc = gql`
	fragment User on User {
		_id
		builderId
		type
		name
		email {
			...Email
		}
		phone {
			...Phone
		}
		address {
			...Address
		}
		picture {
			...Picture
		}
		linkedElements
		createdAt
		updatedAt
	}
	${EmailFragmentDoc}
	${PhoneFragmentDoc}
	${AddressFragmentDoc}
	${PictureFragmentDoc}
`
export const ReferenceFragmentDoc = gql`
	fragment Reference on Reference {
		_id
		type
	}
`
export const StatusLifecycleFragmentDoc = gql`
	fragment StatusLifecycle on StatusLifecycle {
		_id
		status
		createdAt
		reference {
			...Reference
		}
		remarks
	}
	${ReferenceFragmentDoc}
`
export const DimensionFragmentDoc = gql`
	fragment Dimension on Dimension {
		unit
		value
		isInternalApproved
		internalRemarks
		isBuilderApproved
		builderRemarks
		isReInspected
	}
`
export const ReviewedDimensionFragmentDoc = gql`
	fragment ReviewedDimension on ReviewedDimension {
		unit
		value
	}
`
export const WaterQualityFragmentDoc = gql`
	fragment WaterQuality on WaterQuality {
		_id
		ph
		tds
		isInternalApproved
		internalRemarks
		isBuilderApproved
		builderRemarks
		isReInspected
	}
`
export const ReviewedWaterQualityFragmentDoc = gql`
	fragment ReviewedWaterQuality on ReviewedWaterQuality {
		_id
		ph
		tds
	}
`
export const AreaDimensionsFragmentDoc = gql`
	fragment AreaDimensions on AreaDimensions {
		_id
		areaId
		rects {
			length {
				...Dimension
			}
			width {
				...Dimension
			}
		}
		length {
			...Dimension
		}
		width {
			...Dimension
		}
		height {
			...Dimension
		}
		area {
			...Dimension
		}
		additionalArea {
			...Dimension
		}
		isInternalApproved
		internalRemarks
		isBuilderApproved
		builderRemarks
		isReInspected
	}
	${DimensionFragmentDoc}
`
export const ReviewedAreaDimensionsFragmentDoc = gql`
	fragment ReviewedAreaDimensions on ReviewedAreaDimensions {
		_id
		areaId
		rects {
			length {
				...Dimension
			}
			width {
				...Dimension
			}
		}
		length {
			...ReviewedDimension
		}
		width {
			...ReviewedDimension
		}
		height {
			...ReviewedDimension
		}
		area {
			...ReviewedDimension
		}
		additionalArea {
			...ReviewedDimension
		}
	}
	${DimensionFragmentDoc}
	${ReviewedDimensionFragmentDoc}
`
export const BrandItemFragmentDoc = gql`
	fragment BrandItem on BrandItem {
		_id
		builderId
		projectId
		clusterId
		blockId
		unitId
		areaId
		label {
			...Label
		}
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
`
export const BrandCheckFragmentDoc = gql`
	fragment BrandCheck on BrandCheck {
		_id
		areaId
		brandItemId
		brandItem {
			...BrandItem
		}
		isOk
		remarks
		isInternalApproved
		internalRemarks
		isBuilderApproved
		builderRemarks
		isReInspected
	}
	${BrandItemFragmentDoc}
`
export const ReviewedBrandCheckFragmentDoc = gql`
	fragment ReviewedBrandCheck on ReviewedBrandCheck {
		_id
		areaId
		brandItemId
		brandItem {
			...BrandItem
		}
		isOk
		remarks
	}
	${BrandItemFragmentDoc}
`
export const MaterialItemFragmentDoc = gql`
	fragment MaterialItem on MaterialItem {
		_id
		builderId
		projectId
		clusterId
		blockId
		unitId
		areaId
		label {
			...Label
		}
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
`
export const MaterialCheckFragmentDoc = gql`
	fragment MaterialCheck on MaterialCheck {
		_id
		areaId
		materialItemId
		materialItem {
			...MaterialItem
		}
		isOk
		remarks
		isInternalApproved
		internalRemarks
		isBuilderApproved
		builderRemarks
		isReInspected
	}
	${MaterialItemFragmentDoc}
`
export const ReviewedMaterialCheckFragmentDoc = gql`
	fragment ReviewedMaterialCheck on ReviewedMaterialCheck {
		_id
		areaId
		materialItemId
		materialItem {
			...MaterialItem
		}
		isOk
		remarks
	}
	${MaterialItemFragmentDoc}
`
export const IssueFragmentDoc = gql`
	fragment Issue on Issue {
		_id
		areaId
		element
		label {
			...Label
		}
		severity
		picture {
			...Picture
		}
		additionalPicture {
			...Picture
		}
		isCritical
		isInternalApproved
		internalRemarks
		isBuilderApproved
		builderRemarks
		isReInspected
		isCopiedFromPreSnagging
		postSnaggingPicture {
			...Picture
		}
		postSnaggingStatus
	}
	${LabelFragmentDoc}
	${PictureFragmentDoc}
`
export const ReviewedIssueFragmentDoc = gql`
	fragment ReviewedIssue on ReviewedIssue {
		_id
		areaId
		element
		label {
			...Label
		}
		severity
		picture {
			...Picture
		}
		isCritical
	}
	${LabelFragmentDoc}
	${PictureFragmentDoc}
`
export const WorkInProgressItemFragmentDoc = gql`
	fragment WorkInProgressItem on WorkInProgressItem {
		_id
		areaId
		element
		label {
			...Label
		}
		status
		picture {
			...Picture
		}
		estimatedDeadline
		isInternalApproved
		internalRemarks
		isBuilderApproved
		builderRemarks
		isReInspected
		isCopiedFromPreSnagging
		postSnaggingPicture {
			...Picture
		}
		postSnaggingStatus
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
	${PictureFragmentDoc}
`
export const ReviewedWorkInProgressItemFragmentDoc = gql`
	fragment ReviewedWorkInProgressItem on ReviewedWorkInProgressItem {
		_id
		areaId
		element
		label {
			...Label
		}
		status
		picture {
			...Picture
		}
		estimatedDeadline
		isCopiedFromPreSnagging
		postSnaggingPicture {
			...Picture
		}
		postSnaggingStatus
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
	${PictureFragmentDoc}
`
export const PostSnaggingInspectionRequestFragmentDoc = gql`
	fragment PostSnaggingInspectionRequest on PostSnaggingInspectionRequest {
		status
		statusLifecycle {
			...StatusLifecycle
		}
	}
	${StatusLifecycleFragmentDoc}
`
export const InspectionFragmentDoc = gql`
	fragment Inspection on Inspection {
		_id
		builderId
		projectId
		clusterId
		blockId
		unitId
		project {
			...Project
		}
		block {
			...Block
		}
		cluster {
			...Cluster
		}
		unit {
			...Unit
		}
		builder {
			...Builder
		}
		inspectorId
		inspector {
			...User
		}
		internalReviewerId
		builderReviewerId
		internalReviewer {
			...User
		}
		builderReviewer {
			...User
		}
		status
		type
		statusLifecycle {
			...StatusLifecycle
		}
		unitArea {
			...Dimension
		}
		reviewedUnitArea {
			...ReviewedDimension
		}
		waterQuality {
			...WaterQuality
		}
		reviewedWaterQuality {
			...ReviewedWaterQuality
		}
		dimensions {
			...AreaDimensions
		}
		reviewedDimensions {
			...ReviewedAreaDimensions
		}
		brandChecks {
			...BrandCheck
		}
		reviewedBrandChecks {
			...ReviewedBrandCheck
		}
		materialChecks {
			...MaterialCheck
		}
		reviewedMaterialChecks {
			...ReviewedMaterialCheck
		}
		issues {
			...Issue
		}
		reviewedIssues {
			...ReviewedIssue
		}
		workInProgressItems {
			...WorkInProgressItem
		}
		reviewedWorkInProgressItems {
			...ReviewedWorkInProgressItem
		}
		postSnaggingInspectionRequest {
			...PostSnaggingInspectionRequest
		}
		preSnaggingInspectionId
		postSnaggingInspectionId
		postSnaggingInspectionStatus
		rectificationId
		rectificationStatus
		createdAt
		updatedAt
	}
	${ProjectFragmentDoc}
	${BlockFragmentDoc}
	${ClusterFragmentDoc}
	${UnitFragmentDoc}
	${BuilderFragmentDoc}
	${UserFragmentDoc}
	${StatusLifecycleFragmentDoc}
	${DimensionFragmentDoc}
	${ReviewedDimensionFragmentDoc}
	${WaterQualityFragmentDoc}
	${ReviewedWaterQualityFragmentDoc}
	${AreaDimensionsFragmentDoc}
	${ReviewedAreaDimensionsFragmentDoc}
	${BrandCheckFragmentDoc}
	${ReviewedBrandCheckFragmentDoc}
	${MaterialCheckFragmentDoc}
	${ReviewedMaterialCheckFragmentDoc}
	${IssueFragmentDoc}
	${ReviewedIssueFragmentDoc}
	${WorkInProgressItemFragmentDoc}
	${ReviewedWorkInProgressItemFragmentDoc}
	${PostSnaggingInspectionRequestFragmentDoc}
`
export const RectificationIssueFragmentDoc = gql`
	fragment RectificationIssue on RectificationIssue {
		_id
		areaId
		element
		label {
			...Label
		}
		severity
		picture {
			...Picture
		}
		additionalPicture {
			...Picture
		}
		isCritical
		rectificationPicture {
			...Picture
		}
		isRectified
		rectificationRemarks
		isBuilderApproved
		builderRemarks
		offlineHash
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
	${PictureFragmentDoc}
`
export const ElementWiseRectificationFragmentDoc = gql`
	fragment ElementWiseRectification on ElementWiseRectification {
		element
		contractorId
		contractor {
			...User
		}
		status
		statusLifecycle {
			...StatusLifecycle
		}
		issues {
			...RectificationIssue
		}
	}
	${UserFragmentDoc}
	${StatusLifecycleFragmentDoc}
	${RectificationIssueFragmentDoc}
`
export const RectificationFragmentDoc = gql`
	fragment Rectification on Rectification {
		_id
		builderId
		builder {
			...Builder
		}
		projectId
		project {
			...Project
		}
		clusterId
		cluster {
			...Cluster
		}
		blockId
		block {
			...Block
		}
		unitId
		unit {
			...Unit
		}
		builderReviewerId
		builderReviewer {
			...User
		}
		preSnaggingInspectionId
		preSnaggingInspection {
			...Inspection
		}
		elementWiseRectifications {
			...ElementWiseRectification
		}
		contractorIds
		status
		statusLifecycle {
			...StatusLifecycle
		}
		isDeleted
		createdAt
		updatedAt
	}
	${BuilderFragmentDoc}
	${ProjectFragmentDoc}
	${ClusterFragmentDoc}
	${BlockFragmentDoc}
	${UnitFragmentDoc}
	${UserFragmentDoc}
	${InspectionFragmentDoc}
	${ElementWiseRectificationFragmentDoc}
	${StatusLifecycleFragmentDoc}
`
export const ReportObjectFragmentDoc = gql`
	fragment ReportObject on ReportObject {
		_id
		type
		element
		label {
			...Label
		}
		key
		url
	}
	${LabelFragmentDoc}
`
export const ReportFragmentDoc = gql`
	fragment Report on Report {
		_id
		publicId
		type
		builderId
		projectId
		clusterId
		blockId
		unitId
		inspectorId
		inspectionId
		builder {
			...Builder
		}
		cluster {
			...Cluster
		}
		block {
			...Block
		}
		unit {
			...Unit
		}
		inspector {
			...User
		}
		inspection {
			...Inspection
		}
		reports {
			...ReportObject
		}
		createdAt
		updatedAt
	}
	${BuilderFragmentDoc}
	${ClusterFragmentDoc}
	${BlockFragmentDoc}
	${UnitFragmentDoc}
	${UserFragmentDoc}
	${InspectionFragmentDoc}
	${ReportObjectFragmentDoc}
`
export const ServiceFragmentDoc = gql`
	fragment Service on Service {
		_id
		key
		label {
			...Label
		}
		lastHeartbeatAt
		isActive
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
`
export const StatusWiseInspectionsStatsFragmentDoc = gql`
	fragment StatusWiseInspectionsStats on StatusWiseInspectionsStats {
		_id
		builderId
		statusWiseUnits {
			...UnitAndInspectionStatus
		}
		builder {
			...Builder
		}
		createdAt
		updatedAt
	}
	${UnitAndInspectionStatusFragmentDoc}
	${BuilderFragmentDoc}
`
export const UnitCategoryBrandItemFragmentDoc = gql`
	fragment UnitCategoryBrandItem on UnitCategoryBrandItem {
		_id
		builderId
		projectId
		unitCategoryId
		areaId
		label {
			...Label
		}
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
`
export const UnitCategoryMaterialItemFragmentDoc = gql`
	fragment UnitCategoryMaterialItem on UnitCategoryMaterialItem {
		_id
		builderId
		projectId
		unitCategoryId
		areaId
		label {
			...Label
		}
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
`
export const UnitCategoryFragmentDoc = gql`
	fragment UnitCategory on UnitCategory {
		_id
		builderId
		builder {
			...Builder
		}
		projectId
		project {
			...Project
		}
		label {
			...Label
		}
		configuration
		areas {
			...Area
		}
		layout {
			_id
			key
			url
			areaCoordinates {
				...LayoutAreaCoordinates
			}
		}
		createdAt
		updatedAt
	}
	${BuilderFragmentDoc}
	${ProjectFragmentDoc}
	${LabelFragmentDoc}
	${AreaFragmentDoc}
	${LayoutAreaCoordinatesFragmentDoc}
`
export const GroupedUnitsFragmentDoc = gql`
	fragment GroupedUnits on GroupedUnits {
		_id
		unitCategoryId
		unitCategory {
			...UnitCategory
		}
		clusterId
		cluster {
			...Cluster
		}
		blockId
		block {
			...Block
		}
		unitIds
		units {
			...Unit
		}
	}
	${UnitCategoryFragmentDoc}
	${ClusterFragmentDoc}
	${BlockFragmentDoc}
	${UnitFragmentDoc}
`
export const UnitGroupFragmentDoc = gql`
	fragment UnitGroup on UnitGroup {
		_id
		builderId
		projectId
		label {
			...Label
		}
		units {
			...GroupedUnits
		}
		createdAt
		updatedAt
	}
	${LabelFragmentDoc}
	${GroupedUnitsFragmentDoc}
`
export const UnitWithFieldErrorsResponseFragmentDoc = gql`
	fragment UnitWithFieldErrorsResponse on UnitWithFieldErrorsResponse {
		errors {
			...FieldError
		}
		unit {
			...Unit
		}
	}
	${FieldErrorFragmentDoc}
	${UnitFragmentDoc}
`
export const UploadSignatureResponseFragmentDoc = gql`
	fragment UploadSignatureResponse on UploadSignatureResponse {
		signedUrl
		key
	}
`
export const UserAuthResponseFragmentDoc = gql`
	fragment UserAuthResponse on UserAuthResponse {
		user {
			...User
		}
		errors {
			...FieldError
		}
	}
	${UserFragmentDoc}
	${FieldErrorFragmentDoc}
`
export const UserWithFieldErrorsResponseFragmentDoc = gql`
	fragment UserWithFieldErrorsResponse on UserWithFieldErrorsResponse {
		errors {
			...FieldError
		}
		user {
			...User
		}
	}
	${FieldErrorFragmentDoc}
	${UserFragmentDoc}
`
export const UpdateInternalReviewerofInspectionDocument = gql`
	mutation UpdateInternalReviewerofInspection($internalReviewerId: String!, $inspectionId: String!) {
		updateInternalReviewerofInspection(internalReviewerId: $internalReviewerId, inspectionId: $inspectionId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useUpdateInternalReviewerofInspectionMutation() {
	return Urql.useMutation<UpdateInternalReviewerofInspectionMutation, UpdateInternalReviewerofInspectionMutationVariables>(UpdateInternalReviewerofInspectionDocument)
}
export const AddAdditionalIssuePictureDocument = gql`
	mutation AddAdditionalIssuePicture($inspectionId: String!, $issueId: String!, $pictureKey: String!) {
		addAdditionalIssuePicture(inspectionId: $inspectionId, issueId: $issueId, pictureKey: $pictureKey) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useAddAdditionalIssuePictureMutation() {
	return Urql.useMutation<AddAdditionalIssuePictureMutation, AddAdditionalIssuePictureMutationVariables>(AddAdditionalIssuePictureDocument)
}
export const AddAreaCoordinatesOnUnitCategoryLayoutDocument = gql`
	mutation AddAreaCoordinatesOnUnitCategoryLayout($unitCategoryId: String!, $areaId: String!, $coordinates: CoordinatesInput!) {
		addAreaCoordinatesOnUnitCategoryLayout(unitCategoryId: $unitCategoryId, areaId: $areaId, coordinates: $coordinates) {
			...UnitCategory
		}
	}
	${UnitCategoryFragmentDoc}
`

export function useAddAreaCoordinatesOnUnitCategoryLayoutMutation() {
	return Urql.useMutation<AddAreaCoordinatesOnUnitCategoryLayoutMutation, AddAreaCoordinatesOnUnitCategoryLayoutMutationVariables>(AddAreaCoordinatesOnUnitCategoryLayoutDocument)
}
export const AddAreaCoordinatesOnUnitLayoutDocument = gql`
	mutation AddAreaCoordinatesOnUnitLayout($unitId: String!, $areaId: String!, $coordinates: CoordinatesInput!) {
		addAreaCoordinatesOnUnitLayout(unitId: $unitId, areaId: $areaId, coordinates: $coordinates) {
			...Unit
		}
	}
	${UnitFragmentDoc}
`

export function useAddAreaCoordinatesOnUnitLayoutMutation() {
	return Urql.useMutation<AddAreaCoordinatesOnUnitLayoutMutation, AddAreaCoordinatesOnUnitLayoutMutationVariables>(AddAreaCoordinatesOnUnitLayoutDocument)
}
export const AddContractorToBuilderDocument = gql`
	mutation AddContractorToBuilder($builderId: String!, $contractorId: String!) {
		addContractorToBuilder(builderId: $builderId, contractorId: $contractorId) {
			...Builder
		}
	}
	${BuilderFragmentDoc}
`

export function useAddContractorToBuilderMutation() {
	return Urql.useMutation<AddContractorToBuilderMutation, AddContractorToBuilderMutationVariables>(AddContractorToBuilderDocument)
}
export const AddIssueDocument = gql`
	mutation AddIssue($inspectionId: String!, $areaId: String!, $element: Elements!, $input: IssueInput!) {
		addIssue(inspectionId: $inspectionId, areaId: $areaId, element: $element, input: $input) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useAddIssueMutation() {
	return Urql.useMutation<AddIssueMutation, AddIssueMutationVariables>(AddIssueDocument)
}
export const AddWaterQualityDocument = gql`
	mutation AddWaterQuality($inspectionId: String!, $input: WaterQualityInput!) {
		addWaterQuality(inspectionId: $inspectionId, input: $input) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useAddWaterQualityMutation() {
	return Urql.useMutation<AddWaterQualityMutation, AddWaterQualityMutationVariables>(AddWaterQualityDocument)
}
export const AssignBrandItemToAreaDocument = gql`
	mutation AssignBrandItemToArea($brandItemId: String!, $areaId: String!) {
		assignBrandItemToArea(brandItemId: $brandItemId, areaId: $areaId) {
			...BrandItem
		}
	}
	${BrandItemFragmentDoc}
`

export function useAssignBrandItemToAreaMutation() {
	return Urql.useMutation<AssignBrandItemToAreaMutation, AssignBrandItemToAreaMutationVariables>(AssignBrandItemToAreaDocument)
}
export const AssignMaterialItemToAreaDocument = gql`
	mutation AssignMaterialItemToArea($materialItemId: String!, $areaId: String!) {
		assignMaterialItemToArea(materialItemId: $materialItemId, areaId: $areaId) {
			...MaterialItem
		}
	}
	${MaterialItemFragmentDoc}
`

export function useAssignMaterialItemToAreaMutation() {
	return Urql.useMutation<AssignMaterialItemToAreaMutation, AssignMaterialItemToAreaMutationVariables>(AssignMaterialItemToAreaDocument)
}
export const AssignUnitCategoryBrandItemToAreaDocument = gql`
	mutation AssignUnitCategoryBrandItemToArea($brandItemId: String!, $areaId: String!) {
		assignUnitCategoryBrandItemToArea(brandItemId: $brandItemId, areaId: $areaId) {
			...UnitCategoryBrandItem
		}
	}
	${UnitCategoryBrandItemFragmentDoc}
`

export function useAssignUnitCategoryBrandItemToAreaMutation() {
	return Urql.useMutation<AssignUnitCategoryBrandItemToAreaMutation, AssignUnitCategoryBrandItemToAreaMutationVariables>(AssignUnitCategoryBrandItemToAreaDocument)
}
export const AssignUnitCategoryMaterialItemToAreaDocument = gql`
	mutation AssignUnitCategoryMaterialItemToArea($materialItemId: String!, $areaId: String!) {
		assignUnitCategoryMaterialItemToArea(materialItemId: $materialItemId, areaId: $areaId) {
			...UnitCategoryMaterialItem
		}
	}
	${UnitCategoryMaterialItemFragmentDoc}
`

export function useAssignUnitCategoryMaterialItemToAreaMutation() {
	return Urql.useMutation<AssignUnitCategoryMaterialItemToAreaMutation, AssignUnitCategoryMaterialItemToAreaMutationVariables>(AssignUnitCategoryMaterialItemToAreaDocument)
}
export const BuilderApproveAreaDimensionDocument = gql`
	mutation BuilderApproveAreaDimension($inspectionId: String!, $areaDimensionId: String!, $approval: Boolean!, $remarks: String) {
		builderApproveAreaDimension(inspectionId: $inspectionId, areaDimensionId: $areaDimensionId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useBuilderApproveAreaDimensionMutation() {
	return Urql.useMutation<BuilderApproveAreaDimensionMutation, BuilderApproveAreaDimensionMutationVariables>(BuilderApproveAreaDimensionDocument)
}
export const BuilderApproveBrandCheckDocument = gql`
	mutation BuilderApproveBrandCheck($inspectionId: String!, $brandCheckId: String!, $approval: Boolean!, $remarks: String) {
		builderApproveBrandCheck(inspectionId: $inspectionId, brandCheckId: $brandCheckId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useBuilderApproveBrandCheckMutation() {
	return Urql.useMutation<BuilderApproveBrandCheckMutation, BuilderApproveBrandCheckMutationVariables>(BuilderApproveBrandCheckDocument)
}
export const BuilderApproveIssueDocument = gql`
	mutation BuilderApproveIssue($inspectionId: String!, $issueId: String!, $approval: Boolean!, $remarks: String) {
		builderApproveIssue(inspectionId: $inspectionId, issueId: $issueId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useBuilderApproveIssueMutation() {
	return Urql.useMutation<BuilderApproveIssueMutation, BuilderApproveIssueMutationVariables>(BuilderApproveIssueDocument)
}
export const BuilderApproveMaterialCheckDocument = gql`
	mutation BuilderApproveMaterialCheck($inspectionId: String!, $materialCheckId: String!, $approval: Boolean!, $remarks: String) {
		builderApproveMaterialCheck(inspectionId: $inspectionId, materialCheckId: $materialCheckId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useBuilderApproveMaterialCheckMutation() {
	return Urql.useMutation<BuilderApproveMaterialCheckMutation, BuilderApproveMaterialCheckMutationVariables>(BuilderApproveMaterialCheckDocument)
}
export const BuilderApproveUnitAreaDocument = gql`
	mutation BuilderApproveUnitArea($inspectionId: String!, $approval: Boolean!, $remarks: String) {
		builderApproveUnitArea(inspectionId: $inspectionId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useBuilderApproveUnitAreaMutation() {
	return Urql.useMutation<BuilderApproveUnitAreaMutation, BuilderApproveUnitAreaMutationVariables>(BuilderApproveUnitAreaDocument)
}
export const BuilderApproveWaterQualityDocument = gql`
	mutation BuilderApproveWaterQuality($inspectionId: String!, $approval: Boolean!, $remarks: String) {
		builderApproveWaterQuality(inspectionId: $inspectionId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useBuilderApproveWaterQualityMutation() {
	return Urql.useMutation<BuilderApproveWaterQualityMutation, BuilderApproveWaterQualityMutationVariables>(BuilderApproveWaterQualityDocument)
}
export const BuilderApproveWorkInProgressItemDocument = gql`
	mutation BuilderApproveWorkInProgressItem($inspectionId: String!, $itemId: String!, $approval: Boolean!, $remarks: String) {
		builderApproveWorkInProgressItem(inspectionId: $inspectionId, itemId: $itemId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useBuilderApproveWorkInProgressItemMutation() {
	return Urql.useMutation<BuilderApproveWorkInProgressItemMutation, BuilderApproveWorkInProgressItemMutationVariables>(BuilderApproveWorkInProgressItemDocument)
}
export const BuilderReviewIssueRectificationDocument = gql`
	mutation BuilderReviewIssueRectification($rectificationId: String!, $element: Elements!, $issueId: String!, $approval: Boolean!, $remarks: String) {
		builderReviewIssueRectification(rectificationId: $rectificationId, element: $element, issueId: $issueId, approval: $approval, remarks: $remarks) {
			...Rectification
		}
	}
	${RectificationFragmentDoc}
`

export function useBuilderReviewIssueRectificationMutation() {
	return Urql.useMutation<BuilderReviewIssueRectificationMutation, BuilderReviewIssueRectificationMutationVariables>(BuilderReviewIssueRectificationDocument)
}
export const CreateAdminDocument = gql`
	mutation CreateAdmin($input: UserInput!) {
		createAdmin(input: $input) {
			...UserWithFieldErrorsResponse
		}
	}
	${UserWithFieldErrorsResponseFragmentDoc}
`

export function useCreateAdminMutation() {
	return Urql.useMutation<CreateAdminMutation, CreateAdminMutationVariables>(CreateAdminDocument)
}
export const CreateAreaDocument = gql`
	mutation CreateArea($unitId: String!, $input: AreaInput!) {
		createArea(unitId: $unitId, input: $input) {
			...Area
		}
	}
	${AreaFragmentDoc}
`

export function useCreateAreaMutation() {
	return Urql.useMutation<CreateAreaMutation, CreateAreaMutationVariables>(CreateAreaDocument)
}
export const CreateBlockDocument = gql`
	mutation CreateBlock($clusterId: String!, $input: BlockInput!) {
		createBlock(clusterId: $clusterId, input: $input) {
			...BlockWithFieldErrorsResponse
		}
	}
	${BlockWithFieldErrorsResponseFragmentDoc}
`

export function useCreateBlockMutation() {
	return Urql.useMutation<CreateBlockMutation, CreateBlockMutationVariables>(CreateBlockDocument)
}
export const CreateBlockLayoutDocument = gql`
	mutation CreateBlockLayout($blockId: String!, $rows: Int!, $columns: Int!) {
		createBlockLayout(blockId: $blockId, rows: $rows, columns: $columns) {
			...BlockLayoutWithFieldErrorsResponse
		}
	}
	${BlockLayoutWithFieldErrorsResponseFragmentDoc}
`

export function useCreateBlockLayoutMutation() {
	return Urql.useMutation<CreateBlockLayoutMutation, CreateBlockLayoutMutationVariables>(CreateBlockLayoutDocument)
}
export const CreateBrandItemsDocument = gql`
	mutation CreateBrandItems($unitId: String!, $areaId: String, $input: BrandItemInput!, $quantity: Int!) {
		createBrandItems(unitId: $unitId, areaId: $areaId, input: $input, quantity: $quantity) {
			...BrandItem
		}
	}
	${BrandItemFragmentDoc}
`

export function useCreateBrandItemsMutation() {
	return Urql.useMutation<CreateBrandItemsMutation, CreateBrandItemsMutationVariables>(CreateBrandItemsDocument)
}
export const CreateBuilderDocument = gql`
	mutation CreateBuilder($input: BuilderInput!) {
		createBuilder(input: $input) {
			...BuilderWithFieldErrorsResponse
		}
	}
	${BuilderWithFieldErrorsResponseFragmentDoc}
`

export function useCreateBuilderMutation() {
	return Urql.useMutation<CreateBuilderMutation, CreateBuilderMutationVariables>(CreateBuilderDocument)
}
export const CreateBuilderAdminDocument = gql`
	mutation CreateBuilderAdmin($builderId: String!, $input: UserInput!) {
		createBuilderAdmin(builderId: $builderId, input: $input) {
			...UserWithFieldErrorsResponse
		}
	}
	${UserWithFieldErrorsResponseFragmentDoc}
`

export function useCreateBuilderAdminMutation() {
	return Urql.useMutation<CreateBuilderAdminMutation, CreateBuilderAdminMutationVariables>(CreateBuilderAdminDocument)
}
export const CreateClusterDocument = gql`
	mutation CreateCluster($projectId: String!, $input: ClusterInput!) {
		createCluster(projectId: $projectId, input: $input) {
			...ClusterWithFieldErrorsResponse
		}
	}
	${ClusterWithFieldErrorsResponseFragmentDoc}
`

export function useCreateClusterMutation() {
	return Urql.useMutation<CreateClusterMutation, CreateClusterMutationVariables>(CreateClusterDocument)
}
export const CreateContractorDocument = gql`
	mutation CreateContractor($input: UserInput!, $linkedElements: [Elements!]!) {
		createContractor(input: $input, linkedElements: $linkedElements) {
			...UserWithFieldErrorsResponse
		}
	}
	${UserWithFieldErrorsResponseFragmentDoc}
`

export function useCreateContractorMutation() {
	return Urql.useMutation<CreateContractorMutation, CreateContractorMutationVariables>(CreateContractorDocument)
}
export const CreateElementDocument = gql`
	mutation CreateElement($unitId: String!, $areaId: String!, $element: Elements!) {
		createElement(unitId: $unitId, areaId: $areaId, element: $element) {
			...Area
		}
	}
	${AreaFragmentDoc}
`

export function useCreateElementMutation() {
	return Urql.useMutation<CreateElementMutation, CreateElementMutationVariables>(CreateElementDocument)
}
export const CreateInspectionDocument = gql`
	mutation CreateInspection($unitId: String!, $inspectorId: String!, $type: InspectionTypes!, $builderReviewerId: String!, $internalReviewerId: String!, $preSnaggingInspectionId: String) {
		createInspection(unitId: $unitId, inspectorId: $inspectorId, type: $type, builderReviewerId: $builderReviewerId, internalReviewerId: $internalReviewerId, preSnaggingInspectionId: $preSnaggingInspectionId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useCreateInspectionMutation() {
	return Urql.useMutation<CreateInspectionMutation, CreateInspectionMutationVariables>(CreateInspectionDocument)
}
export const CreateInspectorDocument = gql`
	mutation CreateInspector($input: UserInput!) {
		createInspector(input: $input) {
			...UserWithFieldErrorsResponse
		}
	}
	${UserWithFieldErrorsResponseFragmentDoc}
`

export function useCreateInspectorMutation() {
	return Urql.useMutation<CreateInspectorMutation, CreateInspectorMutationVariables>(CreateInspectorDocument)
}
export const CreateMaterialItemsDocument = gql`
	mutation CreateMaterialItems($unitId: String!, $areaId: String, $input: MaterialItemInput!, $quantity: Int!) {
		createMaterialItems(unitId: $unitId, areaId: $areaId, input: $input, quantity: $quantity) {
			...MaterialItem
		}
	}
	${MaterialItemFragmentDoc}
`

export function useCreateMaterialItemsMutation() {
	return Urql.useMutation<CreateMaterialItemsMutation, CreateMaterialItemsMutationVariables>(CreateMaterialItemsDocument)
}
export const CreatePostSnaggingInspectionRequestDocument = gql`
	mutation CreatePostSnaggingInspectionRequest($inspectionId: String!) {
		createPostSnaggingInspectionRequest(inspectionId: $inspectionId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useCreatePostSnaggingInspectionRequestMutation() {
	return Urql.useMutation<CreatePostSnaggingInspectionRequestMutation, CreatePostSnaggingInspectionRequestMutationVariables>(CreatePostSnaggingInspectionRequestDocument)
}
export const CreateProjectDocument = gql`
	mutation CreateProject($builderId: String!, $input: ProjectInput!) {
		createProject(builderId: $builderId, input: $input) {
			...ProjectWithFieldErrorsResponse
		}
	}
	${ProjectWithFieldErrorsResponseFragmentDoc}
`

export function useCreateProjectMutation() {
	return Urql.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument)
}
export const CreateProjectHeadDocument = gql`
	mutation CreateProjectHead($projectId: String!, $userId: String!) {
		createProjectHead(projectId: $projectId, userId: $userId) {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useCreateProjectHeadMutation() {
	return Urql.useMutation<CreateProjectHeadMutation, CreateProjectHeadMutationVariables>(CreateProjectHeadDocument)
}
export const CreateQualityHeadDocument = gql`
	mutation CreateQualityHead($projectId: String!, $userId: String!) {
		createQualityHead(projectId: $projectId, userId: $userId) {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useCreateQualityHeadMutation() {
	return Urql.useMutation<CreateQualityHeadMutation, CreateQualityHeadMutationVariables>(CreateQualityHeadDocument)
}
export const CreateRectificationDocument = gql`
	mutation CreateRectification($preSnaggingInspectionId: String!, $builderReviewerId: String!, $elementWiseContractors: [ElementWiseContractorInput!]!) {
		createRectification(preSnaggingInspectionId: $preSnaggingInspectionId, builderReviewerId: $builderReviewerId, elementWiseContractors: $elementWiseContractors) {
			...Rectification
		}
	}
	${RectificationFragmentDoc}
`

export function useCreateRectificationMutation() {
	return Urql.useMutation<CreateRectificationMutation, CreateRectificationMutationVariables>(CreateRectificationDocument)
}
export const CreateUnitDocument = gql`
	mutation CreateUnit($blockId: String!, $input: UnitInput!) {
		createUnit(blockId: $blockId, input: $input) {
			...UnitWithFieldErrorsResponse
		}
	}
	${UnitWithFieldErrorsResponseFragmentDoc}
`

export function useCreateUnitMutation() {
	return Urql.useMutation<CreateUnitMutation, CreateUnitMutationVariables>(CreateUnitDocument)
}
export const CreateUnitCategoryDocument = gql`
	mutation CreateUnitCategory($projectId: String!, $input: UnitCategoryInput!) {
		createUnitCategory(projectId: $projectId, input: $input) {
			errors {
				...FieldError
			}
			unitCategory {
				...UnitCategory
			}
		}
	}
	${FieldErrorFragmentDoc}
	${UnitCategoryFragmentDoc}
`

export function useCreateUnitCategoryMutation() {
	return Urql.useMutation<CreateUnitCategoryMutation, CreateUnitCategoryMutationVariables>(CreateUnitCategoryDocument)
}
export const CreateUnitCategoryAreaDocument = gql`
	mutation CreateUnitCategoryArea($unitCategoryId: String!, $input: AreaInput!) {
		createUnitCategoryArea(unitCategoryId: $unitCategoryId, input: $input) {
			...Area
		}
	}
	${AreaFragmentDoc}
`

export function useCreateUnitCategoryAreaMutation() {
	return Urql.useMutation<CreateUnitCategoryAreaMutation, CreateUnitCategoryAreaMutationVariables>(CreateUnitCategoryAreaDocument)
}
export const CreateUnitCategoryBrandItemsDocument = gql`
	mutation CreateUnitCategoryBrandItems($unitCategoryId: String!, $input: BrandItemInput!, $quantity: Int!, $areaId: String) {
		createUnitCategoryBrandItems(unitCategoryId: $unitCategoryId, input: $input, quantity: $quantity, areaId: $areaId) {
			...UnitCategoryBrandItem
		}
	}
	${UnitCategoryBrandItemFragmentDoc}
`

export function useCreateUnitCategoryBrandItemsMutation() {
	return Urql.useMutation<CreateUnitCategoryBrandItemsMutation, CreateUnitCategoryBrandItemsMutationVariables>(CreateUnitCategoryBrandItemsDocument)
}
export const CreateUnitCategoryElementDocument = gql`
	mutation CreateUnitCategoryElement($unitCategoryId: String!, $areaId: String!, $element: Elements!) {
		createUnitCategoryElement(unitCategoryId: $unitCategoryId, areaId: $areaId, element: $element) {
			...Area
		}
	}
	${AreaFragmentDoc}
`

export function useCreateUnitCategoryElementMutation() {
	return Urql.useMutation<CreateUnitCategoryElementMutation, CreateUnitCategoryElementMutationVariables>(CreateUnitCategoryElementDocument)
}
export const CreateUnitCategoryMaterialItemsDocument = gql`
	mutation CreateUnitCategoryMaterialItems($unitCategoryId: String!, $input: MaterialItemInput!, $quantity: Int!, $areaId: String) {
		createUnitCategoryMaterialItems(unitCategoryId: $unitCategoryId, input: $input, quantity: $quantity, areaId: $areaId) {
			...UnitCategoryMaterialItem
		}
	}
	${UnitCategoryMaterialItemFragmentDoc}
`

export function useCreateUnitCategoryMaterialItemsMutation() {
	return Urql.useMutation<CreateUnitCategoryMaterialItemsMutation, CreateUnitCategoryMaterialItemsMutationVariables>(CreateUnitCategoryMaterialItemsDocument)
}
export const CreateUnitGroupDocument = gql`
	mutation CreateUnitGroup($projectId: String!, $input: UnitGroupInput!) {
		createUnitGroup(projectId: $projectId, input: $input) {
			errors {
				...FieldError
			}
			unitGroup {
				...UnitGroup
			}
		}
	}
	${FieldErrorFragmentDoc}
	${UnitGroupFragmentDoc}
`

export function useCreateUnitGroupMutation() {
	return Urql.useMutation<CreateUnitGroupMutation, CreateUnitGroupMutationVariables>(CreateUnitGroupDocument)
}
export const DeleteAreaDocument = gql`
	mutation DeleteArea($unitId: String!, $areaId: String!) {
		deleteArea(unitId: $unitId, areaId: $areaId)
	}
`

export function useDeleteAreaMutation() {
	return Urql.useMutation<DeleteAreaMutation, DeleteAreaMutationVariables>(DeleteAreaDocument)
}
export const DeleteBlockDocument = gql`
	mutation DeleteBlock($blockId: String!) {
		deleteBlock(blockId: $blockId)
	}
`

export function useDeleteBlockMutation() {
	return Urql.useMutation<DeleteBlockMutation, DeleteBlockMutationVariables>(DeleteBlockDocument)
}
export const DeleteBlockLayoutDocument = gql`
	mutation DeleteBlockLayout($blockLayoutId: String!) {
		deleteBlockLayout(blockLayoutId: $blockLayoutId)
	}
`

export function useDeleteBlockLayoutMutation() {
	return Urql.useMutation<DeleteBlockLayoutMutation, DeleteBlockLayoutMutationVariables>(DeleteBlockLayoutDocument)
}
export const DeleteBrandItemDocument = gql`
	mutation DeleteBrandItem($brandItemId: String!) {
		deleteBrandItem(brandItemId: $brandItemId)
	}
`

export function useDeleteBrandItemMutation() {
	return Urql.useMutation<DeleteBrandItemMutation, DeleteBrandItemMutationVariables>(DeleteBrandItemDocument)
}
export const DeleteBuilderDocument = gql`
	mutation DeleteBuilder($builderId: String!) {
		deleteBuilder(builderId: $builderId)
	}
`

export function useDeleteBuilderMutation() {
	return Urql.useMutation<DeleteBuilderMutation, DeleteBuilderMutationVariables>(DeleteBuilderDocument)
}
export const DeleteBuilderAdminDocument = gql`
	mutation DeleteBuilderAdmin($builderAdminId: String!) {
		deleteBuilderAdmin(builderAdminId: $builderAdminId)
	}
`

export function useDeleteBuilderAdminMutation() {
	return Urql.useMutation<DeleteBuilderAdminMutation, DeleteBuilderAdminMutationVariables>(DeleteBuilderAdminDocument)
}
export const DeleteClusterDocument = gql`
	mutation DeleteCluster($clusterId: String!) {
		deleteCluster(clusterId: $clusterId)
	}
`

export function useDeleteClusterMutation() {
	return Urql.useMutation<DeleteClusterMutation, DeleteClusterMutationVariables>(DeleteClusterDocument)
}
export const DeleteContractorDocument = gql`
	mutation DeleteContractor($contractorId: String!) {
		deleteContractor(contractorId: $contractorId)
	}
`

export function useDeleteContractorMutation() {
	return Urql.useMutation<DeleteContractorMutation, DeleteContractorMutationVariables>(DeleteContractorDocument)
}
export const DeleteElementDocument = gql`
	mutation DeleteElement($unitId: String!, $areaId: String!, $element: Elements!) {
		deleteElement(unitId: $unitId, areaId: $areaId, element: $element)
	}
`

export function useDeleteElementMutation() {
	return Urql.useMutation<DeleteElementMutation, DeleteElementMutationVariables>(DeleteElementDocument)
}
export const DeleteInspectionDocument = gql`
	mutation DeleteInspection($inspectionId: String!) {
		deleteInspection(inspectionId: $inspectionId)
	}
`

export function useDeleteInspectionMutation() {
	return Urql.useMutation<DeleteInspectionMutation, DeleteInspectionMutationVariables>(DeleteInspectionDocument)
}
export const DeleteInspectorDocument = gql`
	mutation DeleteInspector($inspectorId: String!) {
		deleteInspector(inspectorId: $inspectorId)
	}
`

export function useDeleteInspectorMutation() {
	return Urql.useMutation<DeleteInspectorMutation, DeleteInspectorMutationVariables>(DeleteInspectorDocument)
}
export const DeleteIssueDocument = gql`
	mutation DeleteIssue($inspectionId: String!, $issueId: String!) {
		deleteIssue(inspectionId: $inspectionId, issueId: $issueId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useDeleteIssueMutation() {
	return Urql.useMutation<DeleteIssueMutation, DeleteIssueMutationVariables>(DeleteIssueDocument)
}
export const DeleteMaterialItemDocument = gql`
	mutation DeleteMaterialItem($materialItemId: String!) {
		deleteMaterialItem(materialItemId: $materialItemId)
	}
`

export function useDeleteMaterialItemMutation() {
	return Urql.useMutation<DeleteMaterialItemMutation, DeleteMaterialItemMutationVariables>(DeleteMaterialItemDocument)
}
export const DeleteProjectDocument = gql`
	mutation DeleteProject($projectId: String!) {
		deleteProject(projectId: $projectId)
	}
`

export function useDeleteProjectMutation() {
	return Urql.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument)
}
export const DeleteUnitDocument = gql`
	mutation DeleteUnit($unitId: String!) {
		deleteUnit(unitId: $unitId)
	}
`

export function useDeleteUnitMutation() {
	return Urql.useMutation<DeleteUnitMutation, DeleteUnitMutationVariables>(DeleteUnitDocument)
}
export const DeleteUnitCategoryDocument = gql`
	mutation DeleteUnitCategory($unitCategoryId: String!) {
		deleteUnitCategory(unitCategoryId: $unitCategoryId)
	}
`

export function useDeleteUnitCategoryMutation() {
	return Urql.useMutation<DeleteUnitCategoryMutation, DeleteUnitCategoryMutationVariables>(DeleteUnitCategoryDocument)
}
export const DeleteUnitCategoryAreaDocument = gql`
	mutation DeleteUnitCategoryArea($unitCategoryId: String!, $areaId: String!) {
		deleteUnitCategoryArea(unitCategoryId: $unitCategoryId, areaId: $areaId)
	}
`

export function useDeleteUnitCategoryAreaMutation() {
	return Urql.useMutation<DeleteUnitCategoryAreaMutation, DeleteUnitCategoryAreaMutationVariables>(DeleteUnitCategoryAreaDocument)
}
export const DeleteUnitCategoryBrandItemDocument = gql`
	mutation DeleteUnitCategoryBrandItem($brandItemId: String!) {
		deleteUnitCategoryBrandItem(brandItemId: $brandItemId)
	}
`

export function useDeleteUnitCategoryBrandItemMutation() {
	return Urql.useMutation<DeleteUnitCategoryBrandItemMutation, DeleteUnitCategoryBrandItemMutationVariables>(DeleteUnitCategoryBrandItemDocument)
}
export const DeleteUnitCategoryBrandItemFromAreaDocument = gql`
	mutation DeleteUnitCategoryBrandItemFromArea($brandItemId: String!) {
		deleteUnitCategoryBrandItemFromArea(brandItemId: $brandItemId)
	}
`

export function useDeleteUnitCategoryBrandItemFromAreaMutation() {
	return Urql.useMutation<DeleteUnitCategoryBrandItemFromAreaMutation, DeleteUnitCategoryBrandItemFromAreaMutationVariables>(DeleteUnitCategoryBrandItemFromAreaDocument)
}
export const DeleteUnitCategoryElementDocument = gql`
	mutation DeleteUnitCategoryElement($unitCategoryId: String!, $areaId: String!, $element: Elements!) {
		deleteUnitCategoryElement(unitCategoryId: $unitCategoryId, areaId: $areaId, element: $element)
	}
`

export function useDeleteUnitCategoryElementMutation() {
	return Urql.useMutation<DeleteUnitCategoryElementMutation, DeleteUnitCategoryElementMutationVariables>(DeleteUnitCategoryElementDocument)
}
export const DeleteUnitCategoryMaterialItemDocument = gql`
	mutation DeleteUnitCategoryMaterialItem($materialItemId: String!) {
		deleteUnitCategoryMaterialItem(materialItemId: $materialItemId)
	}
`

export function useDeleteUnitCategoryMaterialItemMutation() {
	return Urql.useMutation<DeleteUnitCategoryMaterialItemMutation, DeleteUnitCategoryMaterialItemMutationVariables>(DeleteUnitCategoryMaterialItemDocument)
}
export const DeleteUnitCategoryMaterialItemFromAreaDocument = gql`
	mutation DeleteUnitCategoryMaterialItemFromArea($materialItemId: String!) {
		deleteUnitCategoryMaterialItemFromArea(materialItemId: $materialItemId)
	}
`

export function useDeleteUnitCategoryMaterialItemFromAreaMutation() {
	return Urql.useMutation<DeleteUnitCategoryMaterialItemFromAreaMutation, DeleteUnitCategoryMaterialItemFromAreaMutationVariables>(DeleteUnitCategoryMaterialItemFromAreaDocument)
}
export const DeleteUnitGroupDocument = gql`
	mutation DeleteUnitGroup($unitGroupId: String!) {
		deleteUnitGroup(unitGroupId: $unitGroupId)
	}
`

export function useDeleteUnitGroupMutation() {
	return Urql.useMutation<DeleteUnitGroupMutation, DeleteUnitGroupMutationVariables>(DeleteUnitGroupDocument)
}
export const DeleteWorkInProgressItemDocument = gql`
	mutation DeleteWorkInProgressItem($inspectionId: String!, $itemId: String!) {
		deleteWorkInProgressItem(inspectionId: $inspectionId, itemId: $itemId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useDeleteWorkInProgressItemMutation() {
	return Urql.useMutation<DeleteWorkInProgressItemMutation, DeleteWorkInProgressItemMutationVariables>(DeleteWorkInProgressItemDocument)
}
export const FinishAvatarUploadDocument = gql`
	mutation FinishAvatarUpload($input: FinishUploadInput!) {
		finishAvatarUpload(input: $input) {
			...Picture
		}
	}
	${PictureFragmentDoc}
`

export function useFinishAvatarUploadMutation() {
	return Urql.useMutation<FinishAvatarUploadMutation, FinishAvatarUploadMutationVariables>(FinishAvatarUploadDocument)
}
export const FinishBuilderPictureUploadDocument = gql`
	mutation FinishBuilderPictureUpload($builderId: String!, $input: FinishUploadInput!) {
		finishBuilderPictureUpload(builderId: $builderId, input: $input) {
			...Picture
		}
	}
	${PictureFragmentDoc}
`

export function useFinishBuilderPictureUploadMutation() {
	return Urql.useMutation<FinishBuilderPictureUploadMutation, FinishBuilderPictureUploadMutationVariables>(FinishBuilderPictureUploadDocument)
}
export const FinishInspectionDocument = gql`
	mutation FinishInspection($inspectionId: String!) {
		finishInspection(inspectionId: $inspectionId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useFinishInspectionMutation() {
	return Urql.useMutation<FinishInspectionMutation, FinishInspectionMutationVariables>(FinishInspectionDocument)
}
export const FinishUnitCategoryLayoutPictureUploadDocument = gql`
	mutation FinishUnitCategoryLayoutPictureUpload($unitCategoryId: String!, $input: FinishUploadInput!) {
		finishUnitCategoryLayoutPictureUpload(unitCategoryId: $unitCategoryId, input: $input) {
			...UnitCategory
		}
	}
	${UnitCategoryFragmentDoc}
`

export function useFinishUnitCategoryLayoutPictureUploadMutation() {
	return Urql.useMutation<FinishUnitCategoryLayoutPictureUploadMutation, FinishUnitCategoryLayoutPictureUploadMutationVariables>(FinishUnitCategoryLayoutPictureUploadDocument)
}
export const FinishUnitCustomerInspectionTemplatePictureUploadDocument = gql`
	mutation FinishUnitCustomerInspectionTemplatePictureUpload($unitId: String!, $input: FinishUploadInput!) {
		finishUnitCustomerInspectionTemplatePictureUpload(unitId: $unitId, input: $input) {
			...Unit
		}
	}
	${UnitFragmentDoc}
`

export function useFinishUnitCustomerInspectionTemplatePictureUploadMutation() {
	return Urql.useMutation<FinishUnitCustomerInspectionTemplatePictureUploadMutation, FinishUnitCustomerInspectionTemplatePictureUploadMutationVariables>(FinishUnitCustomerInspectionTemplatePictureUploadDocument)
}
export const FinishUnitLayoutPictureUploadDocument = gql`
	mutation FinishUnitLayoutPictureUpload($unitId: String!, $input: FinishUploadInput!) {
		finishUnitLayoutPictureUpload(unitId: $unitId, input: $input) {
			...Unit
		}
	}
	${UnitFragmentDoc}
`

export function useFinishUnitLayoutPictureUploadMutation() {
	return Urql.useMutation<FinishUnitLayoutPictureUploadMutation, FinishUnitLayoutPictureUploadMutationVariables>(FinishUnitLayoutPictureUploadDocument)
}
export const InternalApproveAreaDimensionDocument = gql`
	mutation InternalApproveAreaDimension($inspectionId: String!, $areaDimensionId: String!, $approval: Boolean!, $remarks: String) {
		internalApproveAreaDimension(inspectionId: $inspectionId, areaDimensionId: $areaDimensionId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useInternalApproveAreaDimensionMutation() {
	return Urql.useMutation<InternalApproveAreaDimensionMutation, InternalApproveAreaDimensionMutationVariables>(InternalApproveAreaDimensionDocument)
}
export const InternalApproveBrandCheckDocument = gql`
	mutation InternalApproveBrandCheck($inspectionId: String!, $brandCheckId: String!, $approval: Boolean!, $remarks: String) {
		internalApproveBrandCheck(inspectionId: $inspectionId, brandCheckId: $brandCheckId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useInternalApproveBrandCheckMutation() {
	return Urql.useMutation<InternalApproveBrandCheckMutation, InternalApproveBrandCheckMutationVariables>(InternalApproveBrandCheckDocument)
}
export const InternalApproveIssueDocument = gql`
	mutation InternalApproveIssue($inspectionId: String!, $issueId: String!, $approval: Boolean!, $remarks: String) {
		internalApproveIssue(inspectionId: $inspectionId, issueId: $issueId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useInternalApproveIssueMutation() {
	return Urql.useMutation<InternalApproveIssueMutation, InternalApproveIssueMutationVariables>(InternalApproveIssueDocument)
}
export const InternalApproveMaterialCheckDocument = gql`
	mutation InternalApproveMaterialCheck($inspectionId: String!, $materialCheckId: String!, $approval: Boolean!, $remarks: String) {
		internalApproveMaterialCheck(inspectionId: $inspectionId, materialCheckId: $materialCheckId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useInternalApproveMaterialCheckMutation() {
	return Urql.useMutation<InternalApproveMaterialCheckMutation, InternalApproveMaterialCheckMutationVariables>(InternalApproveMaterialCheckDocument)
}
export const InternalApproveUnitAreaDocument = gql`
	mutation InternalApproveUnitArea($inspectionId: String!, $approval: Boolean!, $remarks: String) {
		internalApproveUnitArea(inspectionId: $inspectionId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useInternalApproveUnitAreaMutation() {
	return Urql.useMutation<InternalApproveUnitAreaMutation, InternalApproveUnitAreaMutationVariables>(InternalApproveUnitAreaDocument)
}
export const InternalApproveWaterQualityDocument = gql`
	mutation InternalApproveWaterQuality($inspectionId: String!, $approval: Boolean!, $remarks: String) {
		internalApproveWaterQuality(inspectionId: $inspectionId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useInternalApproveWaterQualityMutation() {
	return Urql.useMutation<InternalApproveWaterQualityMutation, InternalApproveWaterQualityMutationVariables>(InternalApproveWaterQualityDocument)
}
export const InternalApproveWorkInProgressItemDocument = gql`
	mutation InternalApproveWorkInProgressItem($inspectionId: String!, $itemId: String!, $approval: Boolean!, $remarks: String) {
		internalApproveWorkInProgressItem(inspectionId: $inspectionId, itemId: $itemId, approval: $approval, remarks: $remarks) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useInternalApproveWorkInProgressItemMutation() {
	return Urql.useMutation<InternalApproveWorkInProgressItemMutation, InternalApproveWorkInProgressItemMutationVariables>(InternalApproveWorkInProgressItemDocument)
}
export const MapUnitToBlockLayoutDocument = gql`
	mutation MapUnitToBlockLayout($blockLayoutId: String!, $unitId: String!, $column: Int!, $row: Int!) {
		mapUnitToBlockLayout(blockLayoutId: $blockLayoutId, unitId: $unitId, column: $column, row: $row)
	}
`

export function useMapUnitToBlockLayoutMutation() {
	return Urql.useMutation<MapUnitToBlockLayoutMutation, MapUnitToBlockLayoutMutationVariables>(MapUnitToBlockLayoutDocument)
}
export const RejectBuilderReviewDocument = gql`
	mutation RejectBuilderReview($inspectionId: String!) {
		rejectBuilderReview(inspectionId: $inspectionId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useRejectBuilderReviewMutation() {
	return Urql.useMutation<RejectBuilderReviewMutation, RejectBuilderReviewMutationVariables>(RejectBuilderReviewDocument)
}
export const RemoveAdditionalIssuePictureDocument = gql`
	mutation RemoveAdditionalIssuePicture($inspectionId: String!, $issueId: String!) {
		removeAdditionalIssuePicture(inspectionId: $inspectionId, issueId: $issueId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useRemoveAdditionalIssuePictureMutation() {
	return Urql.useMutation<RemoveAdditionalIssuePictureMutation, RemoveAdditionalIssuePictureMutationVariables>(RemoveAdditionalIssuePictureDocument)
}
export const RemoveAreaCoordinatesFromUnitCategoryLayoutDocument = gql`
	mutation RemoveAreaCoordinatesFromUnitCategoryLayout($unitCategoryId: String!, $coordinatesId: String!) {
		removeAreaCoordinatesFromUnitCategoryLayout(unitCategoryId: $unitCategoryId, coordinatesId: $coordinatesId) {
			...UnitCategory
		}
	}
	${UnitCategoryFragmentDoc}
`

export function useRemoveAreaCoordinatesFromUnitCategoryLayoutMutation() {
	return Urql.useMutation<RemoveAreaCoordinatesFromUnitCategoryLayoutMutation, RemoveAreaCoordinatesFromUnitCategoryLayoutMutationVariables>(RemoveAreaCoordinatesFromUnitCategoryLayoutDocument)
}
export const RemoveAreaCoordinatesFromUnitLayoutDocument = gql`
	mutation RemoveAreaCoordinatesFromUnitLayout($unitId: String!, $coordinatesId: String!) {
		removeAreaCoordinatesFromUnitLayout(unitId: $unitId, coordinatesId: $coordinatesId) {
			...Unit
		}
	}
	${UnitFragmentDoc}
`

export function useRemoveAreaCoordinatesFromUnitLayoutMutation() {
	return Urql.useMutation<RemoveAreaCoordinatesFromUnitLayoutMutation, RemoveAreaCoordinatesFromUnitLayoutMutationVariables>(RemoveAreaCoordinatesFromUnitLayoutDocument)
}
export const RemoveContractorFromBuilderDocument = gql`
	mutation RemoveContractorFromBuilder($builderId: String!, $contractorId: String!) {
		removeContractorFromBuilder(builderId: $builderId, contractorId: $contractorId) {
			...Builder
		}
	}
	${BuilderFragmentDoc}
`

export function useRemoveContractorFromBuilderMutation() {
	return Urql.useMutation<RemoveContractorFromBuilderMutation, RemoveContractorFromBuilderMutationVariables>(RemoveContractorFromBuilderDocument)
}
export const RemoveCustomerInspectionTemplatePictureFromUnitDocument = gql`
	mutation RemoveCustomerInspectionTemplatePictureFromUnit($unitId: String!) {
		removeCustomerInspectionTemplatePictureFromUnit(unitId: $unitId) {
			...Unit
		}
	}
	${UnitFragmentDoc}
`

export function useRemoveCustomerInspectionTemplatePictureFromUnitMutation() {
	return Urql.useMutation<RemoveCustomerInspectionTemplatePictureFromUnitMutation, RemoveCustomerInspectionTemplatePictureFromUnitMutationVariables>(RemoveCustomerInspectionTemplatePictureFromUnitDocument)
}
export const RemoveUnitFromBlockLayoutDocument = gql`
	mutation RemoveUnitFromBlockLayout($blockLayoutId: String!, $unitId: String!, $column: Int!, $row: Int!) {
		removeUnitFromBlockLayout(blockLayoutId: $blockLayoutId, unitId: $unitId, column: $column, row: $row)
	}
`

export function useRemoveUnitFromBlockLayoutMutation() {
	return Urql.useMutation<RemoveUnitFromBlockLayoutMutation, RemoveUnitFromBlockLayoutMutationVariables>(RemoveUnitFromBlockLayoutDocument)
}
export const SendChangePasswordEmailDocument = gql`
	mutation SendChangePasswordEmail {
		sendChangePasswordEmail
	}
`

export function useSendChangePasswordEmailMutation() {
	return Urql.useMutation<SendChangePasswordEmailMutation, SendChangePasswordEmailMutationVariables>(SendChangePasswordEmailDocument)
}
export const SendPasswordResetEmailDocument = gql`
	mutation SendPasswordResetEmail($emailAddress: String!) {
		sendPasswordResetEmail(emailAddress: $emailAddress)
	}
`

export function useSendPasswordResetEmailMutation() {
	return Urql.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument)
}
export const SignAvatarUploadDocument = gql`
	mutation SignAvatarUpload($format: String!) {
		signAvatarUpload(format: $format) {
			...UploadSignatureResponse
		}
	}
	${UploadSignatureResponseFragmentDoc}
`

export function useSignAvatarUploadMutation() {
	return Urql.useMutation<SignAvatarUploadMutation, SignAvatarUploadMutationVariables>(SignAvatarUploadDocument)
}
export const SignBuilderPictureUploadDocument = gql`
	mutation SignBuilderPictureUpload($builderId: String!, $format: String!) {
		signBuilderPictureUpload(builderId: $builderId, format: $format) {
			...UploadSignatureResponse
		}
	}
	${UploadSignatureResponseFragmentDoc}
`

export function useSignBuilderPictureUploadMutation() {
	return Urql.useMutation<SignBuilderPictureUploadMutation, SignBuilderPictureUploadMutationVariables>(SignBuilderPictureUploadDocument)
}
export const SignIssuePictureUploadDocument = gql`
	mutation SignIssuePictureUpload($inspectionId: String!, $contentType: String!) {
		signIssuePictureUpload(inspectionId: $inspectionId, contentType: $contentType) {
			key
			signedUrl
		}
	}
`

export function useSignIssuePictureUploadMutation() {
	return Urql.useMutation<SignIssuePictureUploadMutation, SignIssuePictureUploadMutationVariables>(SignIssuePictureUploadDocument)
}
export const SignUnitCategoryLayoutPictureUploadDocument = gql`
	mutation SignUnitCategoryLayoutPictureUpload($unitCategoryId: String!, $contentType: String!) {
		signUnitCategoryLayoutPictureUpload(unitCategoryId: $unitCategoryId, contentType: $contentType) {
			key
			signedUrl
		}
	}
`

export function useSignUnitCategoryLayoutPictureUploadMutation() {
	return Urql.useMutation<SignUnitCategoryLayoutPictureUploadMutation, SignUnitCategoryLayoutPictureUploadMutationVariables>(SignUnitCategoryLayoutPictureUploadDocument)
}
export const SignUnitCustomerInspectionTemplatePictureUploadDocument = gql`
	mutation SignUnitCustomerInspectionTemplatePictureUpload($unitId: String!, $contentType: String!) {
		signUnitCustomerInspectionTemplatePictureUpload(unitId: $unitId, contentType: $contentType) {
			key
			signedUrl
		}
	}
`

export function useSignUnitCustomerInspectionTemplatePictureUploadMutation() {
	return Urql.useMutation<SignUnitCustomerInspectionTemplatePictureUploadMutation, SignUnitCustomerInspectionTemplatePictureUploadMutationVariables>(SignUnitCustomerInspectionTemplatePictureUploadDocument)
}
export const SignUnitLayoutPictureUploadDocument = gql`
	mutation SignUnitLayoutPictureUpload($unitId: String!, $contentType: String!) {
		signUnitLayoutPictureUpload(unitId: $unitId, contentType: $contentType) {
			key
			signedUrl
		}
	}
`

export function useSignUnitLayoutPictureUploadMutation() {
	return Urql.useMutation<SignUnitLayoutPictureUploadMutation, SignUnitLayoutPictureUploadMutationVariables>(SignUnitLayoutPictureUploadDocument)
}
export const SigninDocument = gql`
	mutation Signin($emailAddress: String!, $password: String!) {
		signin(emailAddress: $emailAddress, password: $password) {
			...UserAuthResponse
		}
	}
	${UserAuthResponseFragmentDoc}
`

export function useSigninMutation() {
	return Urql.useMutation<SigninMutation, SigninMutationVariables>(SigninDocument)
}
export const SigninWithEmailTokenDocument = gql`
	mutation SigninWithEmailToken($emailAddress: String!, $token: String!, $newPassword: String!) {
		signinWithEmailToken(emailAddress: $emailAddress, token: $token, newPassword: $newPassword) {
			...UserAuthResponse
		}
	}
	${UserAuthResponseFragmentDoc}
`

export function useSigninWithEmailTokenMutation() {
	return Urql.useMutation<SigninWithEmailTokenMutation, SigninWithEmailTokenMutationVariables>(SigninWithEmailTokenDocument)
}
export const SignoutDocument = gql`
	mutation Signout {
		signout
	}
`

export function useSignoutMutation() {
	return Urql.useMutation<SignoutMutation, SignoutMutationVariables>(SignoutDocument)
}
export const StartInspectionDocument = gql`
	mutation StartInspection($inspectionId: String!) {
		startInspection(inspectionId: $inspectionId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useStartInspectionMutation() {
	return Urql.useMutation<StartInspectionMutation, StartInspectionMutationVariables>(StartInspectionDocument)
}
export const SubmitBuilderElementWiseRectificationReviewDocument = gql`
	mutation SubmitBuilderElementWiseRectificationReview($rectificationId: String!, $element: Elements!) {
		submitBuilderElementWiseRectificationReview(rectificationId: $rectificationId, element: $element) {
			...Rectification
		}
	}
	${RectificationFragmentDoc}
`

export function useSubmitBuilderElementWiseRectificationReviewMutation() {
	return Urql.useMutation<SubmitBuilderElementWiseRectificationReviewMutation, SubmitBuilderElementWiseRectificationReviewMutationVariables>(SubmitBuilderElementWiseRectificationReviewDocument)
}
export const SubmitBuilderRectificationReviewDocument = gql`
	mutation SubmitBuilderRectificationReview($rectificationId: String!) {
		submitBuilderRectificationReview(rectificationId: $rectificationId) {
			...Rectification
		}
	}
	${RectificationFragmentDoc}
`

export function useSubmitBuilderRectificationReviewMutation() {
	return Urql.useMutation<SubmitBuilderRectificationReviewMutation, SubmitBuilderRectificationReviewMutationVariables>(SubmitBuilderRectificationReviewDocument)
}
export const SubmitBuilderReviewDocument = gql`
	mutation SubmitBuilderReview($inspectionId: String!) {
		submitBuilderReview(inspectionId: $inspectionId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useSubmitBuilderReviewMutation() {
	return Urql.useMutation<SubmitBuilderReviewMutation, SubmitBuilderReviewMutationVariables>(SubmitBuilderReviewDocument)
}
export const SubmitInternalReviewDocument = gql`
	mutation SubmitInternalReview($inspectionId: String!) {
		submitInternalReview(inspectionId: $inspectionId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useSubmitInternalReviewMutation() {
	return Urql.useMutation<SubmitInternalReviewMutation, SubmitInternalReviewMutationVariables>(SubmitInternalReviewDocument)
}
export const UpdateAreaDocument = gql`
	mutation UpdateArea($unitId: String!, $areaId: String!, $input: AreaInput!) {
		updateArea(unitId: $unitId, areaId: $areaId, input: $input) {
			...Area
		}
	}
	${AreaFragmentDoc}
`

export function useUpdateAreaMutation() {
	return Urql.useMutation<UpdateAreaMutation, UpdateAreaMutationVariables>(UpdateAreaDocument)
}
export const UpdateAreaDimensionsDocument = gql`
	mutation UpdateAreaDimensions($inspectionId: String!, $areaDimensionsId: String!, $input: AreaDimensionsInput!) {
		updateAreaDimensions(inspectionId: $inspectionId, areaDimensionsId: $areaDimensionsId, input: $input) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useUpdateAreaDimensionsMutation() {
	return Urql.useMutation<UpdateAreaDimensionsMutation, UpdateAreaDimensionsMutationVariables>(UpdateAreaDimensionsDocument)
}
export const UpdateBlockDocument = gql`
	mutation UpdateBlock($blockId: String!, $input: BlockInput!) {
		updateBlock(blockId: $blockId, input: $input) {
			...BlockWithFieldErrorsResponse
		}
	}
	${BlockWithFieldErrorsResponseFragmentDoc}
`

export function useUpdateBlockMutation() {
	return Urql.useMutation<UpdateBlockMutation, UpdateBlockMutationVariables>(UpdateBlockDocument)
}
export const UpdateBlockLayoutDocument = gql`
	mutation UpdateBlockLayout($blockLayoutId: String!, $rows: Int!, $columns: Int!) {
		updateBlockLayout(blockLayoutId: $blockLayoutId, rows: $rows, columns: $columns) {
			...BlockLayoutWithFieldErrorsResponse
		}
	}
	${BlockLayoutWithFieldErrorsResponseFragmentDoc}
`

export function useUpdateBlockLayoutMutation() {
	return Urql.useMutation<UpdateBlockLayoutMutation, UpdateBlockLayoutMutationVariables>(UpdateBlockLayoutDocument)
}
export const UpdateBrandCheckDocument = gql`
	mutation UpdateBrandCheck($inspectionId: String!, $brandCheckId: String!, $input: BrandCheckInput!) {
		updateBrandCheck(inspectionId: $inspectionId, brandCheckId: $brandCheckId, input: $input) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useUpdateBrandCheckMutation() {
	return Urql.useMutation<UpdateBrandCheckMutation, UpdateBrandCheckMutationVariables>(UpdateBrandCheckDocument)
}
export const UpdateBrandItemDocument = gql`
	mutation UpdateBrandItem($brandItemId: String!, $input: BrandItemInput!) {
		updateBrandItem(brandItemId: $brandItemId, input: $input) {
			...BrandItem
		}
	}
	${BrandItemFragmentDoc}
`

export function useUpdateBrandItemMutation() {
	return Urql.useMutation<UpdateBrandItemMutation, UpdateBrandItemMutationVariables>(UpdateBrandItemDocument)
}
export const UpdateBuilderDocument = gql`
	mutation UpdateBuilder($builderId: String!, $input: BuilderInput!) {
		updateBuilder(builderId: $builderId, input: $input) {
			...BuilderWithFieldErrorsResponse
		}
	}
	${BuilderWithFieldErrorsResponseFragmentDoc}
`

export function useUpdateBuilderMutation() {
	return Urql.useMutation<UpdateBuilderMutation, UpdateBuilderMutationVariables>(UpdateBuilderDocument)
}
export const UpdateBuilderAdminDocument = gql`
	mutation UpdateBuilderAdmin($builderAdminId: String!, $input: UpdateUserInput!) {
		updateBuilderAdmin(builderAdminId: $builderAdminId, input: $input) {
			...UserWithFieldErrorsResponse
		}
	}
	${UserWithFieldErrorsResponseFragmentDoc}
`

export function useUpdateBuilderAdminMutation() {
	return Urql.useMutation<UpdateBuilderAdminMutation, UpdateBuilderAdminMutationVariables>(UpdateBuilderAdminDocument)
}
export const UpdateBuilderReviewerofInspectionDocument = gql`
	mutation UpdateBuilderReviewerofInspection($builderReviewerId: String!, $inspectionId: String!) {
		updateBuilderReviewerofInspection(builderReviewerId: $builderReviewerId, inspectionId: $inspectionId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useUpdateBuilderReviewerofInspectionMutation() {
	return Urql.useMutation<UpdateBuilderReviewerofInspectionMutation, UpdateBuilderReviewerofInspectionMutationVariables>(UpdateBuilderReviewerofInspectionDocument)
}
export const UpdateClusterDocument = gql`
	mutation UpdateCluster($clusterId: String!, $input: ClusterInput!) {
		updateCluster(clusterId: $clusterId, input: $input) {
			...ClusterWithFieldErrorsResponse
		}
	}
	${ClusterWithFieldErrorsResponseFragmentDoc}
`

export function useUpdateClusterMutation() {
	return Urql.useMutation<UpdateClusterMutation, UpdateClusterMutationVariables>(UpdateClusterDocument)
}
export const UpdateContractorDocument = gql`
	mutation UpdateContractor($contractorId: String!, $input: UpdateUserInput!, $linkedElements: [Elements!]!) {
		updateContractor(contractorId: $contractorId, input: $input, linkedElements: $linkedElements) {
			...UserWithFieldErrorsResponse
		}
	}
	${UserWithFieldErrorsResponseFragmentDoc}
`

export function useUpdateContractorMutation() {
	return Urql.useMutation<UpdateContractorMutation, UpdateContractorMutationVariables>(UpdateContractorDocument)
}
export const UpdateContractorForElementRectificationDocument = gql`
	mutation UpdateContractorForElementRectification($rectificationId: String!, $element: Elements!, $contractorId: String!, $remarks: String!) {
		updateContractorForElementRectification(rectificationId: $rectificationId, element: $element, contractorId: $contractorId, remarks: $remarks) {
			...Rectification
		}
	}
	${RectificationFragmentDoc}
`

export function useUpdateContractorForElementRectificationMutation() {
	return Urql.useMutation<UpdateContractorForElementRectificationMutation, UpdateContractorForElementRectificationMutationVariables>(UpdateContractorForElementRectificationDocument)
}
export const UpdateInspectorDocument = gql`
	mutation UpdateInspector($inspectorId: String!, $input: UpdateUserInput!) {
		updateInspector(inspectorId: $inspectorId, input: $input) {
			...UserWithFieldErrorsResponse
		}
	}
	${UserWithFieldErrorsResponseFragmentDoc}
`

export function useUpdateInspectorMutation() {
	return Urql.useMutation<UpdateInspectorMutation, UpdateInspectorMutationVariables>(UpdateInspectorDocument)
}
export const UpdateInspectorofInspectionDocument = gql`
	mutation UpdateInspectorofInspection($inspectorId: String!, $inspectionId: String!) {
		updateInspectorofInspection(inspectorId: $inspectorId, inspectionId: $inspectionId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useUpdateInspectorofInspectionMutation() {
	return Urql.useMutation<UpdateInspectorofInspectionMutation, UpdateInspectorofInspectionMutationVariables>(UpdateInspectorofInspectionDocument)
}
export const UpdateIssueDocument = gql`
	mutation UpdateIssue($inspectionId: String!, $issueId: String!, $input: UpdateIssueInput!) {
		updateIssue(inspectionId: $inspectionId, issueId: $issueId, input: $input) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useUpdateIssueMutation() {
	return Urql.useMutation<UpdateIssueMutation, UpdateIssueMutationVariables>(UpdateIssueDocument)
}
export const UpdateMaterialCheckDocument = gql`
	mutation UpdateMaterialCheck($inspectionId: String!, $materialCheckId: String!, $input: MaterialCheckInput!) {
		updateMaterialCheck(inspectionId: $inspectionId, materialCheckId: $materialCheckId, input: $input) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useUpdateMaterialCheckMutation() {
	return Urql.useMutation<UpdateMaterialCheckMutation, UpdateMaterialCheckMutationVariables>(UpdateMaterialCheckDocument)
}
export const UpdateMaterialItemDocument = gql`
	mutation UpdateMaterialItem($materialItemId: String!, $input: MaterialItemInput!) {
		updateMaterialItem(materialItemId: $materialItemId, input: $input) {
			...MaterialItem
		}
	}
	${MaterialItemFragmentDoc}
`

export function useUpdateMaterialItemMutation() {
	return Urql.useMutation<UpdateMaterialItemMutation, UpdateMaterialItemMutationVariables>(UpdateMaterialItemDocument)
}
export const UpdateProjectDocument = gql`
	mutation UpdateProject($projectId: String!, $input: ProjectInput!) {
		updateProject(projectId: $projectId, input: $input) {
			...ProjectWithFieldErrorsResponse
		}
	}
	${ProjectWithFieldErrorsResponseFragmentDoc}
`

export function useUpdateProjectMutation() {
	return Urql.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument)
}
export const UpdateUnitDocument = gql`
	mutation UpdateUnit($unitId: String!, $input: UnitInput!) {
		updateUnit(unitId: $unitId, input: $input) {
			...UnitWithFieldErrorsResponse
		}
	}
	${UnitWithFieldErrorsResponseFragmentDoc}
`

export function useUpdateUnitMutation() {
	return Urql.useMutation<UpdateUnitMutation, UpdateUnitMutationVariables>(UpdateUnitDocument)
}
export const UpdateUnitCategoryAreaDocument = gql`
	mutation UpdateUnitCategoryArea($unitCategoryId: String!, $areaId: String!, $input: AreaInput!) {
		updateUnitCategoryArea(unitCategoryId: $unitCategoryId, areaId: $areaId, input: $input) {
			...Area
		}
	}
	${AreaFragmentDoc}
`

export function useUpdateUnitCategoryAreaMutation() {
	return Urql.useMutation<UpdateUnitCategoryAreaMutation, UpdateUnitCategoryAreaMutationVariables>(UpdateUnitCategoryAreaDocument)
}
export const UpdateUnitCategoryBrandItemDocument = gql`
	mutation UpdateUnitCategoryBrandItem($brandItemId: String!, $input: BrandItemInput!) {
		updateUnitCategoryBrandItem(brandItemId: $brandItemId, input: $input) {
			...UnitCategoryBrandItem
		}
	}
	${UnitCategoryBrandItemFragmentDoc}
`

export function useUpdateUnitCategoryBrandItemMutation() {
	return Urql.useMutation<UpdateUnitCategoryBrandItemMutation, UpdateUnitCategoryBrandItemMutationVariables>(UpdateUnitCategoryBrandItemDocument)
}
export const UpdateUnitCategoryLabelDocument = gql`
	mutation UpdateUnitCategoryLabel($unitCategoryId: String!, $label: LabelInput!) {
		updateUnitCategoryLabel(unitCategoryId: $unitCategoryId, label: $label) {
			errors {
				...FieldError
			}
			unitCategory {
				...UnitCategory
			}
		}
	}
	${FieldErrorFragmentDoc}
	${UnitCategoryFragmentDoc}
`

export function useUpdateUnitCategoryLabelMutation() {
	return Urql.useMutation<UpdateUnitCategoryLabelMutation, UpdateUnitCategoryLabelMutationVariables>(UpdateUnitCategoryLabelDocument)
}
export const UpdateUnitCategoryMaterialItemDocument = gql`
	mutation UpdateUnitCategoryMaterialItem($materialItemId: String!, $input: MaterialItemInput!) {
		updateUnitCategoryMaterialItem(materialItemId: $materialItemId, input: $input) {
			...UnitCategoryMaterialItem
		}
	}
	${UnitCategoryMaterialItemFragmentDoc}
`

export function useUpdateUnitCategoryMaterialItemMutation() {
	return Urql.useMutation<UpdateUnitCategoryMaterialItemMutation, UpdateUnitCategoryMaterialItemMutationVariables>(UpdateUnitCategoryMaterialItemDocument)
}
export const UpdateUnitGroupLabelDocument = gql`
	mutation UpdateUnitGroupLabel($unitGroupId: String!, $label: LabelInput!) {
		updateUnitGroupLabel(unitGroupId: $unitGroupId, label: $label) {
			errors {
				...FieldError
			}
			unitGroup {
				...UnitGroup
			}
		}
	}
	${FieldErrorFragmentDoc}
	${UnitGroupFragmentDoc}
`

export function useUpdateUnitGroupLabelMutation() {
	return Urql.useMutation<UpdateUnitGroupLabelMutation, UpdateUnitGroupLabelMutationVariables>(UpdateUnitGroupLabelDocument)
}
export const UpdateWorkInProgressItemDocument = gql`
	mutation UpdateWorkInProgressItem($inspectionId: String!, $itemId: String!, $input: UpdateWorkInProgressItemInput!) {
		updateWorkInProgressItem(inspectionId: $inspectionId, itemId: $itemId, input: $input) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useUpdateWorkInProgressItemMutation() {
	return Urql.useMutation<UpdateWorkInProgressItemMutation, UpdateWorkInProgressItemMutationVariables>(UpdateWorkInProgressItemDocument)
}
export const VerifySigninWithEmailTokenDocument = gql`
	mutation VerifySigninWithEmailToken($emailAddress: String!, $token: String!) {
		verifySigninWithEmailToken(emailAddress: $emailAddress, token: $token)
	}
`

export function useVerifySigninWithEmailTokenMutation() {
	return Urql.useMutation<VerifySigninWithEmailTokenMutation, VerifySigninWithEmailTokenMutationVariables>(VerifySigninWithEmailTokenDocument)
}
export const AdminsDocument = gql`
	query Admins {
		admins {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useAdminsQuery(options?: Omit<Urql.UseQueryArgs<AdminsQueryVariables>, "query">) {
	return Urql.useQuery<AdminsQuery, AdminsQueryVariables>({ query: AdminsDocument, ...options })
}
export const AllBuildersDocument = gql`
	query AllBuilders {
		allBuilders {
			...Builder
		}
	}
	${BuilderFragmentDoc}
`

export function useAllBuildersQuery(options?: Omit<Urql.UseQueryArgs<AllBuildersQueryVariables>, "query">) {
	return Urql.useQuery<AllBuildersQuery, AllBuildersQueryVariables>({ query: AllBuildersDocument, ...options })
}
export const BlockByIdDocument = gql`
	query BlockById($blockId: String!) {
		blockById(blockId: $blockId) {
			...Block
		}
	}
	${BlockFragmentDoc}
`

export function useBlockByIdQuery(options: Omit<Urql.UseQueryArgs<BlockByIdQueryVariables>, "query">) {
	return Urql.useQuery<BlockByIdQuery, BlockByIdQueryVariables>({ query: BlockByIdDocument, ...options })
}
export const BlocksOfProjectDocument = gql`
	query BlocksOfProject($projectId: String!) {
		blocksOfProject(projectId: $projectId) {
			...Block
		}
	}
	${BlockFragmentDoc}
`

export function useBlocksOfProjectQuery(options: Omit<Urql.UseQueryArgs<BlocksOfProjectQueryVariables>, "query">) {
	return Urql.useQuery<BlocksOfProjectQuery, BlocksOfProjectQueryVariables>({ query: BlocksOfProjectDocument, ...options })
}
export const BrandItemByIdDocument = gql`
	query BrandItemById($brandItemId: String!) {
		brandItemById(brandItemId: $brandItemId) {
			...BrandItem
		}
	}
	${BrandItemFragmentDoc}
`

export function useBrandItemByIdQuery(options: Omit<Urql.UseQueryArgs<BrandItemByIdQueryVariables>, "query">) {
	return Urql.useQuery<BrandItemByIdQuery, BrandItemByIdQueryVariables>({ query: BrandItemByIdDocument, ...options })
}
export const BrandItemsOfInspectionDocument = gql`
	query BrandItemsOfInspection($inspectionId: String!, $areaId: String) {
		brandItemsOfInspection(inspectionId: $inspectionId, areaId: $areaId) {
			...BrandItem
		}
	}
	${BrandItemFragmentDoc}
`

export function useBrandItemsOfInspectionQuery(options: Omit<Urql.UseQueryArgs<BrandItemsOfInspectionQueryVariables>, "query">) {
	return Urql.useQuery<BrandItemsOfInspectionQuery, BrandItemsOfInspectionQueryVariables>({ query: BrandItemsOfInspectionDocument, ...options })
}
export const BuilderAdminsDocument = gql`
	query BuilderAdmins($builderId: String!) {
		builderAdmins(builderId: $builderId) {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useBuilderAdminsQuery(options: Omit<Urql.UseQueryArgs<BuilderAdminsQueryVariables>, "query">) {
	return Urql.useQuery<BuilderAdminsQuery, BuilderAdminsQueryVariables>({ query: BuilderAdminsDocument, ...options })
}
export const BuilderAdminsOfBuilderDocument = gql`
	query BuilderAdminsOfBuilder($builderId: String!) {
		builderAdminsOfBuilder(builderId: $builderId) {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useBuilderAdminsOfBuilderQuery(options: Omit<Urql.UseQueryArgs<BuilderAdminsOfBuilderQueryVariables>, "query">) {
	return Urql.useQuery<BuilderAdminsOfBuilderQuery, BuilderAdminsOfBuilderQueryVariables>({ query: BuilderAdminsOfBuilderDocument, ...options })
}
export const BuilderAndStatusWiseInspectionStatsDocument = gql`
	query BuilderAndStatusWiseInspectionStats {
		builderAndStatusWiseInspectionStats {
			...StatusWiseInspectionsStats
		}
	}
	${StatusWiseInspectionsStatsFragmentDoc}
`

export function useBuilderAndStatusWiseInspectionStatsQuery(options?: Omit<Urql.UseQueryArgs<BuilderAndStatusWiseInspectionStatsQueryVariables>, "query">) {
	return Urql.useQuery<BuilderAndStatusWiseInspectionStatsQuery, BuilderAndStatusWiseInspectionStatsQueryVariables>({ query: BuilderAndStatusWiseInspectionStatsDocument, ...options })
}
export const BuilderByIdDocument = gql`
	query BuilderById($builderId: String!) {
		builderById(builderId: $builderId) {
			...Builder
		}
	}
	${BuilderFragmentDoc}
`

export function useBuilderByIdQuery(options: Omit<Urql.UseQueryArgs<BuilderByIdQueryVariables>, "query">) {
	return Urql.useQuery<BuilderByIdQuery, BuilderByIdQueryVariables>({ query: BuilderByIdDocument, ...options })
}
export const ClusterByIdDocument = gql`
	query ClusterById($clusterId: String!) {
		clusterById(clusterId: $clusterId) {
			...Cluster
		}
	}
	${ClusterFragmentDoc}
`

export function useClusterByIdQuery(options: Omit<Urql.UseQueryArgs<ClusterByIdQueryVariables>, "query">) {
	return Urql.useQuery<ClusterByIdQuery, ClusterByIdQueryVariables>({ query: ClusterByIdDocument, ...options })
}
export const ClustersOfProjectDocument = gql`
	query ClustersOfProject($projectId: String!) {
		clustersOfProject(projectId: $projectId) {
			...Cluster
		}
	}
	${ClusterFragmentDoc}
`

export function useClustersOfProjectQuery(options: Omit<Urql.UseQueryArgs<ClustersOfProjectQueryVariables>, "query">) {
	return Urql.useQuery<ClustersOfProjectQuery, ClustersOfProjectQueryVariables>({ query: ClustersOfProjectDocument, ...options })
}
export const ContractorsDocument = gql`
	query Contractors($builderId: String!, $element: Elements) {
		contractors(builderId: $builderId, element: $element) {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useContractorsQuery(options: Omit<Urql.UseQueryArgs<ContractorsQueryVariables>, "query">) {
	return Urql.useQuery<ContractorsQuery, ContractorsQueryVariables>({ query: ContractorsDocument, ...options })
}
export const ContractorsByRectificationIdDocument = gql`
	query ContractorsByRectificationId($rectificationId: String!) {
		contractorsByRectificationId(rectificationId: $rectificationId) {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useContractorsByRectificationIdQuery(options: Omit<Urql.UseQueryArgs<ContractorsByRectificationIdQueryVariables>, "query">) {
	return Urql.useQuery<ContractorsByRectificationIdQuery, ContractorsByRectificationIdQueryVariables>({ query: ContractorsByRectificationIdDocument, ...options })
}
export const ElementAndSeverityWiseIssuesStatsDocument = gql`
	query ElementAndSeverityWiseIssuesStats {
		elementAndSeverityWiseIssuesStats {
			...ElementAndSeverityWiseIssuesStats
		}
	}
	${ElementAndSeverityWiseIssuesStatsFragmentDoc}
`

export function useElementAndSeverityWiseIssuesStatsQuery(options?: Omit<Urql.UseQueryArgs<ElementAndSeverityWiseIssuesStatsQueryVariables>, "query">) {
	return Urql.useQuery<ElementAndSeverityWiseIssuesStatsQuery, ElementAndSeverityWiseIssuesStatsQueryVariables>({ query: ElementAndSeverityWiseIssuesStatsDocument, ...options })
}
export const ElementsOfRectificationDocument = gql`
	query ElementsOfRectification($rectificationId: String!) {
		elementsOfRectification(rectificationId: $rectificationId) {
			...ElementWiseRectification
		}
	}
	${ElementWiseRectificationFragmentDoc}
`

export function useElementsOfRectificationQuery(options: Omit<Urql.UseQueryArgs<ElementsOfRectificationQueryVariables>, "query">) {
	return Urql.useQuery<ElementsOfRectificationQuery, ElementsOfRectificationQueryVariables>({ query: ElementsOfRectificationDocument, ...options })
}
export const InspectionByIdDocument = gql`
	query InspectionById($inspectionId: String!) {
		inspectionById(inspectionId: $inspectionId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useInspectionByIdQuery(options: Omit<Urql.UseQueryArgs<InspectionByIdQueryVariables>, "query">) {
	return Urql.useQuery<InspectionByIdQuery, InspectionByIdQueryVariables>({ query: InspectionByIdDocument, ...options })
}
export const InspectionsDocument = gql`
	query Inspections($unitId: String, $builderId: String, $projectId: String, $status: InspectionStatus, $type: InspectionTypes, $since: DateTime, $until: DateTime, $pagination: PaginatedInput!) {
		inspections(unitId: $unitId, builderId: $builderId, projectId: $projectId, status: $status, type: $type, since: $since, until: $until, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			inspections {
				...Inspection
			}
		}
	}
	${InspectionFragmentDoc}
`

export function useInspectionsQuery(options: Omit<Urql.UseQueryArgs<InspectionsQueryVariables>, "query">) {
	return Urql.useQuery<InspectionsQuery, InspectionsQueryVariables>({ query: InspectionsDocument, ...options })
}
export const InspectionsWithoutPaginationDocument = gql`
	query InspectionsWithoutPagination($builderId: String, $status: InspectionStatus, $type: InspectionTypes, $since: DateTime, $until: DateTime) {
		inspectionsWithoutPagination(builderId: $builderId, type: $type, status: $status, since: $since, until: $until) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useInspectionsWithoutPaginationQuery(options?: Omit<Urql.UseQueryArgs<InspectionsWithoutPaginationQueryVariables>, "query">) {
	return Urql.useQuery<InspectionsWithoutPaginationQuery, InspectionsWithoutPaginationQueryVariables>({ query: InspectionsWithoutPaginationDocument, ...options })
}
export const InspectorsDocument = gql`
	query Inspectors {
		inspectors {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useInspectorsQuery(options?: Omit<Urql.UseQueryArgs<InspectorsQueryVariables>, "query">) {
	return Urql.useQuery<InspectorsQuery, InspectorsQueryVariables>({ query: InspectorsDocument, ...options })
}
export const IssueItemsDocument = gql`
	query IssueItems {
		issueItems {
			...IssueItem
		}
	}
	${IssueItemFragmentDoc}
`

export function useIssueItemsQuery(options?: Omit<Urql.UseQueryArgs<IssueItemsQueryVariables>, "query">) {
	return Urql.useQuery<IssueItemsQuery, IssueItemsQueryVariables>({ query: IssueItemsDocument, ...options })
}
export const IssueTemplatesDocument = gql`
	query IssueTemplates($element: Elements!, $areaType: AreaTypes!, $pagination: PaginatedInput!) {
		issueTemplates(element: $element, areaType: $areaType, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			issueTemplates {
				...IssueTemplate
			}
		}
	}
	${IssueTemplateFragmentDoc}
`

export function useIssueTemplatesQuery(options: Omit<Urql.UseQueryArgs<IssueTemplatesQueryVariables>, "query">) {
	return Urql.useQuery<IssueTemplatesQuery, IssueTemplatesQueryVariables>({ query: IssueTemplatesDocument, ...options })
}
export const LatestInspectionOfUnitDocument = gql`
	query LatestInspectionOfUnit($unitId: String!) {
		latestInspectionOfUnit(unitId: $unitId) {
			...Inspection
		}
	}
	${InspectionFragmentDoc}
`

export function useLatestInspectionOfUnitQuery(options: Omit<Urql.UseQueryArgs<LatestInspectionOfUnitQueryVariables>, "query">) {
	return Urql.useQuery<LatestInspectionOfUnitQuery, LatestInspectionOfUnitQueryVariables>({ query: LatestInspectionOfUnitDocument, ...options })
}
export const LayoutOfBlockDocument = gql`
	query LayoutOfBlock($blockId: String!) {
		layoutOfBlock(blockId: $blockId) {
			...BlockLayout
		}
	}
	${BlockLayoutFragmentDoc}
`

export function useLayoutOfBlockQuery(options: Omit<Urql.UseQueryArgs<LayoutOfBlockQueryVariables>, "query">) {
	return Urql.useQuery<LayoutOfBlockQuery, LayoutOfBlockQueryVariables>({ query: LayoutOfBlockDocument, ...options })
}
export const LinkedContractorsOfBuilderDocument = gql`
	query LinkedContractorsOfBuilder($builderId: String!) {
		linkedContractorsOfBuilder(builderId: $builderId) {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useLinkedContractorsOfBuilderQuery(options: Omit<Urql.UseQueryArgs<LinkedContractorsOfBuilderQueryVariables>, "query">) {
	return Urql.useQuery<LinkedContractorsOfBuilderQuery, LinkedContractorsOfBuilderQueryVariables>({ query: LinkedContractorsOfBuilderDocument, ...options })
}
export const MaterialItemByIdDocument = gql`
	query MaterialItemById($materialItemId: String!) {
		materialItemById(materialItemId: $materialItemId) {
			...MaterialItem
		}
	}
	${MaterialItemFragmentDoc}
`

export function useMaterialItemByIdQuery(options: Omit<Urql.UseQueryArgs<MaterialItemByIdQueryVariables>, "query">) {
	return Urql.useQuery<MaterialItemByIdQuery, MaterialItemByIdQueryVariables>({ query: MaterialItemByIdDocument, ...options })
}
export const MaterialItemsOfInspectionDocument = gql`
	query MaterialItemsOfInspection($inspectionId: String!, $areaId: String) {
		materialItemsOfInspection(inspectionId: $inspectionId, areaId: $areaId) {
			...MaterialItem
		}
	}
	${MaterialItemFragmentDoc}
`

export function useMaterialItemsOfInspectionQuery(options: Omit<Urql.UseQueryArgs<MaterialItemsOfInspectionQueryVariables>, "query">) {
	return Urql.useQuery<MaterialItemsOfInspectionQuery, MaterialItemsOfInspectionQueryVariables>({ query: MaterialItemsOfInspectionDocument, ...options })
}
export const MeDocument = gql`
	query Me {
		me {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useMeQuery(options?: Omit<Urql.UseQueryArgs<MeQueryVariables>, "query">) {
	return Urql.useQuery<MeQuery, MeQueryVariables>({ query: MeDocument, ...options })
}
export const ProjectAndSeverityWiseIssuesStatsDocument = gql`
	query ProjectAndSeverityWiseIssuesStats {
		projectAndSeverityWiseIssuesStats {
			...ProjectAndSeverityWiseIssuesStats
		}
	}
	${ProjectAndSeverityWiseIssuesStatsFragmentDoc}
`

export function useProjectAndSeverityWiseIssuesStatsQuery(options?: Omit<Urql.UseQueryArgs<ProjectAndSeverityWiseIssuesStatsQueryVariables>, "query">) {
	return Urql.useQuery<ProjectAndSeverityWiseIssuesStatsQuery, ProjectAndSeverityWiseIssuesStatsQueryVariables>({ query: ProjectAndSeverityWiseIssuesStatsDocument, ...options })
}
export const ProjectAndStatusWiseInspectionStatsDocument = gql`
	query ProjectAndStatusWiseInspectionStats {
		projectAndStatusWiseInspectionStats {
			...ProjectAndStatusWiseInspectionsStats
		}
	}
	${ProjectAndStatusWiseInspectionsStatsFragmentDoc}
`

export function useProjectAndStatusWiseInspectionStatsQuery(options?: Omit<Urql.UseQueryArgs<ProjectAndStatusWiseInspectionStatsQueryVariables>, "query">) {
	return Urql.useQuery<ProjectAndStatusWiseInspectionStatsQuery, ProjectAndStatusWiseInspectionStatsQueryVariables>({ query: ProjectAndStatusWiseInspectionStatsDocument, ...options })
}
export const ProjectByIdDocument = gql`
	query ProjectById($projectId: String!) {
		projectById(projectId: $projectId) {
			...Project
		}
	}
	${ProjectFragmentDoc}
`

export function useProjectByIdQuery(options: Omit<Urql.UseQueryArgs<ProjectByIdQueryVariables>, "query">) {
	return Urql.useQuery<ProjectByIdQuery, ProjectByIdQueryVariables>({ query: ProjectByIdDocument, ...options })
}
export const ProjectHeadsOfProjectDocument = gql`
	query ProjectHeadsOfProject($projectId: String!) {
		projectHeadsOfProject(projectId: $projectId) {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useProjectHeadsOfProjectQuery(options: Omit<Urql.UseQueryArgs<ProjectHeadsOfProjectQueryVariables>, "query">) {
	return Urql.useQuery<ProjectHeadsOfProjectQuery, ProjectHeadsOfProjectQueryVariables>({ query: ProjectHeadsOfProjectDocument, ...options })
}
export const QualityHeadsOfProjectDocument = gql`
	query QualityHeadsOfProject($projectId: String!) {
		qualityHeadsOfProject(projectId: $projectId) {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useQualityHeadsOfProjectQuery(options: Omit<Urql.UseQueryArgs<QualityHeadsOfProjectQueryVariables>, "query">) {
	return Urql.useQuery<QualityHeadsOfProjectQuery, QualityHeadsOfProjectQueryVariables>({ query: QualityHeadsOfProjectDocument, ...options })
}
export const RectificationByIdDocument = gql`
	query RectificationById($rectificationId: String!) {
		rectificationById(rectificationId: $rectificationId) {
			...Rectification
		}
	}
	${RectificationFragmentDoc}
`

export function useRectificationByIdQuery(options: Omit<Urql.UseQueryArgs<RectificationByIdQueryVariables>, "query">) {
	return Urql.useQuery<RectificationByIdQuery, RectificationByIdQueryVariables>({ query: RectificationByIdDocument, ...options })
}
export const RectificationsDocument = gql`
	query Rectifications($unitId: String, $builderId: String, $projectId: String, $status: RectificationStatus, $since: DateTime, $until: DateTime, $pagination: PaginatedInput!) {
		rectifications(unitId: $unitId, builderId: $builderId, projectId: $projectId, status: $status, since: $since, until: $until, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			rectifications {
				...Rectification
			}
		}
	}
	${RectificationFragmentDoc}
`

export function useRectificationsQuery(options: Omit<Urql.UseQueryArgs<RectificationsQueryVariables>, "query">) {
	return Urql.useQuery<RectificationsQuery, RectificationsQueryVariables>({ query: RectificationsDocument, ...options })
}
export const ReportByInspectionIdDocument = gql`
	query ReportByInspectionId($inspectionId: String!) {
		reportByInspectionId(inspectionId: $inspectionId) {
			...Report
		}
	}
	${ReportFragmentDoc}
`

export function useReportByInspectionIdQuery(options: Omit<Urql.UseQueryArgs<ReportByInspectionIdQueryVariables>, "query">) {
	return Urql.useQuery<ReportByInspectionIdQuery, ReportByInspectionIdQueryVariables>({ query: ReportByInspectionIdDocument, ...options })
}
export const ReportByPublicIdDocument = gql`
	query ReportByPublicId($reportPublicId: String!) {
		reportByPublicId(reportPublicId: $reportPublicId) {
			...Report
		}
	}
	${ReportFragmentDoc}
`

export function useReportByPublicIdQuery(options: Omit<Urql.UseQueryArgs<ReportByPublicIdQueryVariables>, "query">) {
	return Urql.useQuery<ReportByPublicIdQuery, ReportByPublicIdQueryVariables>({ query: ReportByPublicIdDocument, ...options })
}
export const SearchAdminsDocument = gql`
	query SearchAdmins($keyword: String!, $pagination: PaginatedInput!) {
		searchAdmins(keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			users {
				...User
			}
		}
	}
	${UserFragmentDoc}
`

export function useSearchAdminsQuery(options: Omit<Urql.UseQueryArgs<SearchAdminsQueryVariables>, "query">) {
	return Urql.useQuery<SearchAdminsQuery, SearchAdminsQueryVariables>({ query: SearchAdminsDocument, ...options })
}
export const SearchBlocksOfClusterDocument = gql`
	query SearchBlocksOfCluster($clusterId: String!, $keyword: String!, $pagination: PaginatedInput!) {
		searchBlocksOfCluster(clusterId: $clusterId, keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			blocks {
				...Block
			}
		}
	}
	${BlockFragmentDoc}
`

export function useSearchBlocksOfClusterQuery(options: Omit<Urql.UseQueryArgs<SearchBlocksOfClusterQueryVariables>, "query">) {
	return Urql.useQuery<SearchBlocksOfClusterQuery, SearchBlocksOfClusterQueryVariables>({ query: SearchBlocksOfClusterDocument, ...options })
}
export const SearchBrandItemsOfUnitDocument = gql`
	query SearchBrandItemsOfUnit($unitId: String!, $areaId: String, $keyword: String!, $pagination: PaginatedInput!) {
		searchBrandItemsOfUnit(unitId: $unitId, areaId: $areaId, keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			brandItems {
				...BrandItem
			}
		}
	}
	${BrandItemFragmentDoc}
`

export function useSearchBrandItemsOfUnitQuery(options: Omit<Urql.UseQueryArgs<SearchBrandItemsOfUnitQueryVariables>, "query">) {
	return Urql.useQuery<SearchBrandItemsOfUnitQuery, SearchBrandItemsOfUnitQueryVariables>({ query: SearchBrandItemsOfUnitDocument, ...options })
}
export const SearchBrandItemsOfUnitCategoryDocument = gql`
	query SearchBrandItemsOfUnitCategory($unitCategoryId: String!, $keyword: String!, $pagination: PaginatedInput!, $areaId: String) {
		searchBrandItemsOfUnitCategory(unitCategoryId: $unitCategoryId, keyword: $keyword, pagination: $pagination, areaId: $areaId) {
			hasPrevPage
			hasNextPage
			currentPage
			brandItems {
				...UnitCategoryBrandItem
			}
		}
	}
	${UnitCategoryBrandItemFragmentDoc}
`

export function useSearchBrandItemsOfUnitCategoryQuery(options: Omit<Urql.UseQueryArgs<SearchBrandItemsOfUnitCategoryQueryVariables>, "query">) {
	return Urql.useQuery<SearchBrandItemsOfUnitCategoryQuery, SearchBrandItemsOfUnitCategoryQueryVariables>({ query: SearchBrandItemsOfUnitCategoryDocument, ...options })
}
export const SearchBuilderAdminsDocument = gql`
	query SearchBuilderAdmins($builderId: String!, $keyword: String!, $pagination: PaginatedInput!) {
		searchBuilderAdmins(builderId: $builderId, keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			users {
				...User
			}
		}
	}
	${UserFragmentDoc}
`

export function useSearchBuilderAdminsQuery(options: Omit<Urql.UseQueryArgs<SearchBuilderAdminsQueryVariables>, "query">) {
	return Urql.useQuery<SearchBuilderAdminsQuery, SearchBuilderAdminsQueryVariables>({ query: SearchBuilderAdminsDocument, ...options })
}
export const SearchBuildersDocument = gql`
	query SearchBuilders($keyword: String!, $pagination: PaginatedInput!) {
		searchBuilders(keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			builders {
				...Builder
			}
		}
	}
	${BuilderFragmentDoc}
`

export function useSearchBuildersQuery(options: Omit<Urql.UseQueryArgs<SearchBuildersQueryVariables>, "query">) {
	return Urql.useQuery<SearchBuildersQuery, SearchBuildersQueryVariables>({ query: SearchBuildersDocument, ...options })
}
export const SearchClustersOfProjectDocument = gql`
	query SearchClustersOfProject($projectId: String!, $keyword: String!, $pagination: PaginatedInput!) {
		searchClustersOfProject(projectId: $projectId, keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			clusters {
				...Cluster
			}
		}
	}
	${ClusterFragmentDoc}
`

export function useSearchClustersOfProjectQuery(options: Omit<Urql.UseQueryArgs<SearchClustersOfProjectQueryVariables>, "query">) {
	return Urql.useQuery<SearchClustersOfProjectQuery, SearchClustersOfProjectQueryVariables>({ query: SearchClustersOfProjectDocument, ...options })
}
export const SearchContractorsDocument = gql`
	query SearchContractors($keyword: String!, $pagination: PaginatedInput!, $element: Elements) {
		searchContractors(keyword: $keyword, pagination: $pagination, element: $element) {
			hasPrevPage
			hasNextPage
			currentPage
			users {
				...User
			}
		}
	}
	${UserFragmentDoc}
`

export function useSearchContractorsQuery(options: Omit<Urql.UseQueryArgs<SearchContractorsQueryVariables>, "query">) {
	return Urql.useQuery<SearchContractorsQuery, SearchContractorsQueryVariables>({ query: SearchContractorsDocument, ...options })
}
export const SearchInspectorsDocument = gql`
	query SearchInspectors($keyword: String!, $pagination: PaginatedInput!) {
		searchInspectors(keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			users {
				...User
			}
		}
	}
	${UserFragmentDoc}
`

export function useSearchInspectorsQuery(options: Omit<Urql.UseQueryArgs<SearchInspectorsQueryVariables>, "query">) {
	return Urql.useQuery<SearchInspectorsQuery, SearchInspectorsQueryVariables>({ query: SearchInspectorsDocument, ...options })
}
export const SearchMaterialItemsOfUnitDocument = gql`
	query SearchMaterialItemsOfUnit($unitId: String!, $areaId: String, $keyword: String!, $pagination: PaginatedInput!) {
		searchMaterialItemsOfUnit(unitId: $unitId, areaId: $areaId, keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			materialItems {
				...MaterialItem
			}
		}
	}
	${MaterialItemFragmentDoc}
`

export function useSearchMaterialItemsOfUnitQuery(options: Omit<Urql.UseQueryArgs<SearchMaterialItemsOfUnitQueryVariables>, "query">) {
	return Urql.useQuery<SearchMaterialItemsOfUnitQuery, SearchMaterialItemsOfUnitQueryVariables>({ query: SearchMaterialItemsOfUnitDocument, ...options })
}
export const SearchMaterialItemsOfUnitCategoryDocument = gql`
	query SearchMaterialItemsOfUnitCategory($unitCategoryId: String!, $keyword: String!, $pagination: PaginatedInput!, $areaId: String) {
		searchMaterialItemsOfUnitCategory(unitCategoryId: $unitCategoryId, keyword: $keyword, pagination: $pagination, areaId: $areaId) {
			hasPrevPage
			hasNextPage
			currentPage
			materialItems {
				...UnitCategoryMaterialItem
			}
		}
	}
	${UnitCategoryMaterialItemFragmentDoc}
`

export function useSearchMaterialItemsOfUnitCategoryQuery(options: Omit<Urql.UseQueryArgs<SearchMaterialItemsOfUnitCategoryQueryVariables>, "query">) {
	return Urql.useQuery<SearchMaterialItemsOfUnitCategoryQuery, SearchMaterialItemsOfUnitCategoryQueryVariables>({ query: SearchMaterialItemsOfUnitCategoryDocument, ...options })
}
export const SearchProjectsOfBuilderDocument = gql`
	query SearchProjectsOfBuilder($builderId: String!, $keyword: String!, $pagination: PaginatedInput!) {
		searchProjectsOfBuilder(builderId: $builderId, keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			projects {
				...Project
			}
		}
	}
	${ProjectFragmentDoc}
`

export function useSearchProjectsOfBuilderQuery(options: Omit<Urql.UseQueryArgs<SearchProjectsOfBuilderQueryVariables>, "query">) {
	return Urql.useQuery<SearchProjectsOfBuilderQuery, SearchProjectsOfBuilderQueryVariables>({ query: SearchProjectsOfBuilderDocument, ...options })
}
export const SearchReportsDocument = gql`
	query SearchReports($keyword: String, $pagination: PaginatedInput!, $inspectorId: String, $since: DateTime, $until: DateTime, $builderId: String, $type: ReportTypes) {
		searchReports(keyword: $keyword, pagination: $pagination, inspectorId: $inspectorId, since: $since, until: $until, builderId: $builderId, type: $type) {
			hasPrevPage
			hasNextPage
			currentPage
			reports {
				...Report
			}
		}
	}
	${ReportFragmentDoc}
`

export function useSearchReportsQuery(options: Omit<Urql.UseQueryArgs<SearchReportsQueryVariables>, "query">) {
	return Urql.useQuery<SearchReportsQuery, SearchReportsQueryVariables>({ query: SearchReportsDocument, ...options })
}
export const SearchUnitCategoriesOfProjectDocument = gql`
	query SearchUnitCategoriesOfProject($projectId: String!, $keyword: String!, $pagination: PaginatedInput!) {
		searchUnitCategoriesOfProject(projectId: $projectId, keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			unitCategories {
				...UnitCategory
			}
		}
	}
	${UnitCategoryFragmentDoc}
`

export function useSearchUnitCategoriesOfProjectQuery(options: Omit<Urql.UseQueryArgs<SearchUnitCategoriesOfProjectQueryVariables>, "query">) {
	return Urql.useQuery<SearchUnitCategoriesOfProjectQuery, SearchUnitCategoriesOfProjectQueryVariables>({ query: SearchUnitCategoriesOfProjectDocument, ...options })
}
export const SearchUnitGroupsOfProjectDocument = gql`
	query SearchUnitGroupsOfProject($projectId: String!, $keyword: String!, $pagination: PaginatedInput!) {
		searchUnitGroupsOfProject(projectId: $projectId, keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			unitGroups {
				...UnitGroup
			}
		}
	}
	${UnitGroupFragmentDoc}
`

export function useSearchUnitGroupsOfProjectQuery(options: Omit<Urql.UseQueryArgs<SearchUnitGroupsOfProjectQueryVariables>, "query">) {
	return Urql.useQuery<SearchUnitGroupsOfProjectQuery, SearchUnitGroupsOfProjectQueryVariables>({ query: SearchUnitGroupsOfProjectDocument, ...options })
}
export const SearchUnitsOfBlockDocument = gql`
	query SearchUnitsOfBlock($blockId: String!, $keyword: String!, $pagination: PaginatedInput!) {
		searchUnitsOfBlock(blockId: $blockId, keyword: $keyword, pagination: $pagination) {
			hasPrevPage
			hasNextPage
			currentPage
			units {
				...Unit
			}
		}
	}
	${UnitFragmentDoc}
`

export function useSearchUnitsOfBlockQuery(options: Omit<Urql.UseQueryArgs<SearchUnitsOfBlockQueryVariables>, "query">) {
	return Urql.useQuery<SearchUnitsOfBlockQuery, SearchUnitsOfBlockQueryVariables>({ query: SearchUnitsOfBlockDocument, ...options })
}
export const StatusWiseInspectionStatsDocument = gql`
	query StatusWiseInspectionStats {
		statusWiseInspectionStats {
			...StatusWiseInspectionsStats
		}
	}
	${StatusWiseInspectionsStatsFragmentDoc}
`

export function useStatusWiseInspectionStatsQuery(options?: Omit<Urql.UseQueryArgs<StatusWiseInspectionStatsQueryVariables>, "query">) {
	return Urql.useQuery<StatusWiseInspectionStatsQuery, StatusWiseInspectionStatsQueryVariables>({ query: StatusWiseInspectionStatsDocument, ...options })
}
export const UnassignedBrandItemsOfUnitDocument = gql`
	query UnassignedBrandItemsOfUnit($unitId: String!) {
		unassignedBrandItemsOfUnit(unitId: $unitId) {
			...BrandItem
		}
	}
	${BrandItemFragmentDoc}
`

export function useUnassignedBrandItemsOfUnitQuery(options: Omit<Urql.UseQueryArgs<UnassignedBrandItemsOfUnitQueryVariables>, "query">) {
	return Urql.useQuery<UnassignedBrandItemsOfUnitQuery, UnassignedBrandItemsOfUnitQueryVariables>({ query: UnassignedBrandItemsOfUnitDocument, ...options })
}
export const UnassignedBrandItemsOfUnitCategoryDocument = gql`
	query UnassignedBrandItemsOfUnitCategory($unitCategoryId: String!) {
		unassignedBrandItemsOfUnitCategory(unitCategoryId: $unitCategoryId) {
			...UnitCategoryBrandItem
		}
	}
	${UnitCategoryBrandItemFragmentDoc}
`

export function useUnassignedBrandItemsOfUnitCategoryQuery(options: Omit<Urql.UseQueryArgs<UnassignedBrandItemsOfUnitCategoryQueryVariables>, "query">) {
	return Urql.useQuery<UnassignedBrandItemsOfUnitCategoryQuery, UnassignedBrandItemsOfUnitCategoryQueryVariables>({ query: UnassignedBrandItemsOfUnitCategoryDocument, ...options })
}
export const UnassignedMaterialItemsOfUnitDocument = gql`
	query UnassignedMaterialItemsOfUnit($unitId: String!) {
		unassignedMaterialItemsOfUnit(unitId: $unitId) {
			...MaterialItem
		}
	}
	${MaterialItemFragmentDoc}
`

export function useUnassignedMaterialItemsOfUnitQuery(options: Omit<Urql.UseQueryArgs<UnassignedMaterialItemsOfUnitQueryVariables>, "query">) {
	return Urql.useQuery<UnassignedMaterialItemsOfUnitQuery, UnassignedMaterialItemsOfUnitQueryVariables>({ query: UnassignedMaterialItemsOfUnitDocument, ...options })
}
export const UnassignedMaterialItemsOfUnitCategoryDocument = gql`
	query UnassignedMaterialItemsOfUnitCategory($unitCategoryId: String!) {
		unassignedMaterialItemsOfUnitCategory(unitCategoryId: $unitCategoryId) {
			...UnitCategoryMaterialItem
		}
	}
	${UnitCategoryMaterialItemFragmentDoc}
`

export function useUnassignedMaterialItemsOfUnitCategoryQuery(options: Omit<Urql.UseQueryArgs<UnassignedMaterialItemsOfUnitCategoryQueryVariables>, "query">) {
	return Urql.useQuery<UnassignedMaterialItemsOfUnitCategoryQuery, UnassignedMaterialItemsOfUnitCategoryQueryVariables>({ query: UnassignedMaterialItemsOfUnitCategoryDocument, ...options })
}
export const UniqueElementsOfUnitDocument = gql`
	query UniqueElementsOfUnit($unitId: String!) {
		uniqueElementsOfUnit(unitId: $unitId)
	}
`

export function useUniqueElementsOfUnitQuery(options: Omit<Urql.UseQueryArgs<UniqueElementsOfUnitQueryVariables>, "query">) {
	return Urql.useQuery<UniqueElementsOfUnitQuery, UniqueElementsOfUnitQueryVariables>({ query: UniqueElementsOfUnitDocument, ...options })
}
export const UnitByIdDocument = gql`
	query UnitById($unitId: String!) {
		unitById(unitId: $unitId) {
			...Unit
		}
	}
	${UnitFragmentDoc}
`

export function useUnitByIdQuery(options: Omit<Urql.UseQueryArgs<UnitByIdQueryVariables>, "query">) {
	return Urql.useQuery<UnitByIdQuery, UnitByIdQueryVariables>({ query: UnitByIdDocument, ...options })
}
export const UnitCategoriesOfProjectDocument = gql`
	query UnitCategoriesOfProject($projectId: String!) {
		unitCategoriesOfProject(projectId: $projectId) {
			...UnitCategory
		}
	}
	${UnitCategoryFragmentDoc}
`

export function useUnitCategoriesOfProjectQuery(options: Omit<Urql.UseQueryArgs<UnitCategoriesOfProjectQueryVariables>, "query">) {
	return Urql.useQuery<UnitCategoriesOfProjectQuery, UnitCategoriesOfProjectQueryVariables>({ query: UnitCategoriesOfProjectDocument, ...options })
}
export const UnitCategoryBrandItemByIdDocument = gql`
	query UnitCategoryBrandItemById($brandItemId: String!) {
		unitCategoryBrandItemById(brandItemId: $brandItemId) {
			...UnitCategoryBrandItem
		}
	}
	${UnitCategoryBrandItemFragmentDoc}
`

export function useUnitCategoryBrandItemByIdQuery(options: Omit<Urql.UseQueryArgs<UnitCategoryBrandItemByIdQueryVariables>, "query">) {
	return Urql.useQuery<UnitCategoryBrandItemByIdQuery, UnitCategoryBrandItemByIdQueryVariables>({ query: UnitCategoryBrandItemByIdDocument, ...options })
}
export const UnitCategoryByIdDocument = gql`
	query UnitCategoryById($unitCategoryId: String!) {
		unitCategoryById(unitCategoryId: $unitCategoryId) {
			...UnitCategory
		}
	}
	${UnitCategoryFragmentDoc}
`

export function useUnitCategoryByIdQuery(options: Omit<Urql.UseQueryArgs<UnitCategoryByIdQueryVariables>, "query">) {
	return Urql.useQuery<UnitCategoryByIdQuery, UnitCategoryByIdQueryVariables>({ query: UnitCategoryByIdDocument, ...options })
}
export const UnitCategoryMaterialItemByIdDocument = gql`
	query UnitCategoryMaterialItemById($materialItemId: String!) {
		unitCategoryMaterialItemById(materialItemId: $materialItemId) {
			...UnitCategoryMaterialItem
		}
	}
	${UnitCategoryMaterialItemFragmentDoc}
`

export function useUnitCategoryMaterialItemByIdQuery(options: Omit<Urql.UseQueryArgs<UnitCategoryMaterialItemByIdQueryVariables>, "query">) {
	return Urql.useQuery<UnitCategoryMaterialItemByIdQuery, UnitCategoryMaterialItemByIdQueryVariables>({ query: UnitCategoryMaterialItemByIdDocument, ...options })
}
export const UnitGroupByIdDocument = gql`
	query UnitGroupById($unitGroupId: String!) {
		unitGroupById(unitGroupId: $unitGroupId) {
			...UnitGroup
		}
	}
	${UnitGroupFragmentDoc}
`

export function useUnitGroupByIdQuery(options: Omit<Urql.UseQueryArgs<UnitGroupByIdQueryVariables>, "query">) {
	return Urql.useQuery<UnitGroupByIdQuery, UnitGroupByIdQueryVariables>({ query: UnitGroupByIdDocument, ...options })
}
export const UserByIdDocument = gql`
	query UserById($userId: String!) {
		userById(userId: $userId) {
			...User
		}
	}
	${UserFragmentDoc}
`

export function useUserByIdQuery(options: Omit<Urql.UseQueryArgs<UserByIdQueryVariables>, "query">) {
	return Urql.useQuery<UserByIdQuery, UserByIdQueryVariables>({ query: UserByIdDocument, ...options })
}
